// This is a generated file, do not edit.

export const graph = {
  "セ1-0": {
    "セ1": [1, 2],
  },
  "セ1-1": {
    "セ1": [6],
  },
  "セ1-2": {
    "セ1": [6],
  },
  "セ1-3": {
    "セ1": [4, 5],
  },
  "セ1-4": {
    "セ1": [7],
  },
  "セ1-5": {
    "セ1": [7],
  },
  "セ1-6": {
    "セ1": [3],
  },
  "セ1-7": {
    "セ1": [9],
  },
  "セ1-9": {
    "セ1": [11, 12, 13, 14],
  },
  "セ1-11": {
    "セ1": [15],
  },
  "セ1-12": {
    "セ1": [15],
  },
  "セ1-13": {
    "セ1": [15],
  },
  "セ1-14": {
    "セ1": [15],
  },
  "セ1-15": {
    "セ2": [0, 13],
  },
  "セ10-0": {
    "セ10": [9],
  },
  "セ10-1": {
    "セ10": [4],
  },
  "セ10-2": {
    "セ10": [1, 3],
  },
  "セ10-3": {
    "セ10": [10],
  },
  "セ10-4": {
    "セ10": [5, 6],
  },
  "セ10-5": {
    "セ10": [7],
  },
  "セ10-6": {
    "セ10": [7],
  },
  "セ10-7": {
    "セ11": [0],
  },
  "セ10-9": {
    "セ10": [2],
  },
  "セ11-0": {
    "セ11": [16],
  },
  "セ11-1": {
    "セ11": [20],
  },
  "セ11-2": {
    "セ11": [3, 4, 5],
  },
  "セ11-3": {
    "セ11": [17],
  },
  "セ11-4": {
    "セ11": [17],
  },
  "セ11-5": {
    "セ11": [17],
  },
  "セ11-6": {
    "セ11": [7, 8],
  },
  "セ11-7": {
    "セ11": [9],
  },
  "セ11-8": {
    "セ11": [9],
  },
  "セ11-9": {
    "セ11": [10, 11],
  },
  "セ11-10": {
    "セ11": [12],
  },
  "セ11-11": {
    "セ11": [12],
  },
  "セ11-12": {
    "セ11": [13, 14],
  },
  "セ11-13": {
    "セ11": [21],
  },
  "セ11-14": {
    "セ12": [13],
  },
  "セ11-16": {
    "セ11": [1, 2],
  },
  "セ11-17": {
    "セ11": [19],
  },
  "セ11-18": {
    "セ11": [6],
  },
  "セ11-19": {
    "セ11": [18, 118],
  },
  "セ11-118": {
    "セ11": [6],
  },
  "セ12-0": {
    "セ12": [1, 2],
  },
  "セ12-1": {
    "セ12": [3],
  },
  "セ12-2": {
    "セ12": [3],
  },
  "セ12-3": {
    "セ12": [4, 5, 6],
  },
  "セ12-4": {
    "セ12": [14],
  },
  "セ12-5": {
    "セ12": [14],
  },
  "セ12-6": {
    "セ12": [14],
  },
  "セ12-7": {
    "セ12": [8, 9, 10],
  },
  "セ12-8": {
    "セ12": [11],
  },
  "セ12-9": {
    "セ12": [11],
  },
  "セ12-10": {
    "セ12": [11],
  },
  "セ12-11": {
    "セ12": [12],
  },
  "セ12-12": {
    "セ12": [15],
  },
  "セ12-13": {
    "セ12": [0],
  },
  "セ12-14": {
    "セ12": [7],
  },
  "セ12-15": {
    "セ13": [3],
  },
  "セ13-0": {
    "セ13": [1, 2],
  },
  "セ13-1": {
    "セ13": [15],
  },
  "セ13-2": {
    "セ13": [4, 5],
  },
  "セ13-3": {
    "セ13": [12],
  },
  "セ13-4": {
    "セ13": [8, 9],
  },
  "セ13-5": {
    "セ13": [15],
  },
  "セ13-6": {
    "セ13": [13],
  },
  "セ13-7": {
    "セ13": [11],
  },
  "セ13-8": {
    "セ13": [16],
  },
  "セ13-9": {
    "セ13": [7],
  },
  "セ13-11": {
    "セ13": [14],
  },
  "セ13-12": {
    "セ13": [6],
  },
  "セ13-13": {
    "セ13": [0],
  },
  "セ13-14": {
    "セ14": [6],
  },
  "セ14-0": {
    "セ14": [2],
  },
  "セ14-2": {
    "セ14": [3, 4],
  },
  "セ14-3": {
    "セ14": [12],
  },
  "セ14-4": {
    "セ14": [11, 111],
  },
  "セ14-6": {
    "セ14": [8],
  },
  "セ14-7": {
    "セ14": [9],
  },
  "セ14-8": {
    "セ14": [7],
  },
  "セ14-9": {
    "セ14": [10],
  },
  "セ14-10": {
    "セ14": [0],
  },
  "セ14-11": {
    "セ15": [0],
  },
  "セ14-101": {
    "セ15": [0],
  },
  "セ14-111": {
    "セ14": [101],
  },
  "セ15-0": {
    "セ15": [1, 2],
  },
  "セ15-1": {
    "セ15": [23],
  },
  "セ15-2": {
    "セ15": [18],
  },
  "セ15-3": {
    "セ15": [24],
  },
  "セ15-4": {
    "セ15": [5, 6, 7],
  },
  "セ15-5": {
    "セ15": [12],
  },
  "セ15-6": {
    "セ15": [12],
  },
  "セ15-7": {
    "セ15": [8, 9, 10],
  },
  "セ15-8": {
    "セ15": [12],
  },
  "セ15-9": {
    "セ15": [12],
  },
  "セ15-10": {
    "セ15": [11],
  },
  "セ15-11": {
    "セ15": [13],
  },
  "セ15-12": {
    "セ15": [25],
  },
  "セ15-13": {
    "セ15": [17],
  },
  "セ15-14": {
    "セ15": [15, 16],
  },
  "セ15-15": {
    "セ15": [4],
  },
  "セ15-16": {
    "セ15": [4],
  },
  "セ15-18": {
    "セ15": [19],
  },
  "セ15-19": {
    "セ15": [20],
  },
  "セ15-20": {
    "セ15": [3, 21],
  },
  "セ15-21": {
    "セ15": [22],
  },
  "セ15-22": {
    "セ15": [14],
  },
  "セ2-0": {
    "セ2": [5, 6],
  },
  "セ2-1": {
    "セ3": [8],
  },
  "セ2-3": {
    "セ2": [7],
  },
  "セ2-4": {
    "セ2": [14],
  },
  "セ2-5": {
    "セ2": [15],
  },
  "セ2-6": {
    "セ2": [15],
  },
  "セ2-7": {
    "セ2": [9, 16],
  },
  "セ2-8": {
    "セ2": [1],
  },
  "セ2-9": {
    "セ2": [8, 10],
  },
  "セ2-10": {
    "セ2": [4],
  },
  "セ2-13": {
    "セ2": [3, 5, 6],
  },
  "セ2-14": {
    "セ3": [8],
  },
  "セ2-15": {
    "セ2": [7],
  },
  "セ2-16": {
    "セ2": [8],
  },
  "セ3-0": {
    "セ3": [17, 17, 17],
    "凛3": [9],
  },
  "セ3-1": {
    "セ3": [16],
  },
  "セ3-2": {
    "セ3": [4, 18],
  },
  "セ3-4": {
    "セ3": [11],
  },
  "セ3-5": {
    "セ3": [6, 7],
  },
  "セ3-6": {
    "セ3": [19],
  },
  "セ3-7": {
    "セ3": [12],
    "セ4": [0],
  },
  "セ3-8": {
    "セ3": [9, 10],
  },
  "セ3-9": {
    "セ3": [1],
  },
  "セ3-10": {
    "セ3": [1],
  },
  "セ3-12": {
    "桜4": [11],
  },
  "セ3-16": {
    "セ3": [0],
  },
  "セ3-17": {
    "セ3": [2],
  },
  "セ3-18": {
    "セ3": [5],
  },
  "セ4-0": {
    "セ4": [1, 2, 3],
  },
  "セ4-1": {
    "セ4": [4],
  },
  "セ4-2": {
    "セ4": [4],
  },
  "セ4-3": {
    "セ4": [4],
  },
  "セ4-4": {
    "セ4": [5, 18],
  },
  "セ4-5": {
    "凛4": [3],
  },
  "セ4-6": {
    "セ4": [7, 8, 9],
  },
  "セ4-7": {
    "セ4": [10],
  },
  "セ4-8": {
    "セ4": [11],
  },
  "セ4-9": {
    "セ4": [10],
  },
  "セ4-10": {
    "セ4": [11],
  },
  "セ4-11": {
    "セ4": [12],
  },
  "セ4-12": {
    "セ4": [15],
  },
  "セ4-15": {
    "セ5": [0],
  },
  "セ4-18": {
    "セ4": [6],
  },
  "セ5-0": {
    "セ5": [4],
  },
  "セ5-4": {
    "セ5": [5],
  },
  "セ5-5": {
    "セ5": [6, 7],
  },
  "セ5-6": {
    "セ5": [8],
  },
  "セ5-7": {
    "セ5": [8],
  },
  "セ5-8": {
    "セ5": [9, 10, 11],
  },
  "セ5-9": {
    "セ5": [12],
  },
  "セ5-10": {
    "セ5": [12],
  },
  "セ5-11": {
    "セ5": [12],
  },
  "セ5-12": {
    "セ5": [14],
  },
  "セ5-14": {
    "セ6": [12],
  },
  "セ6-0": {
    "セ6": [1],
  },
  "セ6-1": {
    "セ6": [3, 4],
  },
  "セ6-3": {
    "セ6": [13],
  },
  "セ6-4": {
    "セ6": [13],
  },
  "セ6-5": {
    "セ6": [6, 7],
  },
  "セ6-6": {
    "セ6": [15],
  },
  "セ6-7": {
    "セ6": [8],
  },
  "セ6-8": {
    "セ6": [9],
  },
  "セ6-9": {
    "セ6": [14],
  },
  "セ6-10": {
    "セ7": [0],
  },
  "セ6-12": {
    "セ6": [0],
  },
  "セ6-13": {
    "セ6": [5],
  },
  "セ6-14": {
    "セ6": [10],
  },
  "セ7-0": {
    "セ7": [2],
  },
  "セ7-1": {
    "セ7": [3],
  },
  "セ7-2": {
    "セ7": [4, 5, 6],
  },
  "セ7-3": {
    "セ7": [8],
  },
  "セ7-4": {
    "セ7": [7],
  },
  "セ7-5": {
    "セ7": [7],
  },
  "セ7-6": {
    "セ7": [7],
  },
  "セ7-7": {
    "セ7": [28],
  },
  "セ7-8": {
    "セ7": [12, 13, 14, 15, 16, 17],
  },
  "セ7-12": {
    "セ7": [18],
  },
  "セ7-13": {
    "セ7": [18],
  },
  "セ7-14": {
    "セ7": [18],
  },
  "セ7-15": {
    "セ7": [18],
  },
  "セ7-16": {
    "セ7": [18],
  },
  "セ7-17": {
    "セ7": [18],
  },
  "セ7-18": {
    "セ7": [19, 20],
  },
  "セ7-19": {
    "セ7": [29],
  },
  "セ7-20": {
    "セ7": [29],
  },
  "セ7-21": {
    "セ7": [22, 23, 24],
  },
  "セ7-22": {
    "セ7": [25],
  },
  "セ7-23": {
    "セ7": [25],
  },
  "セ7-24": {
    "セ7": [25],
  },
  "セ7-25": {
    "セ7": [27],
  },
  "セ7-27": {
    "セ9": [15],
  },
  "セ7-28": {
    "セ7": [1],
  },
  "セ7-29": {
    "セ7": [21],
  },
  "セ9-0": {
    "セ9": [1, 2],
  },
  "セ9-1": {
    "セ9": [3],
  },
  "セ9-2": {
    "セ9": [3],
  },
  "セ9-3": {
    "セ9": [4, 5],
  },
  "セ9-4": {
    "セ9": [6],
  },
  "セ9-5": {
    "セ9": [6],
  },
  "セ9-6": {
    "セ9": [7, 8],
  },
  "セ9-7": {
    "セ9": [16],
  },
  "セ9-8": {
    "セ9": [9, 10, 11],
  },
  "セ9-9": {
    "セ9": [12],
  },
  "セ9-10": {
    "セ9": [12],
  },
  "セ9-11": {
    "セ9": [17],
  },
  "セ9-12": {
    "セ9": [14],
  },
  "セ9-14": {
    "セ10": [0],
  },
  "セ9-15": {
    "セ9": [0],
  },
  "プ-1": {
    "プ": [2],
  },
  "プ-2": {
    "プ": [3],
  },
  "プ-3": {
    "セ1": [0],
  },
  "凛10-0": {
    "凛10": [1, 2, 3],
  },
  "凛10-1": {
    "凛10": [4],
  },
  "凛10-2": {
    "凛10": [4],
  },
  "凛10-3": {
    "凛10": [4],
  },
  "凛10-4": {
    "凛10": [8],
  },
  "凛10-6": {
    "凛10": [7],
  },
  "凛10-7": {
    "凛10": [0],
  },
  "凛10-8": {
    "凛11": [0],
  },
  "凛11-0": {
    "凛11": [1, 2],
  },
  "凛11-1": {
    "凛11": [3, 9],
  },
  "凛11-2": {
    "凛11": [10],
  },
  "凛11-3": {
    "凛11": [11],
  },
  "凛11-4": {
    "凛11": [8],
  },
  "凛11-5": {
    "凛11": [17],
  },
  "凛11-6": {
    "凛11": [12],
  },
  "凛11-8": {
    "凛11": [5, 6],
  },
  "凛11-9": {
    "凛11": [10],
  },
  "凛11-10": {
    "凛11": [11],
  },
  "凛11-11": {
    "凛11": [4],
  },
  "凛11-12": {
    "凛11": [15],
  },
  "凛11-13": {
    "凛11": [14],
  },
  "凛11-14": {
    "凛12": [14],
  },
  "凛11-15": {
    "凛11": [16],
  },
  "凛11-16": {
    "凛11": [13],
  },
  "凛12-0": {
    "凛12": [1, 3],
  },
  "凛12-1": {
    "凛12": [12],
  },
  "凛12-2": {
    "凛12": [16],
  },
  "凛12-3": {
    "凛12": [2, 10, 11],
  },
  "凛12-4": {
    "凛12": [5, 6],
  },
  "凛12-5": {
    "凛12": [17],
  },
  "凛12-6": {
    "凛12": [7, 8],
  },
  "凛12-7": {
    "凛12": [8],
  },
  "凛12-8": {
    "凛12": [13],
  },
  "凛12-10": {
    "凛12": [16],
  },
  "凛12-11": {
    "凛12": [16],
  },
  "凛12-12": {
    "凛12": [4],
  },
  "凛12-13": {
    "凛13": [11],
  },
  "凛12-14": {
    "凛12": [0, 15],
  },
  "凛12-15": {
    "凛12": [3],
  },
  "凛13-0": {
    "凛13": [1, 2, 3],
  },
  "凛13-1": {
    "凛13": [12],
  },
  "凛13-2": {
    "凛13": [12],
  },
  "凛13-3": {
    "凛13": [12],
  },
  "凛13-4": {
    "凛13": [6, 15],
  },
  "凛13-5": {
    "凛13": [7, 8, 9],
  },
  "凛13-6": {
    "凛13": [17],
  },
  "凛13-7": {
    "凛13": [20],
  },
  "凛13-8": {
    "凛13": [20],
  },
  "凛13-9": {
    "凛13": [19],
  },
  "凛13-11": {
    "凛13": [0],
  },
  "凛13-12": {
    "凛13": [13],
  },
  "凛13-13": {
    "凛13": [14],
  },
  "凛13-14": {
    "凛13": [21],
  },
  "凛13-15": {
    "凛13": [16],
  },
  "凛13-16": {
    "凛13": [17],
  },
  "凛13-17": {
    "凛13": [18, 19],
  },
  "凛13-18": {
    "凛13": [5],
  },
  "凛13-19": {
    "凛13": [22],
  },
  "凛13-20": {
    "凛14": [17],
  },
  "凛13-21": {
    "凛13": [4],
  },
  "凛14-0": {
    "凛14": [1, 2],
  },
  "凛14-1": {
    "凛14": [3],
  },
  "凛14-2": {
    "凛14": [3],
  },
  "凛14-3": {
    "凛14": [21],
  },
  "凛14-4": {
    "凛14": [5, 6, 7],
  },
  "凛14-5": {
    "凛14": [8, 108],
  },
  "凛14-6": {
    "凛14": [8, 108],
  },
  "凛14-7": {
    "凛14": [8, 108],
  },
  "凛14-8": {
    "凛14": [31],
  },
  "凛14-9": {
    "凛14": [10, 11],
  },
  "凛14-10": {
    "凛14": [12],
  },
  "凛14-11": {
    "凛14": [12],
  },
  "凛14-12": {
    "凛14": [13, 14],
  },
  "凛14-13": {
    "凛14": [37],
  },
  "凛14-14": {
    "凛14": [15, 16],
  },
  "凛14-17": {
    "凛14": [18],
  },
  "凛14-18": {
    "凛14": [19],
  },
  "凛14-19": {
    "凛14": [20],
  },
  "凛14-20": {
    "凛14": [0],
  },
  "凛14-21": {
    "凛14": [22],
  },
  "凛14-22": {
    "凛14": [23],
  },
  "凛14-23": {
    "凛14": [24],
  },
  "凛14-24": {
    "凛14": [25],
  },
  "凛14-25": {
    "凛14": [26],
  },
  "凛14-26": {
    "凛14": [27],
  },
  "凛14-27": {
    "凛14": [28],
  },
  "凛14-28": {
    "凛14": [29],
  },
  "凛14-29": {
    "凛14": [4],
  },
  "凛14-31": {
    "凛14": [32],
  },
  "凛14-32": {
    "凛14": [33],
  },
  "凛14-33": {
    "凛14": [34],
  },
  "凛14-34": {
    "凛14": [35],
  },
  "凛14-35": {
    "凛14": [36],
  },
  "凛14-36": {
    "凛14": [9],
  },
  "凛14-108": {
    "凛14": [130],
  },
  "凛14-130": {
    "凛14": [31],
  },
  "凛3-0": {
    "凛3": [1, 2, 3],
  },
  "凛3-1": {
    "凛3": [4, 5],
  },
  "凛3-2": {
    "凛3": [12],
  },
  "凛3-3": {
    "凛3": [6, 7],
  },
  "凛3-4": {
    "凛3": [12],
  },
  "凛3-5": {
    "凛3": [6],
  },
  "凛3-6": {
    "凛4": [0],
  },
  "凛3-7": {
    "凛4": [0],
  },
  "凛3-9": {
    "凛3": [10],
  },
  "凛3-10": {
    "凛3": [11],
  },
  "凛3-11": {
    "凛3": [0],
  },
  "凛4-0": {
    "凛4": [1, 2],
  },
  "凛4-1": {
    "凛4": [10],
  },
  "凛4-2": {
    "凛4": [10],
  },
  "凛4-3": {
    "凛4": [4, 5, 6],
  },
  "凛4-4": {
    "凛4": [7],
  },
  "凛4-5": {
    "凛4": [7],
  },
  "凛4-6": {
    "凛4": [7],
  },
  "凛4-7": {
    "凛4": [9, 12],
  },
  "凛4-9": {
    "凛4": [11],
  },
  "凛4-10": {
    "凛4": [3],
  },
  "凛4-11": {
    "凛5": [0],
  },
  "凛4-12": {
    "凛5": [0],
  },
  "凛5-0": {
    "凛5": [1, 2, 3],
  },
  "凛5-1": {
    "凛5": [20],
  },
  "凛5-2": {
    "凛5": [20],
  },
  "凛5-3": {
    "凛5": [20],
  },
  "凛5-4": {
    "凛5": [5, 6],
  },
  "凛5-5": {
    "凛5": [25],
  },
  "凛5-6": {
    "凛5": [9, 9],
  },
  "凛5-9": {
    "凛5": [10, 11, 12],
  },
  "凛5-10": {
    "凛5": [26],
  },
  "凛5-11": {
    "凛5": [13],
  },
  "凛5-12": {
    "凛5": [13],
  },
  "凛5-13": {
    "凛5": [14, 15],
  },
  "凛5-14": {
    "凛5": [22],
  },
  "凛5-15": {
    "凛5": [22],
  },
  "凛5-16": {
    "凛5": [17, 18],
  },
  "凛5-17": {
    "凛6": [13],
  },
  "凛5-18": {
    "凛6": [13],
  },
  "凛5-20": {
    "凛5": [21, 27],
  },
  "凛5-21": {
    "凛5": [4],
  },
  "凛5-22": {
    "凛5": [23],
  },
  "凛5-23": {
    "凛5": [24],
  },
  "凛5-24": {
    "凛5": [16],
  },
  "凛5-27": {
    "凛5": [5],
  },
  "凛6-0": {
    "凛6": [1, 2, 3],
  },
  "凛6-1": {
    "凛6": [5],
  },
  "凛6-2": {
    "凛6": [4],
  },
  "凛6-3": {
    "凛6": [4],
  },
  "凛6-4": {
    "凛6": [6],
  },
  "凛6-5": {
    "凛6": [6],
  },
  "凛6-6": {
    "凛6": [14],
  },
  "凛6-8": {
    "凛6": [9],
  },
  "凛6-9": {
    "凛6": [10],
  },
  "凛6-10": {
    "凛6": [0],
  },
  "凛6-11": {
    "凛6": [12],
  },
  "凛6-12": {
    "凛7": [11],
  },
  "凛6-13": {
    "凛6": [8],
  },
  "凛6-14": {
    "凛6": [11],
  },
  "凛7-0": {
    "凛7": [1, 2, 3],
  },
  "凛7-1": {
    "凛7": [12],
  },
  "凛7-2": {
    "凛7": [12],
  },
  "凛7-3": {
    "凛7": [12],
  },
  "凛7-4": {
    "凛7": [5, 6],
  },
  "凛7-5": {
    "凛7": [8],
  },
  "凛7-6": {
    "凛7": [8],
  },
  "凛7-7": {
    "凛8": [9],
  },
  "凛7-8": {
    "凛7": [9],
  },
  "凛7-9": {
    "凛7": [7],
  },
  "凛7-11": {
    "凛7": [0],
  },
  "凛7-12": {
    "凛7": [4],
  },
  "凛8-0": {
    "凛8": [1, 10],
  },
  "凛8-1": {
    "凛8": [12],
  },
  "凛8-2": {
    "凛8": [3, 4, 5],
  },
  "凛8-3": {
    "凛8": [6],
  },
  "凛8-4": {
    "凛8": [6],
  },
  "凛8-5": {
    "凛8": [6],
  },
  "凛8-6": {
    "凛9": [7],
  },
  "凛8-8": {
    "凛8": [0],
  },
  "凛8-9": {
    "凛8": [8],
  },
  "凛8-10": {
    "凛8": [11],
  },
  "凛8-11": {
    "凛8": [2],
  },
  "凛9-0": {
    "凛9": [1, 2],
  },
  "凛9-1": {
    "凛9": [12],
  },
  "凛9-2": {
    "凛9": [12],
  },
  "凛9-3": {
    "凛9": [4, 5],
  },
  "凛9-4": {
    "凛9": [14],
  },
  "凛9-5": {
    "凛9": [13],
  },
  "凛9-7": {
    "凛9": [8],
  },
  "凛9-8": {
    "凛9": [0],
  },
  "凛9-9": {
    "凛9": [3],
  },
  "凛9-10": {
    "凛9": [11],
  },
  "凛9-11": {
    "凛10": [6],
  },
  "凛9-12": {
    "凛9": [9],
  },
  "凛9-13": {
    "凛9": [10],
  },
  "桜10-0": {
    "桜10": [1, 2, 3],
  },
  "桜10-1": {
    "桜10": [4],
  },
  "桜10-2": {
    "桜10": [4],
  },
  "桜10-3": {
    "桜10": [4],
  },
  "桜10-4": {
    "桜10": [7],
  },
  "桜10-5": {
    "桜10": [8],
  },
  "桜10-6": {
    "桜10": [0],
  },
  "桜10-7": {
    "桜10": [5],
  },
  "桜10-8": {
    "桜10": [9, 10],
  },
  "桜10-9": {
    "桜10": [12],
  },
  "桜10-10": {
    "桜10": [34],
  },
  "桜10-11": {
    "桜10": [19],
  },
  "桜10-12": {
    "桜10": [11],
  },
  "桜10-13": {
    "桜10": [14, 15],
  },
  "桜10-14": {
    "桜10": [28],
  },
  "桜10-15": {
    "桜10": [35],
  },
  "桜10-16": {
    "桜10": [17, 18],
  },
  "桜10-17": {
    "桜10": [30],
  },
  "桜10-18": {
    "桜10": [30],
  },
  "桜10-19": {
    "桜10": [13],
  },
  "桜10-20": {
    "桜10": [21, 22],
  },
  "桜10-21": {
    "桜10": [32],
  },
  "桜10-22": {
    "桜10": [32],
  },
  "桜10-23": {
    "桜10": [24, 25],
  },
  "桜10-24": {
    "桜10": [26],
  },
  "桜10-25": {
    "桜10": [26],
  },
  "桜10-26": {
    "桜10": [33],
  },
  "桜10-28": {
    "桜10": [29],
  },
  "桜10-29": {
    "桜10": [16],
  },
  "桜10-30": {
    "桜10": [31],
  },
  "桜10-31": {
    "桜10": [20],
  },
  "桜10-32": {
    "桜10": [23],
  },
  "桜10-33": {
    "桜11": [6],
  },
  "桜11-0": {
    "桜11": [1, 2, 3],
  },
  "桜11-1": {
    "桜11": [4],
  },
  "桜11-2": {
    "桜11": [4],
  },
  "桜11-3": {
    "桜11": [4],
  },
  "桜11-4": {
    "桜11": [11],
  },
  "桜11-6": {
    "桜11": [7],
  },
  "桜11-7": {
    "桜11": [8],
  },
  "桜11-8": {
    "桜11": [9],
  },
  "桜11-9": {
    "桜11": [10],
  },
  "桜11-10": {
    "桜11": [0],
  },
  "桜11-11": {
    "桜11": [12],
  },
  "桜11-12": {
    "桜11": [13],
  },
  "桜11-13": {
    "桜11": [14],
  },
  "桜11-14": {
    "桜11": [15, 115],
  },
  "桜11-15": {
    "桜11": [16],
  },
  "桜11-16": {
    "桜12": [5],
  },
  "桜11-115": {
    "桜11": [16],
  },
  "桜12-0": {
    "桜12": [1, 2],
  },
  "桜12-1": {
    "桜12": [3],
  },
  "桜12-2": {
    "桜12": [3],
  },
  "桜12-3": {
    "桜12": [7, 8],
  },
  "桜12-5": {
    "桜12": [6],
  },
  "桜12-6": {
    "桜12": [0],
  },
  "桜12-7": {
    "桜12": [8],
  },
  "桜12-8": {
    "桜12": [9],
  },
  "桜12-9": {
    "桜12": [10],
  },
  "桜12-10": {
    "桜12": [11],
  },
  "桜12-11": {
    "桜12": [12],
  },
  "桜12-12": {
    "桜12": [13, 113],
  },
  "桜12-13": {
    "桜12": [14],
  },
  "桜12-14": {
    "桜13": [8],
  },
  "桜12-113": {
    "桜12": [14],
  },
  "桜13-0": {
    "桜13": [1, 2],
  },
  "桜13-1": {
    "桜13": [12],
  },
  "桜13-2": {
    "桜13": [15],
  },
  "桜13-3": {
    "桜13": [5, 5, 6],
  },
  "桜13-5": {
    "桜13": [16],
  },
  "桜13-6": {
    "桜13": [14],
  },
  "桜13-8": {
    "桜13": [9],
  },
  "桜13-9": {
    "桜13": [10],
  },
  "桜13-10": {
    "桜13": [11],
  },
  "桜13-11": {
    "桜13": [0],
  },
  "桜13-12": {
    "桜13": [13],
  },
  "桜13-13": {
    "桜13": [3],
  },
  "桜13-14": {
    "桜14": [0],
  },
  "桜14-0": {
    "桜14": [2],
  },
  "桜14-1": {
    "桜14": [10, 110],
  },
  "桜14-2": {
    "桜14": [8],
  },
  "桜14-3": {
    "桜14": [4, 5],
  },
  "桜14-4": {
    "桜14": [6],
  },
  "桜14-5": {
    "桜14": [6],
  },
  "桜14-6": {
    "桜14": [11],
  },
  "桜14-8": {
    "桜14": [9],
  },
  "桜14-9": {
    "桜14": [1],
  },
  "桜14-10": {
    "桜14": [3],
  },
  "桜14-11": {
    "桜15": [0],
  },
  "桜14-110": {
    "桜14": [3],
  },
  "桜15-0": {
    "桜15": [1, 2],
  },
  "桜15-1": {
    "桜15": [3, 22],
  },
  "桜15-2": {
    "桜15": [27],
  },
  "桜15-3": {
    "桜15": [28],
  },
  "桜15-4": {
    "桜15": [5, 6, 7],
  },
  "桜15-5": {
    "桜15": [8],
  },
  "桜15-6": {
    "桜15": [8],
  },
  "桜15-7": {
    "桜15": [8],
  },
  "桜15-8": {
    "桜15": [9],
  },
  "桜15-9": {
    "桜15": [10],
  },
  "桜15-10": {
    "桜15": [11],
  },
  "桜15-11": {
    "桜15": [12],
  },
  "桜15-12": {
    "桜15": [24],
  },
  "桜15-13": {
    "桜15": [14, 15, 16],
  },
  "桜15-14": {
    "桜15": [20],
  },
  "桜15-15": {
    "桜15": [20],
  },
  "桜15-16": {
    "桜15": [17, 18, 19],
  },
  "桜15-17": {
    "桜15": [20],
  },
  "桜15-18": {
    "桜15": [20],
  },
  "桜15-19": {
    "桜15": [26],
  },
  "桜15-20": {
    "桜15": [29],
  },
  "桜15-22": {
    "桜15": [23],
  },
  "桜15-23": {
    "桜15": [4],
  },
  "桜15-24": {
    "桜15": [25],
  },
  "桜15-25": {
    "桜15": [13],
  },
  "桜15-26": {
    "桜16": [0],
  },
  "桜16-0": {
    "桜16": [14],
  },
  "桜16-1": {
    "桜16": [2, 3, 4],
  },
  "桜16-2": {
    "桜16": [23],
  },
  "桜16-3": {
    "桜16": [5],
  },
  "桜16-4": {
    "桜16": [5],
  },
  "桜16-5": {
    "桜16": [6, 7],
  },
  "桜16-6": {
    "桜16": [17],
  },
  "桜16-7": {
    "桜16": [24],
  },
  "桜16-8": {
    "桜16": [9, 11],
  },
  "桜16-10": {
    "桜16": [12, 13, 13],
  },
  "桜16-11": {
    "桜16": [21],
  },
  "桜16-14": {
    "桜16": [15],
  },
  "桜16-15": {
    "桜16": [16],
  },
  "桜16-16": {
    "桜16": [1],
  },
  "桜16-17": {
    "桜16": [18],
  },
  "桜16-18": {
    "桜16": [19],
  },
  "桜16-19": {
    "桜16": [20],
  },
  "桜16-20": {
    "桜16": [8],
  },
  "桜16-21": {
    "桜16": [22],
  },
  "桜16-22": {
    "桜16": [10],
  },
  "桜4-0": {
    "桜4": [10],
  },
  "桜4-1": {
    "桜4": [7],
  },
  "桜4-2": {
    "桜4": [3, 4],
  },
  "桜4-3": {
    "桜4": [5],
  },
  "桜4-4": {
    "桜4": [5],
  },
  "桜4-5": {
    "桜4": [9],
  },
  "桜4-7": {
    "桜4": [8],
  },
  "桜4-8": {
    "桜4": [2],
  },
  "桜4-9": {
    "桜5": [19],
  },
  "桜4-10": {
    "桜4": [1],
  },
  "桜4-11": {
    "桜4": [0],
  },
  "桜5-0": {
    "桜5": [1, 2, 3],
  },
  "桜5-1": {
    "桜5": [4],
  },
  "桜5-2": {
    "桜5": [4],
  },
  "桜5-3": {
    "桜5": [9],
  },
  "桜5-4": {
    "桜5": [5],
  },
  "桜5-5": {
    "桜5": [6, 7],
  },
  "桜5-6": {
    "桜5": [8],
  },
  "桜5-7": {
    "桜5": [8],
  },
  "桜5-8": {
    "桜5": [9],
  },
  "桜5-9": {
    "桜5": [10, 11],
  },
  "桜5-10": {
    "桜5": [13],
  },
  "桜5-11": {
    "桜5": [13],
  },
  "桜5-12": {
    "桜5": [21],
  },
  "桜5-13": {
    "桜5": [14, 15],
  },
  "桜5-14": {
    "桜5": [16],
  },
  "桜5-15": {
    "桜5": [16],
  },
  "桜5-16": {
    "桜5": [12],
  },
  "桜5-17": {
    "桜6": [0],
  },
  "桜5-19": {
    "桜5": [20],
  },
  "桜5-20": {
    "桜5": [0],
  },
  "桜5-21": {
    "桜5": [22],
  },
  "桜5-22": {
    "桜5": [17, 117],
  },
  "桜5-117": {
    "桜6": [0],
  },
  "桜6-0": {
    "桜6": [1],
  },
  "桜6-1": {
    "桜6": [3, 4],
  },
  "桜6-2": {
    "桜6": [19],
  },
  "桜6-3": {
    "桜6": [5],
  },
  "桜6-4": {
    "桜6": [5],
  },
  "桜6-5": {
    "桜6": [7, 8, 9, 10],
  },
  "桜6-7": {
    "桜6": [19],
  },
  "桜6-8": {
    "桜6": [19],
  },
  "桜6-9": {
    "桜6": [2],
  },
  "桜6-10": {
    "桜6": [2],
  },
  "桜6-11": {
    "桜7": [15],
  },
  "桜6-16": {
    "桜6": [18],
  },
  "桜6-17": {
    "桜6": [18],
  },
  "桜6-18": {
    "桜6": [11],
  },
  "桜6-19": {
    "桜6": [20, 21],
  },
  "桜6-20": {
    "桜6": [22],
  },
  "桜6-21": {
    "桜6": [22],
  },
  "桜6-22": {
    "桜6": [16, 17, 23],
  },
  "桜6-23": {
    "桜6": [11],
  },
  "桜7-0": {
    "桜7": [2],
  },
  "桜7-1": {
    "桜7": [17],
  },
  "桜7-2": {
    "桜7": [18],
  },
  "桜7-4": {
    "桜7": [19],
  },
  "桜7-6": {
    "桜7": [7, 8, 9],
  },
  "桜7-7": {
    "桜7": [19],
  },
  "桜7-8": {
    "桜7": [10],
  },
  "桜7-9": {
    "桜7": [19],
  },
  "桜7-10": {
    "桜7": [20],
  },
  "桜7-11": {
    "桜7": [12, 13],
  },
  "桜7-12": {
    "桜7": [5],
  },
  "桜7-13": {
    "桜7": [21],
  },
  "桜7-15": {
    "桜7": [16],
  },
  "桜7-16": {
    "桜7": [1],
  },
  "桜7-17": {
    "桜7": [0],
  },
  "桜7-18": {
    "桜7": [4, 6],
  },
  "桜7-19": {
    "桜7": [20],
  },
  "桜7-20": {
    "桜7": [11],
  },
  "桜7-21": {
    "桜8": [11],
  },
  "桜8-0": {
    "桜8": [15],
  },
  "桜8-1": {
    "桜8": [23],
  },
  "桜8-2": {
    "桜8": [3, 4],
  },
  "桜8-3": {
    "桜8": [17],
  },
  "桜8-4": {
    "桜8": [17],
  },
  "桜8-5": {
    "桜8": [6, 7, 8],
  },
  "桜8-6": {
    "桜8": [9],
  },
  "桜8-7": {
    "桜8": [24],
  },
  "桜8-8": {
    "桜8": [9],
  },
  "桜8-9": {
    "桜8": [19],
  },
  "桜8-11": {
    "桜8": [12],
  },
  "桜8-12": {
    "桜8": [13],
  },
  "桜8-13": {
    "桜8": [14],
  },
  "桜8-14": {
    "桜8": [0, 1],
  },
  "桜8-15": {
    "桜8": [16],
  },
  "桜8-16": {
    "桜8": [2],
  },
  "桜8-17": {
    "桜8": [18],
  },
  "桜8-18": {
    "桜8": [5],
  },
  "桜8-19": {
    "桜8": [20],
  },
  "桜8-20": {
    "桜8": [21],
  },
  "桜8-21": {
    "桜8": [22],
  },
  "桜8-22": {
    "桜9": [26],
  },
  "桜9-0": {
    "桜9": [1, 2, 3],
  },
  "桜9-1": {
    "桜9": [4],
  },
  "桜9-2": {
    "桜9": [4],
  },
  "桜9-3": {
    "桜9": [4],
  },
  "桜9-4": {
    "桜9": [5, 6],
  },
  "桜9-5": {
    "桜9": [38],
  },
  "桜9-6": {
    "桜9": [8, 9],
  },
  "桜9-8": {
    "桜9": [9],
  },
  "桜9-9": {
    "桜9": [11, 12],
  },
  "桜9-11": {
    "桜9": [12],
  },
  "桜9-12": {
    "桜9": [13, 14],
  },
  "桜9-13": {
    "桜9": [27],
  },
  "桜9-14": {
    "桜9": [27],
  },
  "桜9-15": {
    "桜9": [16, 17],
  },
  "桜9-16": {
    "桜9": [18],
  },
  "桜9-17": {
    "桜9": [18],
  },
  "桜9-18": {
    "桜9": [33],
  },
  "桜9-19": {
    "桜9": [20, 21, 22],
  },
  "桜9-20": {
    "桜9": [35],
  },
  "桜9-21": {
    "桜9": [39],
  },
  "桜9-22": {
    "桜9": [35],
  },
  "桜9-23": {
    "桜9": [25, 36],
  },
  "桜9-24": {
    "桜9": [28, 34],
  },
  "桜9-25": {
    "桜9": [40],
  },
  "桜9-26": {
    "桜9": [0],
  },
  "桜9-27": {
    "桜9": [15, 32],
  },
  "桜9-28": {
    "桜9": [29],
  },
  "桜9-29": {
    "桜9": [30, 130],
  },
  "桜9-30": {
    "桜10": [6],
  },
  "桜9-32": {
    "桜9": [18],
  },
  "桜9-33": {
    "桜9": [19],
  },
  "桜9-34": {
    "桜9": [41],
  },
  "桜9-35": {
    "桜9": [23],
  },
  "桜9-36": {
    "桜9": [37],
  },
  "桜9-37": {
    "桜9": [24],
  },
  "桜9-130": {
    "桜10": [6],
  },
}

export const graphR = {
  "セ1-0": {
    "プ": [3],
  },
  "セ1-1": {
    "セ1": [0],
  },
  "セ1-2": {
    "セ1": [0],
  },
  "セ1-3": {
    "セ1": [6],
  },
  "セ1-4": {
    "セ1": [3],
  },
  "セ1-5": {
    "セ1": [3],
  },
  "セ1-6": {
    "セ1": [1, 2],
  },
  "セ1-7": {
    "セ1": [4, 5],
  },
  "セ1-9": {
    "セ1": [7],
  },
  "セ1-11": {
    "セ1": [9],
  },
  "セ1-12": {
    "セ1": [9],
  },
  "セ1-13": {
    "セ1": [9],
  },
  "セ1-14": {
    "セ1": [9],
  },
  "セ1-15": {
    "セ1": [11, 12, 13, 14],
  },
  "セ10-0": {
    "セ9": [14],
  },
  "セ10-1": {
    "セ10": [2],
  },
  "セ10-2": {
    "セ10": [9],
  },
  "セ10-3": {
    "セ10": [2],
  },
  "セ10-4": {
    "セ10": [1],
  },
  "セ10-5": {
    "セ10": [4],
  },
  "セ10-6": {
    "セ10": [4],
  },
  "セ10-7": {
    "セ10": [5, 6],
  },
  "セ10-9": {
    "セ10": [0],
  },
  "セ10-10": {
    "セ10": [3],
  },
  "セ11-0": {
    "セ10": [7],
  },
  "セ11-1": {
    "セ11": [16],
  },
  "セ11-2": {
    "セ11": [16],
  },
  "セ11-3": {
    "セ11": [2],
  },
  "セ11-4": {
    "セ11": [2],
  },
  "セ11-5": {
    "セ11": [2],
  },
  "セ11-6": {
    "セ11": [18, 118],
  },
  "セ11-7": {
    "セ11": [6],
  },
  "セ11-8": {
    "セ11": [6],
  },
  "セ11-9": {
    "セ11": [7, 8],
  },
  "セ11-10": {
    "セ11": [9],
  },
  "セ11-11": {
    "セ11": [9],
  },
  "セ11-12": {
    "セ11": [10, 11],
  },
  "セ11-13": {
    "セ11": [12],
  },
  "セ11-14": {
    "セ11": [12],
  },
  "セ11-16": {
    "セ11": [0],
  },
  "セ11-17": {
    "セ11": [3, 4, 5],
  },
  "セ11-18": {
    "セ11": [19],
  },
  "セ11-19": {
    "セ11": [17],
  },
  "セ11-20": {
    "セ11": [1],
  },
  "セ11-21": {
    "セ11": [13],
  },
  "セ11-118": {
    "セ11": [19],
  },
  "セ12-0": {
    "セ12": [13],
  },
  "セ12-1": {
    "セ12": [0],
  },
  "セ12-2": {
    "セ12": [0],
  },
  "セ12-3": {
    "セ12": [1, 2],
  },
  "セ12-4": {
    "セ12": [3],
  },
  "セ12-5": {
    "セ12": [3],
  },
  "セ12-6": {
    "セ12": [3],
  },
  "セ12-7": {
    "セ12": [14],
  },
  "セ12-8": {
    "セ12": [7],
  },
  "セ12-9": {
    "セ12": [7],
  },
  "セ12-10": {
    "セ12": [7],
  },
  "セ12-11": {
    "セ12": [8, 9, 10],
  },
  "セ12-12": {
    "セ12": [11],
  },
  "セ12-13": {
    "セ11": [14],
  },
  "セ12-14": {
    "セ12": [4, 5, 6],
  },
  "セ12-15": {
    "セ12": [12],
  },
  "セ13-0": {
    "セ13": [13],
  },
  "セ13-1": {
    "セ13": [0],
  },
  "セ13-2": {
    "セ13": [0],
  },
  "セ13-3": {
    "セ12": [15],
  },
  "セ13-4": {
    "セ13": [2],
  },
  "セ13-5": {
    "セ13": [2],
  },
  "セ13-6": {
    "セ13": [12],
  },
  "セ13-7": {
    "セ13": [9],
  },
  "セ13-8": {
    "セ13": [4],
  },
  "セ13-9": {
    "セ13": [4],
  },
  "セ13-11": {
    "セ13": [7],
  },
  "セ13-12": {
    "セ13": [3],
  },
  "セ13-13": {
    "セ13": [6],
  },
  "セ13-14": {
    "セ13": [11],
  },
  "セ13-15": {
    "セ13": [1, 5],
  },
  "セ13-16": {
    "セ13": [8],
  },
  "セ14-0": {
    "セ14": [10],
  },
  "セ14-2": {
    "セ14": [0],
  },
  "セ14-3": {
    "セ14": [2],
  },
  "セ14-4": {
    "セ14": [2],
  },
  "セ14-6": {
    "セ13": [14],
  },
  "セ14-7": {
    "セ14": [8],
  },
  "セ14-8": {
    "セ14": [6],
  },
  "セ14-9": {
    "セ14": [7],
  },
  "セ14-10": {
    "セ14": [9],
  },
  "セ14-11": {
    "セ14": [4],
  },
  "セ14-12": {
    "セ14": [3],
  },
  "セ14-101": {
    "セ14": [111],
  },
  "セ14-111": {
    "セ14": [4],
  },
  "セ15-0": {
    "セ14": [11, 101],
  },
  "セ15-1": {
    "セ15": [0],
  },
  "セ15-2": {
    "セ15": [0],
  },
  "セ15-3": {
    "セ15": [20],
  },
  "セ15-4": {
    "セ15": [15, 16],
  },
  "セ15-5": {
    "セ15": [4],
  },
  "セ15-6": {
    "セ15": [4],
  },
  "セ15-7": {
    "セ15": [4],
  },
  "セ15-8": {
    "セ15": [7],
  },
  "セ15-9": {
    "セ15": [7],
  },
  "セ15-10": {
    "セ15": [7],
  },
  "セ15-11": {
    "セ15": [10],
  },
  "セ15-12": {
    "セ15": [5, 6, 8, 9],
  },
  "セ15-13": {
    "セ15": [11],
  },
  "セ15-14": {
    "セ15": [22],
  },
  "セ15-15": {
    "セ15": [14],
  },
  "セ15-16": {
    "セ15": [14],
  },
  "セ15-17": {
    "セ15": [13],
  },
  "セ15-18": {
    "セ15": [2],
  },
  "セ15-19": {
    "セ15": [18],
  },
  "セ15-20": {
    "セ15": [19],
  },
  "セ15-21": {
    "セ15": [20],
  },
  "セ15-22": {
    "セ15": [21],
  },
  "セ15-23": {
    "セ15": [1],
  },
  "セ15-24": {
    "セ15": [3],
  },
  "セ15-25": {
    "セ15": [12],
  },
  "セ2-0": {
    "セ1": [15],
  },
  "セ2-1": {
    "セ2": [8],
  },
  "セ2-3": {
    "セ2": [13],
  },
  "セ2-4": {
    "セ2": [10],
  },
  "セ2-5": {
    "セ2": [0, 13],
  },
  "セ2-6": {
    "セ2": [0, 13],
  },
  "セ2-7": {
    "セ2": [3, 15],
  },
  "セ2-8": {
    "セ2": [9, 16],
  },
  "セ2-9": {
    "セ2": [7],
  },
  "セ2-10": {
    "セ2": [9],
  },
  "セ2-13": {
    "セ1": [15],
  },
  "セ2-14": {
    "セ2": [4],
  },
  "セ2-15": {
    "セ2": [5, 6],
  },
  "セ2-16": {
    "セ2": [7],
  },
  "セ3-0": {
    "セ3": [16],
  },
  "セ3-1": {
    "セ3": [9, 10],
  },
  "セ3-2": {
    "セ3": [17],
  },
  "セ3-4": {
    "セ3": [2],
  },
  "セ3-5": {
    "セ3": [18],
  },
  "セ3-6": {
    "セ3": [5],
  },
  "セ3-7": {
    "セ3": [5],
  },
  "セ3-8": {
    "セ2": [1, 14],
  },
  "セ3-9": {
    "セ3": [8],
  },
  "セ3-10": {
    "セ3": [8],
  },
  "セ3-11": {
    "セ3": [4],
  },
  "セ3-12": {
    "セ3": [7],
  },
  "セ3-16": {
    "セ3": [1],
  },
  "セ3-17": {
    "セ3": [0, 0, 0],
  },
  "セ3-18": {
    "セ3": [2],
  },
  "セ3-19": {
    "セ3": [6],
  },
  "セ4-0": {
    "セ3": [7],
  },
  "セ4-1": {
    "セ4": [0],
  },
  "セ4-2": {
    "セ4": [0],
  },
  "セ4-3": {
    "セ4": [0],
  },
  "セ4-4": {
    "セ4": [1, 2, 3],
  },
  "セ4-5": {
    "セ4": [4],
  },
  "セ4-6": {
    "セ4": [18],
  },
  "セ4-7": {
    "セ4": [6],
  },
  "セ4-8": {
    "セ4": [6],
  },
  "セ4-9": {
    "セ4": [6],
  },
  "セ4-10": {
    "セ4": [7, 9],
  },
  "セ4-11": {
    "セ4": [8, 10],
  },
  "セ4-12": {
    "セ4": [11],
  },
  "セ4-15": {
    "セ4": [12],
  },
  "セ4-18": {
    "セ4": [4],
  },
  "セ5-0": {
    "セ4": [15],
  },
  "セ5-4": {
    "セ5": [0],
  },
  "セ5-5": {
    "セ5": [4],
  },
  "セ5-6": {
    "セ5": [5],
  },
  "セ5-7": {
    "セ5": [5],
  },
  "セ5-8": {
    "セ5": [6, 7],
  },
  "セ5-9": {
    "セ5": [8],
  },
  "セ5-10": {
    "セ5": [8],
  },
  "セ5-11": {
    "セ5": [8],
  },
  "セ5-12": {
    "セ5": [9, 10, 11],
  },
  "セ5-14": {
    "セ5": [12],
  },
  "セ6-0": {
    "セ6": [12],
  },
  "セ6-1": {
    "セ6": [0],
  },
  "セ6-3": {
    "セ6": [1],
  },
  "セ6-4": {
    "セ6": [1],
  },
  "セ6-5": {
    "セ6": [13],
  },
  "セ6-6": {
    "セ6": [5],
  },
  "セ6-7": {
    "セ6": [5],
  },
  "セ6-8": {
    "セ6": [7],
  },
  "セ6-9": {
    "セ6": [8],
  },
  "セ6-10": {
    "セ6": [14],
  },
  "セ6-12": {
    "セ5": [14],
  },
  "セ6-13": {
    "セ6": [3, 4],
  },
  "セ6-14": {
    "セ6": [9],
  },
  "セ6-15": {
    "セ6": [6],
  },
  "セ7-0": {
    "セ6": [10],
  },
  "セ7-1": {
    "セ7": [28],
  },
  "セ7-2": {
    "セ7": [0],
  },
  "セ7-3": {
    "セ7": [1],
  },
  "セ7-4": {
    "セ7": [2],
  },
  "セ7-5": {
    "セ7": [2],
  },
  "セ7-6": {
    "セ7": [2],
  },
  "セ7-7": {
    "セ7": [4, 5, 6],
  },
  "セ7-8": {
    "セ7": [3],
  },
  "セ7-12": {
    "セ7": [8],
  },
  "セ7-13": {
    "セ7": [8],
  },
  "セ7-14": {
    "セ7": [8],
  },
  "セ7-15": {
    "セ7": [8],
  },
  "セ7-16": {
    "セ7": [8],
  },
  "セ7-17": {
    "セ7": [8],
  },
  "セ7-18": {
    "セ7": [12, 13, 14, 15, 16, 17],
  },
  "セ7-19": {
    "セ7": [18],
  },
  "セ7-20": {
    "セ7": [18],
  },
  "セ7-21": {
    "セ7": [29],
  },
  "セ7-22": {
    "セ7": [21],
  },
  "セ7-23": {
    "セ7": [21],
  },
  "セ7-24": {
    "セ7": [21],
  },
  "セ7-25": {
    "セ7": [22, 23, 24],
  },
  "セ7-27": {
    "セ7": [25],
  },
  "セ7-28": {
    "セ7": [7],
  },
  "セ7-29": {
    "セ7": [19, 20],
  },
  "セ9-0": {
    "セ9": [15],
  },
  "セ9-1": {
    "セ9": [0],
  },
  "セ9-2": {
    "セ9": [0],
  },
  "セ9-3": {
    "セ9": [1, 2],
  },
  "セ9-4": {
    "セ9": [3],
  },
  "セ9-5": {
    "セ9": [3],
  },
  "セ9-6": {
    "セ9": [4, 5],
  },
  "セ9-7": {
    "セ9": [6],
  },
  "セ9-8": {
    "セ9": [6],
  },
  "セ9-9": {
    "セ9": [8],
  },
  "セ9-10": {
    "セ9": [8],
  },
  "セ9-11": {
    "セ9": [8],
  },
  "セ9-12": {
    "セ9": [9, 10],
  },
  "セ9-14": {
    "セ9": [12],
  },
  "セ9-15": {
    "セ7": [27],
  },
  "セ9-16": {
    "セ9": [7],
  },
  "セ9-17": {
    "セ9": [11],
  },
  "プ-2": {
    "プ": [1],
  },
  "プ-3": {
    "プ": [2],
  },
  "凛10-0": {
    "凛10": [7],
  },
  "凛10-1": {
    "凛10": [0],
  },
  "凛10-2": {
    "凛10": [0],
  },
  "凛10-3": {
    "凛10": [0],
  },
  "凛10-4": {
    "凛10": [1, 2, 3],
  },
  "凛10-6": {
    "凛9": [11],
  },
  "凛10-7": {
    "凛10": [6],
  },
  "凛10-8": {
    "凛10": [4],
  },
  "凛11-0": {
    "凛10": [8],
  },
  "凛11-1": {
    "凛11": [0],
  },
  "凛11-2": {
    "凛11": [0],
  },
  "凛11-3": {
    "凛11": [1],
  },
  "凛11-4": {
    "凛11": [11],
  },
  "凛11-5": {
    "凛11": [8],
  },
  "凛11-6": {
    "凛11": [8],
  },
  "凛11-8": {
    "凛11": [4],
  },
  "凛11-9": {
    "凛11": [1],
  },
  "凛11-10": {
    "凛11": [2, 9],
  },
  "凛11-11": {
    "凛11": [3, 10],
  },
  "凛11-12": {
    "凛11": [6],
  },
  "凛11-13": {
    "凛11": [16],
  },
  "凛11-14": {
    "凛11": [13],
  },
  "凛11-15": {
    "凛11": [12],
  },
  "凛11-16": {
    "凛11": [15],
  },
  "凛11-17": {
    "凛11": [5],
  },
  "凛12-0": {
    "凛12": [14],
  },
  "凛12-1": {
    "凛12": [0],
  },
  "凛12-2": {
    "凛12": [3],
  },
  "凛12-3": {
    "凛12": [0, 15],
  },
  "凛12-4": {
    "凛12": [12],
  },
  "凛12-5": {
    "凛12": [4],
  },
  "凛12-6": {
    "凛12": [4],
  },
  "凛12-7": {
    "凛12": [6],
  },
  "凛12-8": {
    "凛12": [6, 7],
  },
  "凛12-10": {
    "凛12": [3],
  },
  "凛12-11": {
    "凛12": [3],
  },
  "凛12-12": {
    "凛12": [1],
  },
  "凛12-13": {
    "凛12": [8],
  },
  "凛12-14": {
    "凛11": [14],
  },
  "凛12-15": {
    "凛12": [14],
  },
  "凛12-16": {
    "凛12": [2, 10, 11],
  },
  "凛12-17": {
    "凛12": [5],
  },
  "凛13-0": {
    "凛13": [11],
  },
  "凛13-1": {
    "凛13": [0],
  },
  "凛13-2": {
    "凛13": [0],
  },
  "凛13-3": {
    "凛13": [0],
  },
  "凛13-4": {
    "凛13": [21],
  },
  "凛13-5": {
    "凛13": [18],
  },
  "凛13-6": {
    "凛13": [4],
  },
  "凛13-7": {
    "凛13": [5],
  },
  "凛13-8": {
    "凛13": [5],
  },
  "凛13-9": {
    "凛13": [5],
  },
  "凛13-11": {
    "凛12": [13],
  },
  "凛13-12": {
    "凛13": [1, 2, 3],
  },
  "凛13-13": {
    "凛13": [12],
  },
  "凛13-14": {
    "凛13": [13],
  },
  "凛13-15": {
    "凛13": [4],
  },
  "凛13-16": {
    "凛13": [15],
  },
  "凛13-17": {
    "凛13": [6, 16],
  },
  "凛13-18": {
    "凛13": [17],
  },
  "凛13-19": {
    "凛13": [9, 17],
  },
  "凛13-20": {
    "凛13": [7, 8],
  },
  "凛13-21": {
    "凛13": [14],
  },
  "凛13-22": {
    "凛13": [19],
  },
  "凛14-0": {
    "凛14": [20],
  },
  "凛14-1": {
    "凛14": [0],
  },
  "凛14-2": {
    "凛14": [0],
  },
  "凛14-3": {
    "凛14": [1, 2],
  },
  "凛14-4": {
    "凛14": [29],
  },
  "凛14-5": {
    "凛14": [4],
  },
  "凛14-6": {
    "凛14": [4],
  },
  "凛14-7": {
    "凛14": [4],
  },
  "凛14-8": {
    "凛14": [5, 6, 7],
  },
  "凛14-9": {
    "凛14": [36],
  },
  "凛14-10": {
    "凛14": [9],
  },
  "凛14-11": {
    "凛14": [9],
  },
  "凛14-12": {
    "凛14": [10, 11],
  },
  "凛14-13": {
    "凛14": [12],
  },
  "凛14-14": {
    "凛14": [12],
  },
  "凛14-15": {
    "凛14": [14],
  },
  "凛14-16": {
    "凛14": [14],
  },
  "凛14-17": {
    "凛13": [20],
  },
  "凛14-18": {
    "凛14": [17],
  },
  "凛14-19": {
    "凛14": [18],
  },
  "凛14-20": {
    "凛14": [19],
  },
  "凛14-21": {
    "凛14": [3],
  },
  "凛14-22": {
    "凛14": [21],
  },
  "凛14-23": {
    "凛14": [22],
  },
  "凛14-24": {
    "凛14": [23],
  },
  "凛14-25": {
    "凛14": [24],
  },
  "凛14-26": {
    "凛14": [25],
  },
  "凛14-27": {
    "凛14": [26],
  },
  "凛14-28": {
    "凛14": [27],
  },
  "凛14-29": {
    "凛14": [28],
  },
  "凛14-31": {
    "凛14": [8, 130],
  },
  "凛14-32": {
    "凛14": [31],
  },
  "凛14-33": {
    "凛14": [32],
  },
  "凛14-34": {
    "凛14": [33],
  },
  "凛14-35": {
    "凛14": [34],
  },
  "凛14-36": {
    "凛14": [35],
  },
  "凛14-37": {
    "凛14": [13],
  },
  "凛14-108": {
    "凛14": [5, 6, 7],
  },
  "凛14-130": {
    "凛14": [108],
  },
  "凛3-0": {
    "凛3": [11],
  },
  "凛3-1": {
    "凛3": [0],
  },
  "凛3-2": {
    "凛3": [0],
  },
  "凛3-3": {
    "凛3": [0],
  },
  "凛3-4": {
    "凛3": [1],
  },
  "凛3-5": {
    "凛3": [1],
  },
  "凛3-6": {
    "凛3": [3, 5],
  },
  "凛3-7": {
    "凛3": [3],
  },
  "凛3-9": {
    "セ3": [0],
  },
  "凛3-10": {
    "凛3": [9],
  },
  "凛3-11": {
    "凛3": [10],
  },
  "凛3-12": {
    "凛3": [2, 4],
  },
  "凛4-0": {
    "凛3": [6, 7],
  },
  "凛4-1": {
    "凛4": [0],
  },
  "凛4-2": {
    "凛4": [0],
  },
  "凛4-3": {
    "セ4": [5],
    "凛4": [10],
  },
  "凛4-4": {
    "凛4": [3],
  },
  "凛4-5": {
    "凛4": [3],
  },
  "凛4-6": {
    "凛4": [3],
  },
  "凛4-7": {
    "凛4": [4, 5, 6],
  },
  "凛4-9": {
    "凛4": [7],
  },
  "凛4-10": {
    "凛4": [1, 2],
  },
  "凛4-11": {
    "凛4": [9],
  },
  "凛4-12": {
    "凛4": [7],
  },
  "凛5-0": {
    "凛4": [11, 12],
  },
  "凛5-1": {
    "凛5": [0],
  },
  "凛5-2": {
    "凛5": [0],
  },
  "凛5-3": {
    "凛5": [0],
  },
  "凛5-4": {
    "凛5": [21],
  },
  "凛5-5": {
    "凛5": [4, 27],
  },
  "凛5-6": {
    "凛5": [4],
  },
  "凛5-9": {
    "凛5": [6, 6],
  },
  "凛5-10": {
    "凛5": [9],
  },
  "凛5-11": {
    "凛5": [9],
  },
  "凛5-12": {
    "凛5": [9],
  },
  "凛5-13": {
    "凛5": [11, 12],
  },
  "凛5-14": {
    "凛5": [13],
  },
  "凛5-15": {
    "凛5": [13],
  },
  "凛5-16": {
    "凛5": [24],
  },
  "凛5-17": {
    "凛5": [16],
  },
  "凛5-18": {
    "凛5": [16],
  },
  "凛5-20": {
    "凛5": [1, 2, 3],
  },
  "凛5-21": {
    "凛5": [20],
  },
  "凛5-22": {
    "凛5": [14, 15],
  },
  "凛5-23": {
    "凛5": [22],
  },
  "凛5-24": {
    "凛5": [23],
  },
  "凛5-25": {
    "凛5": [5],
  },
  "凛5-26": {
    "凛5": [10],
  },
  "凛5-27": {
    "凛5": [20],
  },
  "凛6-0": {
    "凛6": [10],
  },
  "凛6-1": {
    "凛6": [0],
  },
  "凛6-2": {
    "凛6": [0],
  },
  "凛6-3": {
    "凛6": [0],
  },
  "凛6-4": {
    "凛6": [2, 3],
  },
  "凛6-5": {
    "凛6": [1],
  },
  "凛6-6": {
    "凛6": [4, 5],
  },
  "凛6-8": {
    "凛6": [13],
  },
  "凛6-9": {
    "凛6": [8],
  },
  "凛6-10": {
    "凛6": [9],
  },
  "凛6-11": {
    "凛6": [14],
  },
  "凛6-12": {
    "凛6": [11],
  },
  "凛6-13": {
    "凛5": [17, 18],
  },
  "凛6-14": {
    "凛6": [6],
  },
  "凛7-0": {
    "凛7": [11],
  },
  "凛7-1": {
    "凛7": [0],
  },
  "凛7-2": {
    "凛7": [0],
  },
  "凛7-3": {
    "凛7": [0],
  },
  "凛7-4": {
    "凛7": [12],
  },
  "凛7-5": {
    "凛7": [4],
  },
  "凛7-6": {
    "凛7": [4],
  },
  "凛7-7": {
    "凛7": [9],
  },
  "凛7-8": {
    "凛7": [5, 6],
  },
  "凛7-9": {
    "凛7": [8],
  },
  "凛7-11": {
    "凛6": [12],
  },
  "凛7-12": {
    "凛7": [1, 2, 3],
  },
  "凛8-0": {
    "凛8": [8],
  },
  "凛8-1": {
    "凛8": [0],
  },
  "凛8-2": {
    "凛8": [11],
  },
  "凛8-3": {
    "凛8": [2],
  },
  "凛8-4": {
    "凛8": [2],
  },
  "凛8-5": {
    "凛8": [2],
  },
  "凛8-6": {
    "凛8": [3, 4, 5],
  },
  "凛8-8": {
    "凛8": [9],
  },
  "凛8-9": {
    "凛7": [7],
  },
  "凛8-10": {
    "凛8": [0],
  },
  "凛8-11": {
    "凛8": [10],
  },
  "凛8-12": {
    "凛8": [1],
  },
  "凛9-0": {
    "凛9": [8],
  },
  "凛9-1": {
    "凛9": [0],
  },
  "凛9-2": {
    "凛9": [0],
  },
  "凛9-3": {
    "凛9": [9],
  },
  "凛9-4": {
    "凛9": [3],
  },
  "凛9-5": {
    "凛9": [3],
  },
  "凛9-7": {
    "凛8": [6],
  },
  "凛9-8": {
    "凛9": [7],
  },
  "凛9-9": {
    "凛9": [12],
  },
  "凛9-10": {
    "凛9": [13],
  },
  "凛9-11": {
    "凛9": [10],
  },
  "凛9-12": {
    "凛9": [1, 2],
  },
  "凛9-13": {
    "凛9": [5],
  },
  "凛9-14": {
    "凛9": [4],
  },
  "桜10-0": {
    "桜10": [6],
  },
  "桜10-1": {
    "桜10": [0],
  },
  "桜10-2": {
    "桜10": [0],
  },
  "桜10-3": {
    "桜10": [0],
  },
  "桜10-4": {
    "桜10": [1, 2, 3],
  },
  "桜10-5": {
    "桜10": [7],
  },
  "桜10-6": {
    "桜9": [30, 130],
  },
  "桜10-7": {
    "桜10": [4],
  },
  "桜10-8": {
    "桜10": [5],
  },
  "桜10-9": {
    "桜10": [8],
  },
  "桜10-10": {
    "桜10": [8],
  },
  "桜10-11": {
    "桜10": [12],
  },
  "桜10-12": {
    "桜10": [9],
  },
  "桜10-13": {
    "桜10": [19],
  },
  "桜10-14": {
    "桜10": [13],
  },
  "桜10-15": {
    "桜10": [13],
  },
  "桜10-16": {
    "桜10": [29],
  },
  "桜10-17": {
    "桜10": [16],
  },
  "桜10-18": {
    "桜10": [16],
  },
  "桜10-19": {
    "桜10": [11],
  },
  "桜10-20": {
    "桜10": [31],
  },
  "桜10-21": {
    "桜10": [20],
  },
  "桜10-22": {
    "桜10": [20],
  },
  "桜10-23": {
    "桜10": [32],
  },
  "桜10-24": {
    "桜10": [23],
  },
  "桜10-25": {
    "桜10": [23],
  },
  "桜10-26": {
    "桜10": [24, 25],
  },
  "桜10-28": {
    "桜10": [14],
  },
  "桜10-29": {
    "桜10": [28],
  },
  "桜10-30": {
    "桜10": [17, 18],
  },
  "桜10-31": {
    "桜10": [30],
  },
  "桜10-32": {
    "桜10": [21, 22],
  },
  "桜10-33": {
    "桜10": [26],
  },
  "桜10-34": {
    "桜10": [10],
  },
  "桜10-35": {
    "桜10": [15],
  },
  "桜11-0": {
    "桜11": [10],
  },
  "桜11-1": {
    "桜11": [0],
  },
  "桜11-2": {
    "桜11": [0],
  },
  "桜11-3": {
    "桜11": [0],
  },
  "桜11-4": {
    "桜11": [1, 2, 3],
  },
  "桜11-6": {
    "桜10": [33],
  },
  "桜11-7": {
    "桜11": [6],
  },
  "桜11-8": {
    "桜11": [7],
  },
  "桜11-9": {
    "桜11": [8],
  },
  "桜11-10": {
    "桜11": [9],
  },
  "桜11-11": {
    "桜11": [4],
  },
  "桜11-12": {
    "桜11": [11],
  },
  "桜11-13": {
    "桜11": [12],
  },
  "桜11-14": {
    "桜11": [13],
  },
  "桜11-15": {
    "桜11": [14],
  },
  "桜11-16": {
    "桜11": [15, 115],
  },
  "桜11-115": {
    "桜11": [14],
  },
  "桜12-0": {
    "桜12": [6],
  },
  "桜12-1": {
    "桜12": [0],
  },
  "桜12-2": {
    "桜12": [0],
  },
  "桜12-3": {
    "桜12": [1, 2],
  },
  "桜12-5": {
    "桜11": [16],
  },
  "桜12-6": {
    "桜12": [5],
  },
  "桜12-7": {
    "桜12": [3],
  },
  "桜12-8": {
    "桜12": [3, 7],
  },
  "桜12-9": {
    "桜12": [8],
  },
  "桜12-10": {
    "桜12": [9],
  },
  "桜12-11": {
    "桜12": [10],
  },
  "桜12-12": {
    "桜12": [11],
  },
  "桜12-13": {
    "桜12": [12],
  },
  "桜12-14": {
    "桜12": [13, 113],
  },
  "桜12-113": {
    "桜12": [12],
  },
  "桜13-0": {
    "桜13": [11],
  },
  "桜13-1": {
    "桜13": [0],
  },
  "桜13-2": {
    "桜13": [0],
  },
  "桜13-3": {
    "桜13": [13],
  },
  "桜13-5": {
    "桜13": [3, 3],
  },
  "桜13-6": {
    "桜13": [3],
  },
  "桜13-8": {
    "桜12": [14],
  },
  "桜13-9": {
    "桜13": [8],
  },
  "桜13-10": {
    "桜13": [9],
  },
  "桜13-11": {
    "桜13": [10],
  },
  "桜13-12": {
    "桜13": [1],
  },
  "桜13-13": {
    "桜13": [12],
  },
  "桜13-14": {
    "桜13": [6],
  },
  "桜13-15": {
    "桜13": [2],
  },
  "桜13-16": {
    "桜13": [5],
  },
  "桜14-0": {
    "桜13": [14],
  },
  "桜14-1": {
    "桜14": [9],
  },
  "桜14-2": {
    "桜14": [0],
  },
  "桜14-3": {
    "桜14": [10, 110],
  },
  "桜14-4": {
    "桜14": [3],
  },
  "桜14-5": {
    "桜14": [3],
  },
  "桜14-6": {
    "桜14": [4, 5],
  },
  "桜14-8": {
    "桜14": [2],
  },
  "桜14-9": {
    "桜14": [8],
  },
  "桜14-10": {
    "桜14": [1],
  },
  "桜14-11": {
    "桜14": [6],
  },
  "桜14-110": {
    "桜14": [1],
  },
  "桜15-0": {
    "桜14": [11],
  },
  "桜15-1": {
    "桜15": [0],
  },
  "桜15-2": {
    "桜15": [0],
  },
  "桜15-3": {
    "桜15": [1],
  },
  "桜15-4": {
    "桜15": [23],
  },
  "桜15-5": {
    "桜15": [4],
  },
  "桜15-6": {
    "桜15": [4],
  },
  "桜15-7": {
    "桜15": [4],
  },
  "桜15-8": {
    "桜15": [5, 6, 7],
  },
  "桜15-9": {
    "桜15": [8],
  },
  "桜15-10": {
    "桜15": [9],
  },
  "桜15-11": {
    "桜15": [10],
  },
  "桜15-12": {
    "桜15": [11],
  },
  "桜15-13": {
    "桜15": [25],
  },
  "桜15-14": {
    "桜15": [13],
  },
  "桜15-15": {
    "桜15": [13],
  },
  "桜15-16": {
    "桜15": [13],
  },
  "桜15-17": {
    "桜15": [16],
  },
  "桜15-18": {
    "桜15": [16],
  },
  "桜15-19": {
    "桜15": [16],
  },
  "桜15-20": {
    "桜15": [14, 15, 17, 18],
  },
  "桜15-22": {
    "桜15": [1],
  },
  "桜15-23": {
    "桜15": [22],
  },
  "桜15-24": {
    "桜15": [12],
  },
  "桜15-25": {
    "桜15": [24],
  },
  "桜15-26": {
    "桜15": [19],
  },
  "桜15-27": {
    "桜15": [2],
  },
  "桜15-28": {
    "桜15": [3],
  },
  "桜15-29": {
    "桜15": [20],
  },
  "桜16-0": {
    "桜15": [26],
  },
  "桜16-1": {
    "桜16": [16],
  },
  "桜16-2": {
    "桜16": [1],
  },
  "桜16-3": {
    "桜16": [1],
  },
  "桜16-4": {
    "桜16": [1],
  },
  "桜16-5": {
    "桜16": [3, 4],
  },
  "桜16-6": {
    "桜16": [5],
  },
  "桜16-7": {
    "桜16": [5],
  },
  "桜16-8": {
    "桜16": [20],
  },
  "桜16-9": {
    "桜16": [8],
  },
  "桜16-10": {
    "桜16": [22],
  },
  "桜16-11": {
    "桜16": [8],
  },
  "桜16-12": {
    "桜16": [10],
  },
  "桜16-13": {
    "桜16": [10, 10],
  },
  "桜16-14": {
    "桜16": [0],
  },
  "桜16-15": {
    "桜16": [14],
  },
  "桜16-16": {
    "桜16": [15],
  },
  "桜16-17": {
    "桜16": [6],
  },
  "桜16-18": {
    "桜16": [17],
  },
  "桜16-19": {
    "桜16": [18],
  },
  "桜16-20": {
    "桜16": [19],
  },
  "桜16-21": {
    "桜16": [11],
  },
  "桜16-22": {
    "桜16": [21],
  },
  "桜16-23": {
    "桜16": [2],
  },
  "桜16-24": {
    "桜16": [7],
  },
  "桜4-0": {
    "桜4": [11],
  },
  "桜4-1": {
    "桜4": [10],
  },
  "桜4-2": {
    "桜4": [8],
  },
  "桜4-3": {
    "桜4": [2],
  },
  "桜4-4": {
    "桜4": [2],
  },
  "桜4-5": {
    "桜4": [3, 4],
  },
  "桜4-7": {
    "桜4": [1],
  },
  "桜4-8": {
    "桜4": [7],
  },
  "桜4-9": {
    "桜4": [5],
  },
  "桜4-10": {
    "桜4": [0],
  },
  "桜4-11": {
    "セ3": [12],
  },
  "桜5-0": {
    "桜5": [20],
  },
  "桜5-1": {
    "桜5": [0],
  },
  "桜5-2": {
    "桜5": [0],
  },
  "桜5-3": {
    "桜5": [0],
  },
  "桜5-4": {
    "桜5": [1, 2],
  },
  "桜5-5": {
    "桜5": [4],
  },
  "桜5-6": {
    "桜5": [5],
  },
  "桜5-7": {
    "桜5": [5],
  },
  "桜5-8": {
    "桜5": [6, 7],
  },
  "桜5-9": {
    "桜5": [3, 8],
  },
  "桜5-10": {
    "桜5": [9],
  },
  "桜5-11": {
    "桜5": [9],
  },
  "桜5-12": {
    "桜5": [16],
  },
  "桜5-13": {
    "桜5": [10, 11],
  },
  "桜5-14": {
    "桜5": [13],
  },
  "桜5-15": {
    "桜5": [13],
  },
  "桜5-16": {
    "桜5": [14, 15],
  },
  "桜5-17": {
    "桜5": [22],
  },
  "桜5-19": {
    "桜4": [9],
  },
  "桜5-20": {
    "桜5": [19],
  },
  "桜5-21": {
    "桜5": [12],
  },
  "桜5-22": {
    "桜5": [21],
  },
  "桜5-117": {
    "桜5": [22],
  },
  "桜6-0": {
    "桜5": [17, 117],
  },
  "桜6-1": {
    "桜6": [0],
  },
  "桜6-2": {
    "桜6": [9, 10],
  },
  "桜6-3": {
    "桜6": [1],
  },
  "桜6-4": {
    "桜6": [1],
  },
  "桜6-5": {
    "桜6": [3, 4],
  },
  "桜6-7": {
    "桜6": [5],
  },
  "桜6-8": {
    "桜6": [5],
  },
  "桜6-9": {
    "桜6": [5],
  },
  "桜6-10": {
    "桜6": [5],
  },
  "桜6-11": {
    "桜6": [18, 23],
  },
  "桜6-16": {
    "桜6": [22],
  },
  "桜6-17": {
    "桜6": [22],
  },
  "桜6-18": {
    "桜6": [16, 17],
  },
  "桜6-19": {
    "桜6": [2, 7, 8],
  },
  "桜6-20": {
    "桜6": [19],
  },
  "桜6-21": {
    "桜6": [19],
  },
  "桜6-22": {
    "桜6": [20, 21],
  },
  "桜6-23": {
    "桜6": [22],
  },
  "桜7-0": {
    "桜7": [17],
  },
  "桜7-1": {
    "桜7": [16],
  },
  "桜7-2": {
    "桜7": [0],
  },
  "桜7-4": {
    "桜7": [18],
  },
  "桜7-5": {
    "桜7": [12],
  },
  "桜7-6": {
    "桜7": [18],
  },
  "桜7-7": {
    "桜7": [6],
  },
  "桜7-8": {
    "桜7": [6],
  },
  "桜7-9": {
    "桜7": [6],
  },
  "桜7-10": {
    "桜7": [8],
  },
  "桜7-11": {
    "桜7": [20],
  },
  "桜7-12": {
    "桜7": [11],
  },
  "桜7-13": {
    "桜7": [11],
  },
  "桜7-15": {
    "桜6": [11],
  },
  "桜7-16": {
    "桜7": [15],
  },
  "桜7-17": {
    "桜7": [1],
  },
  "桜7-18": {
    "桜7": [2],
  },
  "桜7-19": {
    "桜7": [4, 7, 9],
  },
  "桜7-20": {
    "桜7": [10, 19],
  },
  "桜7-21": {
    "桜7": [13],
  },
  "桜8-0": {
    "桜8": [14],
  },
  "桜8-1": {
    "桜8": [14],
  },
  "桜8-2": {
    "桜8": [16],
  },
  "桜8-3": {
    "桜8": [2],
  },
  "桜8-4": {
    "桜8": [2],
  },
  "桜8-5": {
    "桜8": [18],
  },
  "桜8-6": {
    "桜8": [5],
  },
  "桜8-7": {
    "桜8": [5],
  },
  "桜8-8": {
    "桜8": [5],
  },
  "桜8-9": {
    "桜8": [6, 8],
  },
  "桜8-11": {
    "桜7": [21],
  },
  "桜8-12": {
    "桜8": [11],
  },
  "桜8-13": {
    "桜8": [12],
  },
  "桜8-14": {
    "桜8": [13],
  },
  "桜8-15": {
    "桜8": [0],
  },
  "桜8-16": {
    "桜8": [15],
  },
  "桜8-17": {
    "桜8": [3, 4],
  },
  "桜8-18": {
    "桜8": [17],
  },
  "桜8-19": {
    "桜8": [9],
  },
  "桜8-20": {
    "桜8": [19],
  },
  "桜8-21": {
    "桜8": [20],
  },
  "桜8-22": {
    "桜8": [21],
  },
  "桜8-23": {
    "桜8": [1],
  },
  "桜8-24": {
    "桜8": [7],
  },
  "桜9-0": {
    "桜9": [26],
  },
  "桜9-1": {
    "桜9": [0],
  },
  "桜9-2": {
    "桜9": [0],
  },
  "桜9-3": {
    "桜9": [0],
  },
  "桜9-4": {
    "桜9": [1, 2, 3],
  },
  "桜9-5": {
    "桜9": [4],
  },
  "桜9-6": {
    "桜9": [4],
  },
  "桜9-8": {
    "桜9": [6],
  },
  "桜9-9": {
    "桜9": [6, 8],
  },
  "桜9-11": {
    "桜9": [9],
  },
  "桜9-12": {
    "桜9": [9, 11],
  },
  "桜9-13": {
    "桜9": [12],
  },
  "桜9-14": {
    "桜9": [12],
  },
  "桜9-15": {
    "桜9": [27],
  },
  "桜9-16": {
    "桜9": [15],
  },
  "桜9-17": {
    "桜9": [15],
  },
  "桜9-18": {
    "桜9": [16, 17, 32],
  },
  "桜9-19": {
    "桜9": [33],
  },
  "桜9-20": {
    "桜9": [19],
  },
  "桜9-21": {
    "桜9": [19],
  },
  "桜9-22": {
    "桜9": [19],
  },
  "桜9-23": {
    "桜9": [35],
  },
  "桜9-24": {
    "桜9": [37],
  },
  "桜9-25": {
    "桜9": [23],
  },
  "桜9-26": {
    "桜8": [22],
  },
  "桜9-27": {
    "桜9": [13, 14],
  },
  "桜9-28": {
    "桜9": [24],
  },
  "桜9-29": {
    "桜9": [28],
  },
  "桜9-30": {
    "桜9": [29],
  },
  "桜9-32": {
    "桜9": [27],
  },
  "桜9-33": {
    "桜9": [18],
  },
  "桜9-34": {
    "桜9": [24],
  },
  "桜9-35": {
    "桜9": [20, 22],
  },
  "桜9-36": {
    "桜9": [23],
  },
  "桜9-37": {
    "桜9": [36],
  },
  "桜9-38": {
    "桜9": [5],
  },
  "桜9-39": {
    "桜9": [21],
  },
  "桜9-40": {
    "桜9": [25],
  },
  "桜9-41": {
    "桜9": [34],
  },
  "桜9-130": {
    "桜9": [29],
  },
}

export const graphLogic = {
  "セ1-0": {
    "choices": [
      {
        "eng": "I’ll go and help Sakura.",
        "jp": "桜の手伝いをしに行こう。",
        "then": {
          "goto": "セ1-1",
        },
      },
      {
        "eng": "I’ll go and finish my daily routine.",
        "jp": "いつもの日課を済ませてしまおう。",
        "then": {
          "goto": "セ1-2",
        },
      },
    ],
  },
  "セ1-1": {
    "update": [
      "桜好感度+=1",
    ],
    "goto": "セ1-6",
  },
  "セ1-2": {
    "update": [
      "道場説明=1",
    ],
    "goto": "セ1-6",
  },
  "セ1-3": {
    "choices": [
      {
        "eng": "I’ll go and help out the student council.",
        "jp": "生徒会の手伝いをしよう。",
        "then": {
          "goto": "セ1-4",
        },
      },
      {
        "eng": "I’ll go to work.",
        "jp": "アルバイトに行こう。",
        "then": {
          "goto": "セ1-5",
        },
      },
    ],
  },
  "セ1-4": {
    "update": [
      "凛好感度+=1",
    ],
    "goto": "セ1-7",
  },
  "セ1-5": {
    "goto": "セ1-7",
  },
  "セ1-6": {
    "goto": "セ1-3",
  },
  "セ1-7": {
    "goto": "セ1-9",
  },
  "セ1-9": {
    "choices": [
      {
        "eng": "I’ll take Sakura home.",
        "jp": "桜を送っていく。",
        "then": {
          "conditions": [
            {
              "if": "g凛クリア==1",
              "then": {
                "goto": "セ1-14",
              },
            },
            {
              "then": {
                "goto": "セ1-13",
              },
            },
          ],
        },
      },
      {
        "eng": "I’ll play with Fuji-Nee.",
        "jp": "藤ねえと遊ぶ。",
        "then": {
          "goto": "セ1-11",
        },
      },
      {
        "eng": "I’ll rest.",
        "jp": "大人しく休む。",
        "then": {
          "goto": "セ1-12",
        },
      },
    ],
  },
  "セ1-11": {
    "goto": "セ1-15",
  },
  "セ1-12": {
    "goto": "セ1-15",
  },
  "セ1-13": {
    "goto": "セ1-15",
  },
  "セ1-14": {
    "update": [
      "桜ルート分岐+=1",
    ],
    "goto": "セ1-15",
  },
  "セ1-15": {
    "conditions": [
      {
        "if": "桜ルート分岐\u003e=1\u0026\u0026桜好感度\u003e=1",
        "then": {
          "goto": "セ2-13",
        },
      },
      {
        "then": {
          "goto": "セ2-0",
        },
      },
    ],
  },
  "セ10-0": {
    "goto": "セ10-9",
  },
  "セ10-1": {
    "goto": "セ10-4",
  },
  "セ10-2": {
    "choices": [
      {
        "eng": "…Wait here and stand by.",
        "jp": "……ここで待機する。",
        "then": {
          "goto": "セ10-3",
        },
      },
      {
        "eng": "I have to follow Saber…!",
        "jp": "セイバーを追わなければ……！",
        "then": {
          "goto": "セ10-1",
        },
      },
    ],
  },
  "セ10-3": {
    "goto": "セ10-10",
  },
  "セ10-4": {
    "choices": [
      {
        "eng": "Follow Shinji.",
        "jp": "慎二を追う。",
        "then": {
          "goto": "セ10-5",
        },
      },
      {
        "eng": "Run to Saber.",
        "jp": "セイバーに駆け寄る。",
        "then": {
          "goto": "セ10-6",
        },
      },
    ],
  },
  "セ10-5": {
    "goto": "セ10-7",
  },
  "セ10-6": {
    "update": [
      "セイバー好感度+=2",
    ],
    "goto": "セ10-7",
  },
  "セ10-7": {
    "goto": "セ11-0",
  },
  "セ10-9": {
    "goto": "セ10-2",
  },
  "セ10-10": {},
  "セ11-0": {
    "goto": "セ11-16",
  },
  "セ11-1": {
    "goto": "セ11-20",
  },
  "セ11-2": {
    "choices": [
      {
        "eng": "I have to fight. I’ll make the first move when the door opens.",
        "jp": "こうなったら戦うだけだ。扉が開いた瞬間、先手を撃つ。",
        "then": {
          "goto": "セ11-3",
        },
      },
      {
        "eng": "…I’m in no condition to fight. I’ll sit in the chair and pretend I’m tied up.",
        "jp": "……戦える状態じゃない。椅子に座って、縛られたフリをしよう。",
        "then": {
          "goto": "セ11-4",
        },
      },
      {
        "eng": "…How about that bed?",
        "jp": "………………あのベッドなどいかがなものか？",
        "then": {
          "goto": "セ11-5",
        },
      },
    ],
  },
  "セ11-3": {
    "update": [
      "セイバー好感度+=1",
    ],
    "goto": "セ11-17",
  },
  "セ11-4": {
    "update": [
      "凛好感度+=1",
    ],
    "goto": "セ11-17",
  },
  "セ11-5": {
    "goto": "セ11-17",
  },
  "セ11-6": {
    "choices": [
      {
        "eng": "I’m worried about Saber.",
        "jp": "セイバーが気にかかる。",
        "then": {
          "goto": "セ11-7",
        },
      },
      {
        "eng": "I’m worried about Tohsaka.",
        "jp": "遠坂が気にかかる。",
        "then": {
          "goto": "セ11-8",
        },
      },
    ],
  },
  "セ11-7": {
    "update": [
      "セイバー好感度+=1",
    ],
    "goto": "セ11-9",
  },
  "セ11-8": {
    "update": [
      "凛好感度+=1",
    ],
    "goto": "セ11-9",
  },
  "セ11-9": {
    "choices": [
      {
        "eng": "I’ll provide backup with the bow…!",
        "jp": "弓で援護を……！",
        "then": {
          "goto": "セ11-10",
        },
      },
      {
        "eng": "…What’s the point?",
        "jp": "───それが何になる。",
        "then": {
          "goto": "セ11-11",
        },
      },
    ],
  },
  "セ11-10": {
    "goto": "セ11-12",
  },
  "セ11-11": {
    "goto": "セ11-12",
  },
  "セ11-12": {
    "choices": [
      {
        "eng": "…Is that the only option?",
        "jp": "……それしか、ないのか。",
        "then": {
          "goto": "セ11-13",
        },
      },
      {
        "eng": "Don’t use it!",
        "jp": "───使うな！",
        "then": {
          "goto": "セ11-14",
        },
      },
    ],
  },
  "セ11-13": {
    "goto": "セ11-21",
  },
  "セ11-14": {
    "goto": "セ12-13",
  },
  "セ11-16": {
    "choices": [
      {
        "eng": "…I’ll have to nod for now.",
        "jp": "……今は、頷くしかない。",
        "then": {
          "goto": "セ11-1",
        },
      },
      {
        "eng": "…I can’t do that.",
        "jp": "……それは、出来ない。",
        "then": {
          "goto": "セ11-2",
        },
      },
    ],
  },
  "セ11-17": {
    "goto": "セ11-19",
  },
  "セ11-18": {
    "goto": "セ11-6",
  },
  "セ11-19": {
    "conditions": [
      {
        "if": "ghentai==1",
        "then": {
          "goto": "セ11-118",
        },
      },
      {
        "then": {
          "goto": "セ11-18",
        },
      },
    ],
  },
  "セ11-20": {},
  "セ11-21": {},
  "セ11-118": {
    "goto": "セ11-6",
  },
  "セ12-0": {
    "choices": [
      {
        "eng": "Protect Illya.",
        "jp": "イリヤを匿う。",
        "then": {
          "goto": "セ12-1",
        },
      },
      {
        "eng": "Entrust her to the church.",
        "jp": "教会に預ける。",
        "then": {
          "goto": "セ12-2",
        },
      },
    ],
  },
  "セ12-1": {
    "goto": "セ12-3",
  },
  "セ12-2": {
    "goto": "セ12-3",
  },
  "セ12-3": {
    "choices": [
      {
        "eng": "All right, let’s have lunch.",
        "jp": "よし、昼食にしよう。",
        "then": {
          "goto": "セ12-4",
        },
      },
      {
        "eng": "That’s fine, but why are you exactly on time today?",
        "jp": "いいけど、なんで今日に限って時間ピッタリなんだ？",
        "then": {
          "goto": "セ12-5",
        },
      },
      {
        "eng": "No way. We’re fasting today.",
        "jp": "───だめでござる。今日は断食でござる。",
        "then": {
          "goto": "セ12-6",
        },
      },
    ],
  },
  "セ12-4": {
    "goto": "セ12-14",
  },
  "セ12-5": {
    "goto": "セ12-14",
  },
  "セ12-6": {
    "goto": "セ12-14",
  },
  "セ12-7": {
    "choices": [
      {
        "eng": "Ask about the projection magic.",
        "jp": "投影魔術を詳しく聞く。",
        "then": {
          "goto": "セ12-8",
        },
      },
      {
        "eng": "Question number one.",
        "jp": "疑問点、いち。",
        "then": {
          "goto": "セ12-9",
        },
      },
      {
        "eng": "Silence is good.",
        "jp": "沈黙は美徳。",
        "then": {
          "goto": "セ12-10",
        },
      },
    ],
  },
  "セ12-8": {
    "goto": "セ12-11",
  },
  "セ12-9": {
    "goto": "セ12-11",
  },
  "セ12-10": {
    "goto": "セ12-11",
  },
  "セ12-11": {
    "goto": "セ12-12",
  },
  "セ12-12": {
    "goto": "セ12-15",
  },
  "セ12-13": {
    "goto": "セ12-0",
  },
  "セ12-14": {
    "goto": "セ12-7",
  },
  "セ12-15": {
    "goto": "セ13-3",
  },
  "セ13-0": {
    "choices": [
      {
        "eng": "Let Saber take care of Caster and protect the other two here.",
        "jp": "キャスターはセイバーに任せ、ここで二人を守る。",
        "then": {
          "goto": "セ13-1",
        },
      },
      {
        "eng": "Go out with Saber.",
        "jp": "セイバーと二人で打って出る。",
        "then": {
          "goto": "セ13-2",
        },
      },
    ],
  },
  "セ13-1": {
    "goto": "セ13-15",
  },
  "セ13-2": {
    "choices": [
      {
        "eng": "Believe in Tohsaka.",
        "jp": "遠坂を信じる。",
        "then": {
          "goto": "セ13-4",
        },
      },
      {
        "eng": "Let Saber take care of Caster.",
        "jp": "セイバーにキャスターを任せる。",
        "then": {
          "goto": "セ13-5",
        },
      },
    ],
  },
  "セ13-3": {
    "goto": "セ13-12",
  },
  "セ13-4": {
    "choices": [
      {
        "eng": "…That timing, she got it…!",
        "jp": "……あの間合い、取った……！",
        "then": {
          "goto": "セ13-8",
        },
      },
      {
        "eng": "Don’t do it, Saber…!",
        "jp": "だめだ、セイバー……！",
        "then": {
          "goto": "セ13-9",
        },
      },
    ],
  },
  "セ13-5": {
    "goto": "セ13-15",
  },
  "セ13-6": {
    "goto": "セ13-13",
  },
  "セ13-7": {
    "goto": "セ13-11",
  },
  "セ13-8": {
    "goto": "セ13-16",
  },
  "セ13-9": {
    "goto": "セ13-7",
  },
  "セ13-11": {
    "goto": "セ13-14",
  },
  "セ13-12": {
    "goto": "セ13-6",
  },
  "セ13-13": {
    "goto": "セ13-0",
  },
  "セ13-14": {
    "goto": "セ14-6",
  },
  "セ13-15": {},
  "セ13-16": {},
  "セ14-0": {
    "goto": "セ14-2",
  },
  "セ14-2": {
    "choices": [
      {
        "eng": "Stand up.",
        "jp": "立ち上がる。",
        "then": {
          "goto": "セ14-4",
        },
      },
      {
        "eng": "Don’t stand up.",
        "jp": "立ち上がらない。",
        "then": {
          "goto": "セ14-3",
        },
      },
    ],
  },
  "セ14-3": {
    "goto": "セ14-12",
  },
  "セ14-4": {
    "conditions": [
      {
        "if": "ghentai==1",
        "then": {
          "goto": "セ14-111",
        },
      },
      {
        "then": {
          "goto": "セ14-11",
        },
      },
    ],
  },
  "セ14-6": {
    "goto": "セ14-8",
  },
  "セ14-7": {
    "goto": "セ14-9",
  },
  "セ14-8": {
    "goto": "セ14-7",
  },
  "セ14-9": {
    "goto": "セ14-10",
  },
  "セ14-10": {
    "goto": "セ14-0",
  },
  "セ14-11": {
    "goto": "セ15-0",
  },
  "セ14-12": {},
  "セ14-101": {
    "goto": "セ15-0",
  },
  "セ14-111": {
    "goto": "セ14-101",
  },
  "セ15-0": {
    "choices": [
      {
        "eng": "Go back home.",
        "jp": "家に戻る。",
        "then": {
          "goto": "セ15-1",
        },
      },
      {
        "eng": "Go down the stairs.",
        "jp": "地下室に下りる。",
        "then": {
          "goto": "セ15-2",
        },
      },
    ],
  },
  "セ15-1": {
    "goto": "セ15-23",
  },
  "セ15-2": {
    "goto": "セ15-18",
  },
  "セ15-3": {
    "goto": "セ15-24",
  },
  "セ15-4": {
    "choices": [
      {
        "eng": "Spend time with Saber.",
        "jp": "セイバーとの時間にする。",
        "then": {
          "goto": "セ15-5",
        },
      },
      {
        "eng": "Go and report to Kiritsugu.",
        "jp": "切嗣に報告する。",
        "then": {
          "goto": "セ15-6",
        },
      },
      {
        "eng": "…Have a strategy meeting.",
        "jp": "……作戦会議をする。",
        "then": {
          "goto": "セ15-7",
        },
      },
    ],
  },
  "セ15-5": {
    "goto": "セ15-12",
  },
  "セ15-6": {
    "goto": "セ15-12",
  },
  "セ15-7": {
    "choices": [
      {
        "eng": "Look for a weapon.",
        "jp": "武器を探す。",
        "then": {
          "goto": "セ15-8",
        },
      },
      {
        "eng": "Strengthen Saber.",
        "jp": "セイバーを強化する。",
        "then": {
          "goto": "セ15-9",
        },
      },
      {
        "eng": "…Give Saber back her sheath.",
        "jp": "……鞘をセイバーに返す。",
        "then": {
          "goto": "セ15-10",
        },
      },
    ],
  },
  "セ15-8": {
    "goto": "セ15-12",
  },
  "セ15-9": {
    "goto": "セ15-12",
  },
  "セ15-10": {
    "goto": "セ15-11",
  },
  "セ15-11": {
    "goto": "セ15-13",
  },
  "セ15-12": {
    "goto": "セ15-25",
  },
  "セ15-13": {
    "goto": "セ15-17",
  },
  "セ15-14": {
    "choices": [
      {
        "eng": "…Even so, Tohsaka.",
        "jp": "……それでもだ、遠坂。",
        "then": {
          "goto": "セ15-15",
        },
      },
      {
        "eng": "…Is there a way?",
        "jp": "……方法があるのか？",
        "then": {
          "goto": "セ15-16",
        },
      },
    ],
  },
  "セ15-15": {
    "goto": "セ15-4",
  },
  "セ15-16": {
    "goto": "セ15-4",
  },
  "セ15-17": {
    "update": [
      "gセイバークリア=1",
    ],
  },
  "セ15-18": {
    "goto": "セ15-19",
  },
  "セ15-19": {
    "goto": "セ15-20",
  },
  "セ15-20": {
    "conditions": [
      {
        "if": "セイバー好感度\u003c=5",
        "then": {
          "goto": "セ15-3",
        },
      },
      {
        "then": {
          "goto": "セ15-21",
        },
      },
    ],
  },
  "セ15-21": {
    "goto": "セ15-22",
  },
  "セ15-22": {
    "goto": "セ15-14",
  },
  "セ15-23": {},
  "セ15-24": {},
  "セ15-25": {},
  "セ2-0": {
    "conditions": [
      {
        "if": "道場説明!=1",
        "then": {
          "goto": "セ2-6",
        },
      },
      {
        "then": {
          "goto": "セ2-5",
        },
      },
    ],
  },
  "セ2-1": {
    "goto": "セ3-8",
  },
  "セ2-3": {
    "update": [
      "桜ルート分岐+=1",
      "士郎の痣=1",
    ],
    "goto": "セ2-7",
  },
  "セ2-4": {
    "goto": "セ2-14",
  },
  "セ2-5": {
    "goto": "セ2-15",
  },
  "セ2-6": {
    "goto": "セ2-15",
  },
  "セ2-7": {
    "conditions": [
      {
        "if": "桜ルート分岐\u003e=2",
        "then": {
          "goto": "セ2-9",
        },
      },
      {
        "then": {
          "goto": "セ2-16",
        },
      },
    ],
  },
  "セ2-8": {
    "goto": "セ2-1",
  },
  "セ2-9": {
    "choices": [
      {
        "eng": "I’m worried about Tohsaka.",
        "jp": "遠坂が心配だ。",
        "then": {
          "goto": "セ2-8",
        },
      },
      {
        "eng": "I’m worried about Sakura.",
        "jp": "桜が気にかかる。",
        "then": {
          "goto": "セ2-10",
        },
      },
    ],
  },
  "セ2-10": {
    "update": [
      "桜ルート分岐+=1",
    ],
    "goto": "セ2-4",
  },
  "セ2-13": {
    "choices": [
      {
        "eng": "I’ll do my daily routine at the dojo.",
        "jp": "道場で朝の日課をこなそう。",
        "then": {
          "conditions": [
            {
              "if": "道場説明!=1",
              "then": {
                "goto": "セ2-6",
              },
            },
            {
              "then": {
                "goto": "セ2-5",
              },
            },
          ],
        },
      },
      {
        "eng": "I’ll make one more side dish since Sakura’s coming.",
        "jp": "桜も来るし、もう一品加えよう。",
        "then": {
          "goto": "セ2-3",
        },
      },
    ],
  },
  "セ2-14": {
    "goto": "セ3-8",
  },
  "セ2-15": {
    "goto": "セ2-7",
  },
  "セ2-16": {
    "goto": "セ2-8",
  },
  "セ3-0": {
    "conditions": [
      {
        "if": "桜ルート分岐\u003e=3",
        "then": {
          "goto": "セ3-17",
        },
      },
      {
        "if": "gセイバークリア==1",
        "then": {
          "choices": [
            {
              "eng": "Stop her.",
              "jp": "止める。",
              "then": {
                "goto": "凛3-9",
              },
            },
            {
              "eng": "Don’t stop her.",
              "jp": "止めない。",
              "then": {
                "goto": "セ3-17",
              },
            },
          ],
        },
      },
      {
        "then": {
          "goto": "セ3-17",
        },
      },
    ],
  },
  "セ3-1": {
    "goto": "セ3-16",
  },
  "セ3-2": {
    "choices": [
      {
        "eng": "…Revoke the Command Spell.",
        "jp": "……刻印を破棄する。",
        "then": {
          "goto": "セ3-4",
        },
      },
      {
        "eng": "…Fight.",
        "jp": "───戦う。",
        "then": {
          "goto": "セ3-18",
        },
      },
    ],
  },
  "セ3-4": {
    "goto": "セ3-11",
  },
  "セ3-5": {
    "choices": [
      {
        "eng": "Run away with Tohsaka…!",
        "jp": "遠坂を連れて逃げる……！",
        "then": {
          "goto": "セ3-6",
        },
      },
      {
        "eng": "Save Saber…!",
        "jp": "セイバーを助ける……！",
        "then": {
          "goto": "セ3-7",
        },
      },
    ],
  },
  "セ3-6": {
    "goto": "セ3-19",
  },
  "セ3-7": {
    "conditions": [
      {
        "if": "桜ルート分岐\u003e=3",
        "then": {
          "goto": "セ3-12",
        },
      },
      {
        "then": {
          "goto": "セ4-0",
        },
      },
    ],
  },
  "セ3-8": {
    "conditions": [
      {
        "if": "士郎の痣!=1",
        "then": {
          "goto": "セ3-9",
        },
      },
      {
        "if": "士郎の痣==1",
        "then": {
          "goto": "セ3-10",
        },
      },
    ],
  },
  "セ3-9": {
    "goto": "セ3-1",
  },
  "セ3-10": {
    "goto": "セ3-1",
  },
  "セ3-11": {},
  "セ3-12": {
    "goto": "桜4-11",
  },
  "セ3-16": {
    "goto": "セ3-0",
  },
  "セ3-17": {
    "goto": "セ3-2",
  },
  "セ3-18": {
    "goto": "セ3-5",
  },
  "セ3-19": {},
  "セ4-0": {
    "choices": [
      {
        "eng": "Ask about yesterday.",
        "jp": "まずは昨日の話から。",
        "then": {
          "goto": "セ4-1",
        },
      },
      {
        "eng": "Ask about the serious stuff.",
        "jp": "それじゃあ真面目な話から。",
        "then": {
          "goto": "セ4-2",
        },
      },
      {
        "eng": "…I have a bad feeling about this. I don’t want to hear either.",
        "jp": "……いやな予感がする。どっちも聞かない。",
        "then": {
          "goto": "セ4-3",
        },
      },
    ],
  },
  "セ4-1": {
    "update": [
      "凛好感度+=1",
    ],
    "goto": "セ4-4",
  },
  "セ4-2": {
    "goto": "セ4-4",
  },
  "セ4-3": {
    "goto": "セ4-4",
  },
  "セ4-4": {
    "choices": [
      {
        "eng": "…All right. Let’s cooperate.",
        "jp": "……分かった、手を組もう。",
        "then": {
          "goto": "セ4-18",
        },
      },
      {
        "eng": "…I’m sorry, but I can’t.",
        "jp": "……悪いが、組めない。",
        "then": {
          "goto": "セ4-5",
        },
      },
    ],
  },
  "セ4-5": {
    "goto": "凛4-3",
  },
  "セ4-6": {
    "choices": [
      {
        "eng": "Which heroine is Saber?",
        "jp": "セイバーは何処の英雄なのか？",
        "then": {
          "goto": "セ4-8",
        },
      },
      {
        "eng": "Is she all right?",
        "jp": "体は大丈夫なのか？",
        "then": {
          "goto": "セ4-7",
        },
      },
      {
        "eng": "…Where did you get those clothes?",
        "jp": "……その服、どうしたのさ。",
        "then": {
          "goto": "セ4-9",
        },
      },
    ],
  },
  "セ4-7": {
    "goto": "セ4-10",
  },
  "セ4-8": {
    "goto": "セ4-11",
  },
  "セ4-9": {
    "update": [
      "セイバー好感度+=1",
    ],
    "goto": "セ4-10",
  },
  "セ4-10": {
    "goto": "セ4-11",
  },
  "セ4-11": {
    "goto": "セ4-12",
  },
  "セ4-12": {
    "goto": "セ4-15",
  },
  "セ4-15": {
    "goto": "セ5-0",
  },
  "セ4-18": {
    "goto": "セ4-6",
  },
  "セ5-0": {
    "goto": "セ5-4",
  },
  "セ5-4": {
    "goto": "セ5-5",
  },
  "セ5-5": {
    "choices": [
      {
        "eng": "Go and meet Tohsaka as arranged.",
        "jp": "遠坂との待ち合わせ場所へ。",
        "then": {
          "goto": "セ5-6",
        },
      },
      {
        "eng": "Explain things to Sakura.",
        "jp": "桜に、きちんと説明する。",
        "then": {
          "goto": "セ5-7",
        },
      },
    ],
  },
  "セ5-6": {
    "update": [
      "凛好感度+=1",
    ],
    "goto": "セ5-8",
  },
  "セ5-7": {
    "update": [
      "凛好感度-=1",
    ],
    "goto": "セ5-8",
  },
  "セ5-8": {
    "choices": [
      {
        "eng": "About Lancer.",
        "jp": "ランサーについて。",
        "then": {
          "goto": "セ5-9",
        },
      },
      {
        "eng": "About Archer.",
        "jp": "アーチャーについて。",
        "then": {
          "goto": "セ5-10",
        },
      },
      {
        "eng": "About Berserker.",
        "jp": "バーサーカーについて。",
        "then": {
          "goto": "セ5-11",
        },
      },
    ],
  },
  "セ5-9": {
    "goto": "セ5-12",
  },
  "セ5-10": {
    "goto": "セ5-12",
  },
  "セ5-11": {
    "goto": "セ5-12",
  },
  "セ5-12": {
    "goto": "セ5-14",
  },
  "セ5-14": {
    "goto": "セ6-12",
  },
  "セ6-0": {
    "goto": "セ6-1",
  },
  "セ6-1": {
    "choices": [
      {
        "eng": "Talk to Rider.",
        "jp": "ライダーに話しかける。",
        "then": {
          "goto": "セ6-3",
        },
      },
      {
        "eng": "…Keep away from dangerous things.",
        "jp": "……危うきに近寄らず。",
        "then": {
          "goto": "セ6-4",
        },
      },
    ],
  },
  "セ6-3": {
    "goto": "セ6-13",
  },
  "セ6-4": {
    "goto": "セ6-13",
  },
  "セ6-5": {
    "choices": [
      {
        "eng": "Fight.",
        "jp": "戦う。",
        "then": {
          "goto": "セ6-6",
        },
      },
      {
        "eng": "Don’t fight.",
        "jp": "戦わない。",
        "then": {
          "goto": "セ6-7",
        },
      },
    ],
  },
  "セ6-6": {
    "goto": "セ6-15",
  },
  "セ6-7": {
    "goto": "セ6-8",
  },
  "セ6-8": {
    "goto": "セ6-9",
  },
  "セ6-9": {
    "goto": "セ6-14",
  },
  "セ6-10": {
    "goto": "セ7-0",
  },
  "セ6-12": {
    "goto": "セ6-0",
  },
  "セ6-13": {
    "goto": "セ6-5",
  },
  "セ6-14": {
    "goto": "セ6-10",
  },
  "セ6-15": {},
  "セ7-0": {
    "goto": "セ7-2",
  },
  "セ7-1": {
    "goto": "セ7-3",
  },
  "セ7-2": {
    "choices": [
      {
        "eng": "Her reason for fighting. I want to know why she seeks the Holy Grail.",
        "jp": "戦う理由。聖杯を求める理由が知りたい。",
        "then": {
          "goto": "セ7-4",
        },
      },
      {
        "eng": "I want to know about Saber before she became a Servant.",
        "jp": "サーヴァントになる前のセイバーを知りたい。",
        "then": {
          "goto": "セ7-5",
        },
      },
      {
        "eng": "I want a secret attack. A super move would be great.",
        "jp": "切り札がほしい。必殺剣とか、いいね。",
        "then": {
          "goto": "セ7-6",
        },
      },
    ],
  },
  "セ7-3": {
    "goto": "セ7-8",
  },
  "セ7-4": {
    "update": [
      "質問１=1",
      "セイバー好感度+=2",
    ],
    "goto": "セ7-7",
  },
  "セ7-5": {
    "update": [
      "セイバー好感度+=1",
      "質問２=1",
    ],
    "goto": "セ7-7",
  },
  "セ7-6": {
    "update": [
      "質問３=1",
    ],
    "goto": "セ7-7",
  },
  "セ7-7": {
    "goto": "セ7-28",
  },
  "セ7-8": {
    "conditions": [
      {
        "if": "質問１==1",
        "then": {
          "choices": [
            {
              "eng": "I want to know about Saber before she became a Servant.",
              "jp": "サーヴァントになる前のセイバーが知りたい。",
              "then": {
                "goto": "セ7-12",
              },
            },
            {
              "eng": "A super move even a monkey could understand.",
              "jp": "サルでも分かる必殺剣。",
              "then": {
                "goto": "セ7-13",
              },
            },
          ],
        },
      },
      {
        "if": "質問２==1",
        "then": {
          "choices": [
            {
              "eng": "I want to know why Saber is fighting.",
              "jp": "セイバーが戦う理由が知りたい。",
              "then": {
                "goto": "セ7-14",
              },
            },
            {
              "eng": "A super move even a crab can use.",
              "jp": "カニでも使える必殺剣。",
              "then": {
                "goto": "セ7-15",
              },
            },
          ],
        },
      },
      {
        "if": "質問３==1",
        "then": {
          "choices": [
            {
              "eng": "I want to know why Saber is fighting.",
              "jp": "セイバーの戦う理由が知りたい。",
              "then": {
                "goto": "セ7-16",
              },
            },
            {
              "eng": "I want to know about Saber before she became a Servant.",
              "jp": "サーヴァントになる前のセイバーを知りたい。",
              "then": {
                "goto": "セ7-17",
              },
            },
          ],
        },
      },
    ],
  },
  "セ7-12": {
    "update": [
      "セイバー好感度+=1",
      "質問２=1",
    ],
    "goto": "セ7-18",
  },
  "セ7-13": {
    "goto": "セ7-18",
  },
  "セ7-14": {
    "update": [
      "セイバー好感度+=2",
      "質問１=1",
    ],
    "goto": "セ7-18",
  },
  "セ7-15": {
    "goto": "セ7-18",
  },
  "セ7-16": {
    "update": [
      "セイバー好感度+=2",
      "質問１=1",
    ],
    "goto": "セ7-18",
  },
  "セ7-17": {
    "update": [
      "セイバー好感度+=1",
      "質問２=1",
    ],
    "goto": "セ7-18",
  },
  "セ7-18": {
    "choices": [
      {
        "eng": "Go straight home.",
        "jp": "衛宮邸にまっすぐ帰る。",
        "then": {
          "goto": "セ7-19",
        },
      },
      {
        "eng": "Go and visit the park.",
        "jp": "公園に寄っていく。",
        "then": {
          "goto": "セ7-20",
        },
      },
    ],
  },
  "セ7-19": {
    "update": [
      "セイバー好感度+=1",
    ],
    "goto": "セ7-29",
  },
  "セ7-20": {
    "update": [
      "イリヤ好感度+=1",
    ],
    "goto": "セ7-29",
  },
  "セ7-21": {
    "choices": [
      {
        "eng": "Fuji-Nee, where’s my gift?",
        "jp": "藤ねえ、おみやげは？",
        "then": {
          "goto": "セ7-22",
        },
      },
      {
        "eng": "…She might really get me to make a pie. I’ll stay away for a while.",
        "jp": "……本気でパイを作らされかねない。しばらく退避しよう。",
        "then": {
          "goto": "セ7-24",
        },
      },
      {
        "eng": "Apples won’t do. Eat some Mandarins, Fuji-Nee.",
        "jp": "林檎とかはいい。藤ねえ、蜜柑を食べるんだ。",
        "then": {
          "goto": "セ7-23",
        },
      },
    ],
  },
  "セ7-22": {
    "goto": "セ7-25",
  },
  "セ7-23": {
    "goto": "セ7-25",
  },
  "セ7-24": {
    "goto": "セ7-25",
  },
  "セ7-25": {
    "goto": "セ7-27",
  },
  "セ7-27": {
    "goto": "セ9-15",
  },
  "セ7-28": {
    "goto": "セ7-1",
  },
  "セ7-29": {
    "goto": "セ7-21",
  },
  "セ9-0": {
    "choices": [
      {
        "eng": "Go and get Tohsaka.",
        "jp": "遠坂を呼びに行く。",
        "then": {
          "goto": "セ9-1",
        },
      },
      {
        "eng": "Wait quietly.",
        "jp": "大人しく待つ。",
        "then": {
          "goto": "セ9-2",
        },
      },
    ],
  },
  "セ9-1": {
    "goto": "セ9-3",
  },
  "セ9-2": {
    "goto": "セ9-3",
  },
  "セ9-3": {
    "choices": [
      {
        "eng": "There’s no need to stop…!",
        "jp": "止まる必要などない……！",
        "then": {
          "goto": "セ9-4",
        },
      },
      {
        "eng": "I can’t block it myself…!",
        "jp": "自分では防げない……！",
        "then": {
          "goto": "セ9-5",
        },
      },
    ],
  },
  "セ9-4": {
    "goto": "セ9-6",
  },
  "セ9-5": {
    "goto": "セ9-6",
  },
  "セ9-6": {
    "choices": [
      {
        "eng": "Beat her before I get beaten…!",
        "jp": "倒される前に倒す……！",
        "then": {
          "goto": "セ9-7",
        },
      },
      {
        "eng": "…I can’t match her.",
        "jp": "……戦いになどならない。",
        "then": {
          "goto": "セ9-8",
        },
      },
    ],
  },
  "セ9-7": {
    "goto": "セ9-16",
  },
  "セ9-8": {
    "choices": [
      {
        "eng": "Summon Saber…!",
        "jp": "セイバーを召喚する……！",
        "then": {
          "goto": "セ9-9",
        },
      },
      {
        "eng": "If I can get Saber to help me…!",
        "jp": "セイバーに助けて貰えば……！",
        "then": {
          "goto": "セ9-10",
        },
      },
      {
        "eng": "No, I can’t use my Command Spell…!",
        "jp": "ダメだ、令呪は消費できない……！",
        "then": {
          "goto": "セ9-11",
        },
      },
    ],
  },
  "セ9-9": {
    "update": [
      "セイバー好感度+=2",
    ],
    "goto": "セ9-12",
  },
  "セ9-10": {
    "goto": "セ9-12",
  },
  "セ9-11": {
    "goto": "セ9-17",
  },
  "セ9-12": {
    "goto": "セ9-14",
  },
  "セ9-14": {
    "goto": "セ10-0",
  },
  "セ9-15": {
    "goto": "セ9-0",
  },
  "セ9-16": {},
  "セ9-17": {},
  "プ-1": {
    "goto": "プ-2",
  },
  "プ-2": {
    "goto": "プ-3",
  },
  "プ-3": {
    "goto": "セ1-0",
  },
  "凛10-0": {
    "choices": [
      {
        "eng": "I have to talk to Tohsaka.",
        "jp": "いや、遠坂と話をつけないと。",
        "then": {
          "goto": "凛10-1",
        },
      },
      {
        "eng": "I’ll go talk to Saber at the dojo.",
        "jp": "道場でセイバーと話をつけよう。",
        "then": {
          "goto": "凛10-2",
        },
      },
      {
        "eng": "I’ll pass since it’s cold. Mandarin, mandarin, mandarin.",
        "jp": "寒いのでパス。ミカンミカンミカン。",
        "then": {
          "goto": "凛10-3",
        },
      },
    ],
  },
  "凛10-1": {
    "update": [
      "凛好感度+=1",
    ],
    "goto": "凛10-4",
  },
  "凛10-2": {
    "update": [
      "セイバー好感度+=1",
    ],
    "goto": "凛10-4",
  },
  "凛10-3": {
    "goto": "凛10-4",
  },
  "凛10-4": {
    "goto": "凛10-8",
  },
  "凛10-6": {
    "goto": "凛10-7",
  },
  "凛10-7": {
    "goto": "凛10-0",
  },
  "凛10-8": {
    "goto": "凛11-0",
  },
  "凛11-0": {
    "choices": [
      {
        "eng": "I’ll just make Japanese food. Actually, I’ll take it out on the culprit.",
        "jp": "パンがないので今朝は和風で。というか犯人をとっちめに行く。",
        "then": {
          "goto": "凛11-1",
        },
      },
      {
        "eng": "…I won’t question it. I’ll jog to the shopping district.",
        "jp": "……パンの使い道はあえて不問。ジョギングがてらに商店街へ。",
        "then": {
          "goto": "凛11-2",
        },
      },
    ],
  },
  "凛11-1": {
    "choices": [
      {
        "eng": "Look inside.",
        "jp": "中の様子を見る。",
        "then": {
          "goto": "凛11-3",
        },
      },
      {
        "eng": "Well, I guess Tohsaka’s all right.",
        "jp": "ま、遠坂なら大丈夫だろう。",
        "then": {
          "goto": "凛11-9",
        },
      },
    ],
  },
  "凛11-2": {
    "goto": "凛11-10",
  },
  "凛11-3": {
    "goto": "凛11-11",
  },
  "凛11-4": {
    "goto": "凛11-8",
  },
  "凛11-5": {
    "goto": "凛11-17",
  },
  "凛11-6": {
    "goto": "凛11-12",
  },
  "凛11-8": {
    "choices": [
      {
        "eng": "Refuse.",
        "jp": "断る。",
        "then": {
          "goto": "凛11-6",
        },
      },
      {
        "eng": "Obey.",
        "jp": "従う。",
        "then": {
          "goto": "凛11-5",
        },
      },
    ],
  },
  "凛11-9": {
    "goto": "凛11-10",
  },
  "凛11-10": {
    "goto": "凛11-11",
  },
  "凛11-11": {
    "goto": "凛11-4",
  },
  "凛11-12": {
    "goto": "凛11-15",
  },
  "凛11-13": {
    "goto": "凛11-14",
  },
  "凛11-14": {
    "goto": "凛12-14",
  },
  "凛11-15": {
    "goto": "凛11-16",
  },
  "凛11-16": {
    "goto": "凛11-13",
  },
  "凛11-17": {},
  "凛12-0": {
    "choices": [
      {
        "eng": "Meet up with Tohsaka.",
        "jp": "遠坂と合流する。",
        "then": {
          "goto": "凛12-1",
        },
      },
      {
        "eng": "Go to the church for advice.",
        "jp": "教会へ相談に行く。",
        "then": {
          "goto": "凛12-3",
        },
      },
    ],
  },
  "凛12-1": {
    "goto": "凛12-12",
  },
  "凛12-2": {
    "goto": "凛12-16",
  },
  "凛12-3": {
    "choices": [
      {
        "eng": "Run away.",
        "jp": "逃げる。",
        "then": {
          "goto": "凛12-2",
        },
      },
      {
        "eng": "Fight.",
        "jp": "戦う。",
        "then": {
          "goto": "凛12-10",
        },
      },
      {
        "eng": "Try to find an opening.",
        "jp": "隙を見つける。",
        "then": {
          "goto": "凛12-11",
        },
      },
    ],
  },
  "凛12-4": {
    "choices": [
      {
        "eng": "…I’ll go out. I can give Tohsaka an opening now…!",
        "jp": "……いける。今ならキャスターに隙を作れる……！",
        "then": {
          "goto": "凛12-5",
        },
      },
      {
        "eng": "…Not yet. I can’t act so recklessly.",
        "jp": "……まだだ。そんな安易な真似はできない。",
        "then": {
          "goto": "凛12-6",
        },
      },
    ],
  },
  "凛12-5": {
    "goto": "凛12-17",
  },
  "凛12-6": {
    "choices": [
      {
        "eng": "Don’t help her.",
        "jp": "助けない。",
        "then": {
          "goto": "凛12-7",
        },
      },
      {
        "eng": "Help her.",
        "jp": "助ける。",
        "then": {
          "goto": "凛12-8",
        },
      },
    ],
  },
  "凛12-7": {
    "goto": "凛12-8",
  },
  "凛12-8": {
    "goto": "凛12-13",
  },
  "凛12-10": {
    "goto": "凛12-16",
  },
  "凛12-11": {
    "goto": "凛12-16",
  },
  "凛12-12": {
    "goto": "凛12-4",
  },
  "凛12-13": {
    "goto": "凛13-11",
  },
  "凛12-14": {
    "conditions": [
      {
        "if": "凛好感度\u003c=2",
        "then": {
          "goto": "凛12-15",
        },
      },
      {
        "then": {
          "goto": "凛12-0",
        },
      },
    ],
  },
  "凛12-15": {
    "goto": "凛12-3",
  },
  "凛12-16": {},
  "凛12-17": {},
  "凛13-0": {
    "choices": [
      {
        "eng": "I don’t have any plans. We’ll just fight them head-on.",
        "jp": "そんなものはない。正面突破、これあるのみ。",
        "then": {
          "goto": "凛13-1",
        },
      },
      {
        "eng": "We can’t fight them head-on. Is there a secret passage in the church?",
        "jp": "正面突破は却下だ。教会に抜け道とかある？",
        "then": {
          "goto": "凛13-2",
        },
      },
      {
        "eng": "We can’t do this by ourselves. We’ll cooperate with other Masters.",
        "jp": "俺たちだけでは無理だ。他のマスターと協力する。",
        "then": {
          "goto": "凛13-3",
        },
      },
    ],
  },
  "凛13-1": {
    "goto": "凛13-12",
  },
  "凛13-2": {
    "goto": "凛13-12",
  },
  "凛13-3": {
    "goto": "凛13-12",
  },
  "凛13-4": {
    "choices": [
      {
        "eng": "…Restrain myself.",
        "jp": "……自分を押し留める。",
        "then": {
          "goto": "凛13-6",
        },
      },
      {
        "eng": "────Stop the man…!",
        "jp": "────男を止める……！",
        "then": {
          "goto": "凛13-15",
        },
      },
    ],
  },
  "凛13-5": {
    "choices": [
      {
        "eng": "…All right.",
        "jp": "……いいだろう。",
        "then": {
          "goto": "凛13-7",
        },
      },
      {
        "eng": "…I don’t mind, but under one condition.",
        "jp": "……構わないが、一つ条件がある。",
        "then": {
          "goto": "凛13-8",
        },
      },
      {
        "eng": "…I refuse.",
        "jp": "……断る。",
        "then": {
          "goto": "凛13-9",
        },
      },
    ],
  },
  "凛13-6": {
    "update": [
      "不勇の罪=1",
    ],
    "goto": "凛13-17",
  },
  "凛13-7": {
    "goto": "凛13-20",
  },
  "凛13-8": {
    "update": [
      "凛好感度+=1",
    ],
    "goto": "凛13-20",
  },
  "凛13-9": {
    "goto": "凛13-19",
  },
  "凛13-11": {
    "goto": "凛13-0",
  },
  "凛13-12": {
    "goto": "凛13-13",
  },
  "凛13-13": {
    "goto": "凛13-14",
  },
  "凛13-14": {
    "goto": "凛13-21",
  },
  "凛13-15": {
    "goto": "凛13-16",
  },
  "凛13-16": {
    "goto": "凛13-17",
  },
  "凛13-17": {
    "conditions": [
      {
        "if": "不勇の罪==1",
        "then": {
          "goto": "凛13-19",
        },
      },
      {
        "then": {
          "goto": "凛13-18",
        },
      },
    ],
  },
  "凛13-18": {
    "goto": "凛13-5",
  },
  "凛13-19": {
    "goto": "凛13-22",
  },
  "凛13-20": {
    "goto": "凛14-17",
  },
  "凛13-21": {
    "goto": "凛13-4",
  },
  "凛13-22": {},
  "凛14-0": {
    "choices": [
      {
        "eng": "…What’s wrong with stopping them if I can?",
        "jp": "……止められるのなら、止めてはいけないのか。",
        "then": {
          "goto": "凛14-1",
        },
      },
      {
        "eng": "…What good is stopping them?",
        "jp": "……止めて、どうする。",
        "then": {
          "goto": "凛14-2",
        },
      },
    ],
  },
  "凛14-1": {
    "goto": "凛14-3",
  },
  "凛14-2": {
    "goto": "凛14-3",
  },
  "凛14-3": {
    "goto": "凛14-21",
  },
  "凛14-4": {
    "choices": [
      {
        "eng": "Go over strategy with Tohsaka.",
        "jp": "遠坂と作戦を練る。",
        "then": {
          "goto": "凛14-5",
        },
      },
      {
        "eng": "Go to the dojo to check up on Saber.",
        "jp": "セイバーの様子を見に道場へ。",
        "then": {
          "goto": "凛14-6",
        },
      },
      {
        "eng": "Think.",
        "jp": "もう一度、よく考えてみる。",
        "then": {
          "goto": "凛14-7",
        },
      },
    ],
  },
  "凛14-5": {
    "conditions": [
      {
        "if": "ghentai==1",
        "then": {
          "goto": "凛14-108",
        },
      },
      {
        "then": {
          "goto": "凛14-8",
        },
      },
    ],
    "update": [
      "凛好感度+=2",
    ],
  },
  "凛14-6": {
    "conditions": [
      {
        "if": "ghentai==1",
        "then": {
          "goto": "凛14-108",
        },
      },
      {
        "then": {
          "goto": "凛14-8",
        },
      },
    ],
    "update": [
      "セイバー好感度+=1",
    ],
  },
  "凛14-7": {
    "conditions": [
      {
        "if": "ghentai==1",
        "then": {
          "goto": "凛14-108",
        },
      },
      {
        "then": {
          "goto": "凛14-8",
        },
      },
    ],
    "update": [
      "凛好感度+=1",
    ],
  },
  "凛14-8": {
    "goto": "凛14-31",
  },
  "凛14-9": {
    "conditions": [
      {
        "if": "セイバー好感度\u003e=4\u0026\u0026凛好感度\u003c=8",
        "then": {
          "goto": "凛14-10",
        },
      },
      {
        "then": {
          "goto": "凛14-11",
        },
      },
    ],
  },
  "凛14-10": {
    "goto": "凛14-12",
  },
  "凛14-11": {
    "update": [
      "セイバー不在=1",
    ],
    "goto": "凛14-12",
  },
  "凛14-12": {
    "choices": [
      {
        "eng": "…I’ll at least take him with me…!",
        "jp": "……こうなったら、せめて道連れに……！",
        "then": {
          "goto": "凛14-13",
        },
      },
      {
        "eng": "…No way, I can’t give up so easily…!",
        "jp": "……冗談、簡単に諦められるか……！",
        "then": {
          "goto": "凛14-14",
        },
      },
    ],
  },
  "凛14-13": {
    "goto": "凛14-37",
  },
  "凛14-14": {
    "conditions": [
      {
        "if": "セイバー不在!=1",
        "then": {
          "goto": "凛14-15",
        },
      },
      {
        "if": "セイバー不在==1",
        "then": {
          "goto": "凛14-16",
        },
      },
    ],
  },
  "凛14-15": {
    "update": [
      "g凛クリア=1",
      "g凛グッド=1",
    ],
  },
  "凛14-16": {
    "update": [
      "g凛クリア=1",
      "g凛トゥルー=1",
    ],
  },
  "凛14-17": {
    "goto": "凛14-18",
  },
  "凛14-18": {
    "goto": "凛14-19",
  },
  "凛14-19": {
    "goto": "凛14-20",
  },
  "凛14-20": {
    "goto": "凛14-0",
  },
  "凛14-21": {
    "goto": "凛14-22",
  },
  "凛14-22": {
    "goto": "凛14-23",
  },
  "凛14-23": {
    "goto": "凛14-24",
  },
  "凛14-24": {
    "goto": "凛14-25",
  },
  "凛14-25": {
    "goto": "凛14-26",
  },
  "凛14-26": {
    "goto": "凛14-27",
  },
  "凛14-27": {
    "goto": "凛14-28",
  },
  "凛14-28": {
    "goto": "凛14-29",
  },
  "凛14-29": {
    "goto": "凛14-4",
  },
  "凛14-31": {
    "goto": "凛14-32",
  },
  "凛14-32": {
    "goto": "凛14-33",
  },
  "凛14-33": {
    "goto": "凛14-34",
  },
  "凛14-34": {
    "goto": "凛14-35",
  },
  "凛14-35": {
    "goto": "凛14-36",
  },
  "凛14-36": {
    "goto": "凛14-9",
  },
  "凛14-37": {},
  "凛14-108": {
    "goto": "凛14-130",
  },
  "凛14-130": {
    "goto": "凛14-31",
  },
  "凛3-0": {
    "choices": [
      {
        "eng": "…Stay here.",
        "jp": "……この場に残る。",
        "then": {
          "goto": "凛3-1",
        },
      },
      {
        "eng": "…Follow them.",
        "jp": "……後を追う。",
        "then": {
          "goto": "凛3-3",
        },
      },
      {
        "eng": "Do as Tohsaka said.",
        "jp": "遠坂の言葉に従う。",
        "then": {
          "goto": "凛3-2",
        },
      },
    ],
  },
  "凛3-1": {
    "choices": [
      {
        "eng": "…Don’t go.",
        "jp": "……この場に残る。",
        "then": {
          "goto": "凛3-4",
        },
      },
      {
        "eng": "…Head to the graveyard.",
        "jp": "……墓地に向かう。",
        "then": {
          "goto": "凛3-5",
        },
      },
    ],
  },
  "凛3-2": {
    "goto": "凛3-12",
  },
  "凛3-3": {
    "choices": [
      {
        "eng": "Call back Saber.",
        "jp": "セイバーを呼び戻す。",
        "then": {
          "goto": "凛3-6",
        },
      },
      {
        "eng": "Bring back Saber.",
        "jp": "セイバーを連れ戻す。",
        "then": {
          "goto": "凛3-7",
        },
      },
    ],
  },
  "凛3-4": {
    "goto": "凛3-12",
  },
  "凛3-5": {
    "goto": "凛3-6",
  },
  "凛3-6": {
    "goto": "凛4-0",
  },
  "凛3-7": {
    "goto": "凛4-0",
  },
  "凛3-9": {
    "goto": "凛3-10",
  },
  "凛3-10": {
    "goto": "凛3-11",
  },
  "凛3-11": {
    "goto": "凛3-0",
  },
  "凛3-12": {},
  "凛4-0": {
    "conditions": [
      {
        "if": "自然治癒を知らない==1",
        "then": {
          "goto": "凛4-1",
        },
      },
      {
        "if": "自然治癒を知らない!=1",
        "then": {
          "goto": "凛4-2",
        },
      },
    ],
  },
  "凛4-1": {
    "goto": "凛4-10",
  },
  "凛4-2": {
    "goto": "凛4-10",
  },
  "凛4-3": {
    "choices": [
      {
        "eng": "Stay at the archery range.",
        "jp": "このまま弓道場にいる。",
        "then": {
          "goto": "凛4-4",
        },
      },
      {
        "eng": "Go to the student council room.",
        "jp": "生徒会室に移動する。",
        "then": {
          "goto": "凛4-5",
        },
      },
      {
        "eng": "Show Saber around school.",
        "jp": "セイバーに学校案内をする。",
        "then": {
          "goto": "凛4-6",
        },
      },
    ],
  },
  "凛4-4": {
    "goto": "凛4-7",
  },
  "凛4-5": {
    "goto": "凛4-7",
  },
  "凛4-6": {
    "goto": "凛4-7",
  },
  "凛4-7": {
    "conditions": [
      {
        "if": "ソロ==1",
        "then": {
          "goto": "凛4-12",
        },
      },
      {
        "then": {
          "goto": "凛4-9",
        },
      },
    ],
  },
  "凛4-9": {
    "goto": "凛4-11",
  },
  "凛4-10": {
    "goto": "凛4-3",
  },
  "凛4-11": {
    "goto": "凛5-0",
  },
  "凛4-12": {
    "goto": "凛5-0",
  },
  "凛5-0": {
    "choices": [
      {
        "eng": "I’ll go see how Saber’s doing.",
        "jp": "セイバーの様子を見に行こう。",
        "then": {
          "goto": "凛5-1",
        },
      },
      {
        "eng": "I’ll go and help Sakura.",
        "jp": "桜の手伝いをしに行こう。",
        "then": {
          "goto": "凛5-2",
        },
      },
      {
        "eng": "I’ll go and wake Fuji-Nee up.",
        "jp": "藤ねえを起こしに行こう。",
        "then": {
          "goto": "凛5-3",
        },
      },
    ],
  },
  "凛5-1": {
    "update": [
      "セイバー好感度+=1",
    ],
    "goto": "凛5-20",
  },
  "凛5-2": {
    "goto": "凛5-20",
  },
  "凛5-3": {
    "goto": "凛5-20",
  },
  "凛5-4": {
    "choices": [
      {
        "eng": "Jump to the stairs…!",
        "jp": "階段に飛び込む……！",
        "then": {
          "goto": "凛5-5",
        },
      },
      {
        "eng": "Jump back to the hallway…!",
        "jp": "廊下に跳び退く……！",
        "then": {
          "goto": "凛5-6",
        },
      },
    ],
  },
  "凛5-5": {
    "goto": "凛5-25",
  },
  "凛5-6": {
    "choices": [
      {
        "eng": "Can I hand her my Command Spell…?",
        "jp": "令呪を差し出していいのか……？",
        "then": {
          "update": [
            "凛好感度-=1",
          ],
          "goto": "凛5-9",
        },
      },
      {
        "eng": "Can I admit defeat against Tohsaka…?",
        "jp": "遠坂に負けを認めていいのか……？",
        "then": {
          "update": [
            "凛好感度+=1",
          ],
          "goto": "凛5-9",
        },
      },
    ],
  },
  "凛5-9": {
    "choices": [
      {
        "eng": "Use the Command Spell.",
        "jp": "令呪を使う。",
        "then": {
          "goto": "凛5-10",
        },
      },
      {
        "eng": "Fight using my remaining left arm…!",
        "jp": "残った左手で応戦する……！",
        "then": {
          "goto": "凛5-11",
        },
      },
      {
        "eng": "I can pull out this “nail” in my right arm…!",
        "jp": "右手に刺さった“釘”を抜けば……！",
        "then": {
          "goto": "凛5-12",
        },
      },
    ],
  },
  "凛5-10": {
    "goto": "凛5-26",
  },
  "凛5-11": {
    "goto": "凛5-13",
  },
  "凛5-12": {
    "goto": "凛5-13",
  },
  "凛5-13": {
    "conditions": [
      {
        "if": "自然治癒を知らない==1",
        "then": {
          "goto": "凛5-14",
        },
      },
      {
        "if": "自然治癒を知らない!=1",
        "then": {
          "goto": "凛5-15",
        },
      },
    ],
  },
  "凛5-14": {
    "goto": "凛5-22",
  },
  "凛5-15": {
    "goto": "凛5-22",
  },
  "凛5-16": {
    "choices": [
      {
        "eng": "I can’t say for sure.",
        "jp": "断言はできない",
        "then": {
          "goto": "凛5-17",
        },
      },
      {
        "eng": "I guess that’s how it’ll be.",
        "jp": "そういう事になるな",
        "then": {
          "goto": "凛5-18",
        },
      },
    ],
  },
  "凛5-17": {
    "goto": "凛6-13",
  },
  "凛5-18": {
    "goto": "凛6-13",
  },
  "凛5-20": {
    "conditions": [
      {
        "if": "ソロ==1",
        "then": {
          "goto": "凛5-27",
        },
      },
      {
        "then": {
          "goto": "凛5-21",
        },
      },
    ],
  },
  "凛5-21": {
    "goto": "凛5-4",
  },
  "凛5-22": {
    "goto": "凛5-23",
  },
  "凛5-23": {
    "goto": "凛5-24",
  },
  "凛5-24": {
    "goto": "凛5-16",
  },
  "凛5-25": {},
  "凛5-26": {},
  "凛5-27": {
    "goto": "凛5-5",
  },
  "凛6-0": {
    "choices": [
      {
        "eng": "I’ll stop Fuji-Nee’s wrongdoing before the sun sets.",
        "jp": "日が沈んで夕飯になる前に、藤ねえの悪行を止めておこう。",
        "then": {
          "goto": "凛6-1",
        },
      },
      {
        "eng": "I’ll go see how Sakura’s doing before the sun sets.",
        "jp": "日が沈んで夕飯になる前に、桜の様子を見てこよう。",
        "then": {
          "goto": "凛6-2",
        },
      },
      {
        "eng": "I’ll go tell Saber that I’m home before the sun sets.",
        "jp": "日が沈んで夕飯になる前に、セイバーに帰宅を報告しに行こう。",
        "then": {
          "goto": "凛6-3",
        },
      },
    ],
  },
  "凛6-1": {
    "goto": "凛6-5",
  },
  "凛6-2": {
    "goto": "凛6-4",
  },
  "凛6-3": {
    "goto": "凛6-4",
  },
  "凛6-4": {
    "goto": "凛6-6",
  },
  "凛6-5": {
    "goto": "凛6-6",
  },
  "凛6-6": {
    "goto": "凛6-14",
  },
  "凛6-8": {
    "goto": "凛6-9",
  },
  "凛6-9": {
    "goto": "凛6-10",
  },
  "凛6-10": {
    "goto": "凛6-0",
  },
  "凛6-11": {
    "goto": "凛6-12",
  },
  "凛6-12": {
    "goto": "凛7-11",
  },
  "凛6-13": {
    "goto": "凛6-8",
  },
  "凛6-14": {
    "goto": "凛6-11",
  },
  "凛7-0": {
    "choices": [
      {
        "eng": "…She’s after me. I’ll give up and go out there.",
        "jp": "……あいつの狙いは俺だ。大人しく出て行こう。",
        "then": {
          "goto": "凛7-1",
        },
      },
      {
        "eng": "…She’s after me. I don’t want to die, so I’ll keep quiet.",
        "jp": "……あいつの狙いは俺だ。死にたくないから黙っていよう。",
        "then": {
          "goto": "凛7-2",
        },
      },
      {
        "eng": "…Who’s she after? I don’t know, so I’ll play dumb.",
        "jp": "……あいつの狙いは誰だ。分からないからとぼけよう。",
        "then": {
          "goto": "凛7-3",
        },
      },
    ],
  },
  "凛7-1": {
    "goto": "凛7-12",
  },
  "凛7-2": {
    "goto": "凛7-12",
  },
  "凛7-3": {
    "goto": "凛7-12",
  },
  "凛7-4": {
    "choices": [
      {
        "eng": "Search for Shinji with the two of us.",
        "jp": "二人で慎二を捜す。",
        "then": {
          "goto": "凛7-5",
        },
      },
      {
        "eng": "Use the Command Spell to call for Saber.",
        "jp": "令呪を使用してセイバーを呼ぶ。",
        "then": {
          "goto": "凛7-6",
        },
      },
    ],
  },
  "凛7-5": {
    "goto": "凛7-8",
  },
  "凛7-6": {
    "update": [
      "凛好感度+=2",
    ],
    "goto": "凛7-8",
  },
  "凛7-7": {
    "goto": "凛8-9",
  },
  "凛7-8": {
    "goto": "凛7-9",
  },
  "凛7-9": {
    "goto": "凛7-7",
  },
  "凛7-11": {
    "goto": "凛7-0",
  },
  "凛7-12": {
    "goto": "凛7-4",
  },
  "凛8-0": {
    "choices": [
      {
        "eng": "…I guess I’ll ask him.",
        "jp": "……一応、話を聞いてみる。",
        "then": {
          "goto": "凛8-1",
        },
      },
      {
        "eng": "…It’ll be pointless, so I guess I won’t ask.",
        "jp": "……無駄だろうし、止めておこう。",
        "then": {
          "goto": "凛8-10",
        },
      },
    ],
  },
  "凛8-1": {
    "goto": "凛8-12",
  },
  "凛8-2": {
    "choices": [
      {
        "eng": "I’m worried about Sakura. I’ll go to the Matou household.",
        "jp": "桜が気にかかる。間桐邸に行ってみよう。",
        "then": {
          "goto": "凛8-3",
        },
      },
      {
        "eng": "Oh yeah, I have to contact Tohsaka.",
        "jp": "そうだ、遠坂に連絡しなくては。",
        "then": {
          "goto": "凛8-4",
        },
      },
      {
        "eng": "Meat’s on sale today. I’ll make a huge meal to make Saber happy.",
        "jp": "今日は肉の特売日。ご馳走にしてセイバーを喜ばせよう。",
        "then": {
          "goto": "凛8-5",
        },
      },
    ],
  },
  "凛8-3": {
    "update": [
      "凛好感度+=1",
    ],
    "goto": "凛8-6",
  },
  "凛8-4": {
    "goto": "凛8-6",
  },
  "凛8-5": {
    "update": [
      "セイバー好感度+=1",
    ],
    "goto": "凛8-6",
  },
  "凛8-6": {
    "goto": "凛9-7",
  },
  "凛8-8": {
    "goto": "凛8-0",
  },
  "凛8-9": {
    "goto": "凛8-8",
  },
  "凛8-10": {
    "goto": "凛8-11",
  },
  "凛8-11": {
    "goto": "凛8-2",
  },
  "凛8-12": {},
  "凛9-0": {
    "choices": [
      {
        "eng": "It’s too dangerous. Stop Tohsaka.",
        "jp": "やっぱり危険だ。遠坂を止める。",
        "then": {
          "goto": "凛9-1",
        },
      },
      {
        "eng": "…I guess that’s the only option.",
        "jp": "……今はそれしかない。",
        "then": {
          "goto": "凛9-2",
        },
      },
    ],
  },
  "凛9-1": {
    "goto": "凛9-12",
  },
  "凛9-2": {
    "update": [
      "凛好感度+=1",
    ],
    "goto": "凛9-12",
  },
  "凛9-3": {
    "choices": [
      {
        "eng": "Go help Saber……!",
        "jp": "セイバーの助けに入る……！",
        "then": {
          "goto": "凛9-4",
        },
      },
      {
        "eng": "Protect Tohsaka……!",
        "jp": "遠坂を守りきる……！",
        "then": {
          "goto": "凛9-5",
        },
      },
    ],
  },
  "凛9-4": {
    "goto": "凛9-14",
  },
  "凛9-5": {
    "goto": "凛9-13",
  },
  "凛9-7": {
    "goto": "凛9-8",
  },
  "凛9-8": {
    "goto": "凛9-0",
  },
  "凛9-9": {
    "goto": "凛9-3",
  },
  "凛9-10": {
    "goto": "凛9-11",
  },
  "凛9-11": {
    "goto": "凛10-6",
  },
  "凛9-12": {
    "goto": "凛9-9",
  },
  "凛9-13": {
    "goto": "凛9-10",
  },
  "凛9-14": {},
  "桜10-0": {
    "choices": [
      {
        "eng": "I really like her.",
        "jp": "かなり好き。",
        "then": {
          "goto": "桜10-1",
        },
      },
      {
        "eng": "I really find her hard to deal with.",
        "jp": "かなり苦手。",
        "then": {
          "goto": "桜10-2",
        },
      },
      {
        "eng": "More importantly, do you want something to eat, Rider?",
        "jp": "それよりライダー、ごはんは？",
        "then": {
          "goto": "桜10-3",
        },
      },
    ],
  },
  "桜10-1": {
    "update": [
      "桜好感度+=1",
    ],
    "goto": "桜10-4",
  },
  "桜10-2": {
    "goto": "桜10-4",
  },
  "桜10-3": {
    "update": [
      "桜好感度+=1",
    ],
    "goto": "桜10-4",
  },
  "桜10-4": {
    "goto": "桜10-7",
  },
  "桜10-5": {
    "goto": "桜10-8",
  },
  "桜10-6": {
    "goto": "桜10-0",
  },
  "桜10-7": {
    "goto": "桜10-5",
  },
  "桜10-8": {
    "choices": [
      {
        "eng": "…I should stay here.",
        "jp": "……この場に残るべきだ。",
        "then": {
          "goto": "桜10-10",
        },
      },
      {
        "eng": "I should go see what’s going on.",
        "jp": "急いで様子を見に行くべきだ。",
        "then": {
          "goto": "桜10-9",
        },
      },
    ],
  },
  "桜10-9": {
    "goto": "桜10-12",
  },
  "桜10-10": {
    "goto": "桜10-34",
  },
  "桜10-11": {
    "goto": "桜10-19",
  },
  "桜10-12": {
    "goto": "桜10-11",
  },
  "桜10-13": {
    "choices": [
      {
        "eng": "Bring back Tohsaka…!",
        "jp": "遠坂を連れ戻す……！",
        "then": {
          "goto": "桜10-15",
        },
      },
      {
        "eng": "Protect Illya…!",
        "jp": "イリヤを守りきる……！",
        "then": {
          "goto": "桜10-14",
        },
      },
    ],
  },
  "桜10-14": {
    "goto": "桜10-28",
  },
  "桜10-15": {
    "goto": "桜10-35",
  },
  "桜10-16": {
    "choices": [
      {
        "eng": "I guess Tohsaka.",
        "jp": "遠坂、かな？",
        "then": {
          "goto": "桜10-17",
        },
      },
      {
        "eng": "I guess Illya.",
        "jp": "イリヤ、かな？",
        "then": {
          "goto": "桜10-18",
        },
      },
    ],
  },
  "桜10-17": {
    "update": [
      "凛好感度+=1",
    ],
    "goto": "桜10-30",
  },
  "桜10-18": {
    "update": [
      "イリヤ好感度+=1",
    ],
    "goto": "桜10-30",
  },
  "桜10-19": {
    "goto": "桜10-13",
  },
  "桜10-20": {
    "conditions": [
      {
        "if": "イリヤ、衛宮邸体験した==1",
        "then": {
          "goto": "桜10-21",
        },
      },
      {
        "if": "イリヤ、衛宮邸体験した!=1",
        "then": {
          "goto": "桜10-22",
        },
      },
    ],
  },
  "桜10-21": {
    "goto": "桜10-32",
  },
  "桜10-22": {
    "goto": "桜10-32",
  },
  "桜10-23": {
    "choices": [
      {
        "eng": "Release it.",
        "jp": "解く",
        "then": {
          "goto": "桜10-24",
        },
      },
      {
        "eng": "Do not release it.",
        "jp": "解かない",
        "then": {
          "goto": "桜10-25",
        },
      },
    ],
  },
  "桜10-24": {
    "goto": "桜10-26",
  },
  "桜10-25": {
    "goto": "桜10-26",
  },
  "桜10-26": {
    "goto": "桜10-33",
  },
  "桜10-28": {
    "goto": "桜10-29",
  },
  "桜10-29": {
    "goto": "桜10-16",
  },
  "桜10-30": {
    "goto": "桜10-31",
  },
  "桜10-31": {
    "goto": "桜10-20",
  },
  "桜10-32": {
    "goto": "桜10-23",
  },
  "桜10-33": {
    "goto": "桜11-6",
  },
  "桜10-34": {},
  "桜10-35": {},
  "桜11-0": {
    "choices": [
      {
        "eng": "Go check out how Tohsaka and Illya are doing.",
        "jp": "遠坂とイリヤの様子を見に行く。",
        "then": {
          "goto": "桜11-1",
        },
      },
      {
        "eng": "I haven’t seen Rider.",
        "jp": "そういえば、ライダーに会ってないな。",
        "then": {
          "goto": "桜11-2",
        },
      },
      {
        "eng": "No, I’ll go check up on Sakura.",
        "jp": "いや、桜の見舞いを優先しよう。",
        "then": {
          "goto": "桜11-3",
        },
      },
    ],
  },
  "桜11-1": {
    "goto": "桜11-4",
  },
  "桜11-2": {
    "update": [
      "桜好感度+=1",
    ],
    "goto": "桜11-4",
  },
  "桜11-3": {
    "update": [
      "桜好感度+=1",
    ],
    "goto": "桜11-4",
  },
  "桜11-4": {
    "goto": "桜11-11",
  },
  "桜11-6": {
    "goto": "桜11-7",
  },
  "桜11-7": {
    "goto": "桜11-8",
  },
  "桜11-8": {
    "goto": "桜11-9",
  },
  "桜11-9": {
    "goto": "桜11-10",
  },
  "桜11-10": {
    "goto": "桜11-0",
  },
  "桜11-11": {
    "goto": "桜11-12",
  },
  "桜11-12": {
    "goto": "桜11-13",
  },
  "桜11-13": {
    "goto": "桜11-14",
  },
  "桜11-14": {
    "conditions": [
      {
        "if": "ghentai==1",
        "then": {
          "goto": "桜11-115",
        },
      },
      {
        "then": {
          "goto": "桜11-15",
        },
      },
    ],
  },
  "桜11-15": {
    "goto": "桜11-16",
  },
  "桜11-16": {
    "goto": "桜12-5",
  },
  "桜11-115": {
    "goto": "桜11-16",
  },
  "桜12-0": {
    "choices": [
      {
        "eng": "…I nod.",
        "jp": "……首を縦に振った。",
        "then": {
          "goto": "桜12-1",
        },
      },
      {
        "eng": "…No, I can’t do that.",
        "jp": "……駄目だ、それだけは出来ない……。",
        "then": {
          "goto": "桜12-2",
        },
      },
    ],
  },
  "桜12-1": {
    "goto": "桜12-3",
  },
  "桜12-2": {
    "update": [
      "不断の咎=1",
    ],
    "goto": "桜12-3",
  },
  "桜12-3": {
    "conditions": [
      {
        "if": "不断の咎==1",
        "then": {
          "goto": "桜12-8",
        },
      },
      {
        "then": {
          "goto": "桜12-7",
        },
      },
    ],
  },
  "桜12-5": {
    "goto": "桜12-6",
  },
  "桜12-6": {
    "goto": "桜12-0",
  },
  "桜12-7": {
    "goto": "桜12-8",
  },
  "桜12-8": {
    "goto": "桜12-9",
  },
  "桜12-9": {
    "goto": "桜12-10",
  },
  "桜12-10": {
    "goto": "桜12-11",
  },
  "桜12-11": {
    "goto": "桜12-12",
  },
  "桜12-12": {
    "conditions": [
      {
        "if": "ghentai==1",
        "then": {
          "goto": "桜12-113",
        },
      },
      {
        "then": {
          "goto": "桜12-13",
        },
      },
    ],
  },
  "桜12-13": {
    "goto": "桜12-14",
  },
  "桜12-14": {
    "goto": "桜13-8",
  },
  "桜12-113": {
    "goto": "桜12-14",
  },
  "桜13-0": {
    "choices": [
      {
        "eng": "Accept.",
        "jp": "受ける。",
        "then": {
          "goto": "桜13-1",
        },
      },
      {
        "eng": "Do not accept.",
        "jp": "受けない。",
        "then": {
          "goto": "桜13-2",
        },
      },
    ],
  },
  "桜13-1": {
    "goto": "桜13-12",
  },
  "桜13-2": {
    "goto": "桜13-15",
  },
  "桜13-3": {
    "conditions": [
      {
        "if": "不断の咎==1||桜好感度\u003c=10",
        "then": {
          "goto": "桜13-5",
        },
      },
      {
        "if": "桜好感度\u003e=11",
        "then": {
          "choices": [
            {
              "eng": "Kill Sakura.",
              "jp": "この手に、かける。",
              "then": {
                "goto": "桜13-5",
              },
            },
            {
              "eng": "…I can’t do that.",
              "jp": "……それだけは、出来ない。",
              "then": {
                "goto": "桜13-6",
              },
            },
          ],
        },
      },
    ],
  },
  "桜13-5": {
    "goto": "桜13-16",
  },
  "桜13-6": {
    "goto": "桜13-14",
  },
  "桜13-8": {
    "goto": "桜13-9",
  },
  "桜13-9": {
    "goto": "桜13-10",
  },
  "桜13-10": {
    "goto": "桜13-11",
  },
  "桜13-11": {
    "goto": "桜13-0",
  },
  "桜13-12": {
    "goto": "桜13-13",
  },
  "桜13-13": {
    "goto": "桜13-3",
  },
  "桜13-14": {
    "goto": "桜14-0",
  },
  "桜13-15": {},
  "桜13-16": {},
  "桜14-0": {
    "goto": "桜14-2",
  },
  "桜14-1": {
    "conditions": [
      {
        "if": "gmature==1",
        "then": {
          "goto": "桜14-110",
        },
      },
      {
        "then": {
          "goto": "桜14-10",
        },
      },
    ],
  },
  "桜14-2": {
    "goto": "桜14-8",
  },
  "桜14-3": {
    "choices": [
      {
        "eng": "Quickly go back home.",
        "jp": "急いでうちに戻る。",
        "then": {
          "goto": "桜14-4",
        },
      },
      {
        "eng": "I can’t forgive Zouken.",
        "jp": "臓硯を許せない。",
        "then": {
          "goto": "桜14-5",
        },
      },
    ],
  },
  "桜14-4": {
    "update": [
      "イリヤ好感度+=1",
    ],
    "goto": "桜14-6",
  },
  "桜14-5": {
    "goto": "桜14-6",
  },
  "桜14-6": {
    "goto": "桜14-11",
  },
  "桜14-8": {
    "goto": "桜14-9",
  },
  "桜14-9": {
    "goto": "桜14-1",
  },
  "桜14-10": {
    "goto": "桜14-3",
  },
  "桜14-11": {
    "goto": "桜15-0",
  },
  "桜14-110": {
    "goto": "桜14-3",
  },
  "桜15-0": {
    "choices": [
      {
        "eng": "Save Sakura. Bring back Illya.",
        "jp": "桜を助ける。イリヤを連れ戻す。",
        "then": {
          "goto": "桜15-1",
        },
      },
      {
        "eng": "We lost.",
        "jp": "俺たちの負けだ。",
        "then": {
          "goto": "桜15-2",
        },
      },
    ],
  },
  "桜15-1": {
    "choices": [
      {
        "eng": "Refuse.",
        "jp": "断る。",
        "then": {
          "goto": "桜15-3",
        },
      },
      {
        "eng": "Accept.",
        "jp": "頷く。",
        "then": {
          "goto": "桜15-22",
        },
      },
    ],
  },
  "桜15-2": {
    "goto": "桜15-27",
  },
  "桜15-3": {
    "goto": "桜15-28",
  },
  "桜15-4": {
    "choices": [
      {
        "eng": "Bring Illya back.",
        "jp": "イリヤを連れ戻す。",
        "then": {
          "goto": "桜15-5",
        },
      },
      {
        "eng": "Bring Illya back.",
        "jp": "イリヤを連れ戻す。",
        "then": {
          "goto": "桜15-6",
        },
      },
      {
        "eng": "Bring Illya back.",
        "jp": "イリヤを連れ戻す。",
        "then": {
          "goto": "桜15-7",
        },
      },
    ],
  },
  "桜15-5": {
    "goto": "桜15-8",
  },
  "桜15-6": {
    "goto": "桜15-8",
  },
  "桜15-7": {
    "goto": "桜15-8",
  },
  "桜15-8": {
    "goto": "桜15-9",
  },
  "桜15-9": {
    "goto": "桜15-10",
  },
  "桜15-10": {
    "goto": "桜15-11",
  },
  "桜15-11": {
    "goto": "桜15-12",
  },
  "桜15-12": {
    "goto": "桜15-24",
  },
  "桜15-13": {
    "choices": [
      {
        "eng": "Escape out the shed…!",
        "jp": "土蔵の外へ逃げる……！",
        "then": {
          "goto": "桜15-14",
        },
      },
      {
        "eng": "Fight back using projection…!",
        "jp": "投影で抵抗する……！",
        "then": {
          "goto": "桜15-15",
        },
      },
      {
        "eng": "…Give her the answer to the previous question. ",
        "jp": "……いつかの答えを、口にする。",
        "then": {
          "goto": "桜15-16",
        },
      },
    ],
  },
  "桜15-14": {
    "goto": "桜15-20",
  },
  "桜15-15": {
    "goto": "桜15-20",
  },
  "桜15-16": {
    "choices": [
      {
        "eng": "‘Will I be able to fight until the very end’",
        "jp": "『最後まで戦えるか』",
        "then": {
          "goto": "桜15-17",
        },
      },
      {
        "eng": "‘Will I not give up until the very end’",
        "jp": "『最後まで諦めないか』",
        "then": {
          "goto": "桜15-18",
        },
      },
      {
        "eng": "‘Will I be on Sakura’s side until the very end’",
        "jp": "『最後まで桜の味方か』",
        "then": {
          "goto": "桜15-19",
        },
      },
    ],
  },
  "桜15-17": {
    "goto": "桜15-20",
  },
  "桜15-18": {
    "goto": "桜15-20",
  },
  "桜15-19": {
    "goto": "桜15-26",
  },
  "桜15-20": {
    "goto": "桜15-29",
  },
  "桜15-22": {
    "goto": "桜15-23",
  },
  "桜15-23": {
    "goto": "桜15-4",
  },
  "桜15-24": {
    "goto": "桜15-25",
  },
  "桜15-25": {
    "goto": "桜15-13",
  },
  "桜15-26": {
    "goto": "桜16-0",
  },
  "桜15-27": {},
  "桜15-28": {},
  "桜15-29": {},
  "桜16-0": {
    "goto": "桜16-14",
  },
  "桜16-1": {
    "choices": [
      {
        "eng": "Attack Saber…!",
        "jp": "セイバーと打ち合う……！",
        "then": {
          "goto": "桜16-2",
        },
      },
      {
        "eng": "Use another projection…!",
        "jp": "次の投影……！",
        "then": {
          "goto": "桜16-3",
        },
      },
      {
        "eng": "Wait for my chance…!",
        "jp": "まだ機会を待つ……！",
        "then": {
          "goto": "桜16-4",
        },
      },
    ],
  },
  "桜16-2": {
    "goto": "桜16-23",
  },
  "桜16-3": {
    "update": [
      "限界破裂=1",
    ],
    "goto": "桜16-5",
  },
  "桜16-4": {
    "goto": "桜16-5",
  },
  "桜16-5": {
    "choices": [
      {
        "eng": "…Save Saber.",
        "jp": "……セイバーを助ける。",
        "then": {
          "goto": "桜16-7",
        },
      },
      {
        "eng": "…Bring my arm down.",
        "jp": "……この腕を振り下ろす。",
        "then": {
          "goto": "桜16-6",
        },
      },
    ],
  },
  "桜16-6": {
    "goto": "桜16-17",
  },
  "桜16-7": {
    "goto": "桜16-24",
  },
  "桜16-8": {
    "conditions": [
      {
        "if": "限界破裂==1||イリヤ好感度\u003c=3",
        "then": {
          "goto": "桜16-9",
        },
      },
      {
        "then": {
          "goto": "桜16-11",
        },
      },
    ],
  },
  "桜16-9": {
    "update": [
      "g桜ノーマル=1",
    ],
  },
  "桜16-10": {
    "conditions": [
      {
        "if": "g桜トゥルー==1",
        "then": {
          "choices": [
            {
              "eng": "Do it.",
              "jp": "行う。",
              "then": {
                "goto": "桜16-12",
              },
            },
            {
              "eng": "…Is that the way?",
              "jp": "……いいのか、それで。",
              "then": {
                "goto": "桜16-13",
              },
            },
          ],
        },
      },
      {
        "then": {
          "goto": "桜16-13",
        },
      },
    ],
  },
  "桜16-11": {
    "goto": "桜16-21",
  },
  "桜16-12": {
    "update": [
      "g桜ノーマル=1",
    ],
  },
  "桜16-13": {
    "update": [
      "g桜クリア=1",
      "g桜トゥルー=1",
    ],
  },
  "桜16-14": {
    "goto": "桜16-15",
  },
  "桜16-15": {
    "goto": "桜16-16",
  },
  "桜16-16": {
    "goto": "桜16-1",
  },
  "桜16-17": {
    "goto": "桜16-18",
  },
  "桜16-18": {
    "goto": "桜16-19",
  },
  "桜16-19": {
    "goto": "桜16-20",
  },
  "桜16-20": {
    "goto": "桜16-8",
  },
  "桜16-21": {
    "goto": "桜16-22",
  },
  "桜16-22": {
    "goto": "桜16-10",
  },
  "桜16-23": {},
  "桜16-24": {},
  "桜4-0": {
    "goto": "桜4-10",
  },
  "桜4-1": {
    "goto": "桜4-7",
  },
  "桜4-2": {
    "choices": [
      {
        "eng": "Secure the neighborhood.",
        "jp": "自分の足場を固める。",
        "then": {
          "goto": "桜4-3",
        },
      },
      {
        "eng": "Go to Shinto.",
        "jp": "新都へ。",
        "then": {
          "goto": "桜4-4",
        },
      },
    ],
  },
  "桜4-3": {
    "update": [
      "セイバー好感度+=1",
    ],
    "goto": "桜4-5",
  },
  "桜4-4": {
    "goto": "桜4-5",
  },
  "桜4-5": {
    "goto": "桜4-9",
  },
  "桜4-7": {
    "goto": "桜4-8",
  },
  "桜4-8": {
    "goto": "桜4-2",
  },
  "桜4-9": {
    "goto": "桜5-19",
  },
  "桜4-10": {
    "goto": "桜4-1",
  },
  "桜4-11": {
    "goto": "桜4-0",
  },
  "桜5-0": {
    "choices": [
      {
        "eng": "Consult her about Sakura.",
        "jp": "桜の事を相談する。",
        "then": {
          "goto": "桜5-1",
        },
      },
      {
        "eng": "Consult her about Shinji.",
        "jp": "慎二の事を相談する。",
        "then": {
          "goto": "桜5-2",
        },
      },
      {
        "eng": "I smell danger! Run away to my classroom!",
        "jp": "危険の匂いだ、教室にダッシュ！",
        "then": {
          "goto": "桜5-3",
        },
      },
    ],
  },
  "桜5-1": {
    "update": [
      "凛好感度+=1",
    ],
    "goto": "桜5-4",
  },
  "桜5-2": {
    "goto": "桜5-4",
  },
  "桜5-3": {
    "goto": "桜5-9",
  },
  "桜5-4": {
    "goto": "桜5-5",
  },
  "桜5-5": {
    "choices": [
      {
        "eng": "I don’t hate you.",
        "jp": "俺は嫌いじゃないぞ。",
        "then": {
          "goto": "桜5-7",
        },
      },
      {
        "eng": "I don’t mind it anymore.",
        "jp": "俺は気にしてないぞ。",
        "then": {
          "goto": "桜5-6",
        },
      },
    ],
  },
  "桜5-6": {
    "goto": "桜5-8",
  },
  "桜5-7": {
    "update": [
      "イリヤ好感度+=1",
    ],
    "goto": "桜5-8",
  },
  "桜5-8": {
    "update": [
      "イリヤとの会話+=1",
    ],
    "goto": "桜5-9",
  },
  "桜5-9": {
    "choices": [
      {
        "eng": "Have Fuji-Nee ask Sakura.",
        "jp": "藤ねえにお願いする。",
        "then": {
          "goto": "桜5-10",
        },
      },
      {
        "eng": "I’ll tell Sakura myself.",
        "jp": "自分で言う。",
        "then": {
          "goto": "桜5-11",
        },
      },
    ],
  },
  "桜5-10": {
    "goto": "桜5-13",
  },
  "桜5-11": {
    "update": [
      "桜好感度+=2",
    ],
    "goto": "桜5-13",
  },
  "桜5-12": {
    "goto": "桜5-21",
  },
  "桜5-13": {
    "choices": [
      {
        "eng": "Should I go check on her…?",
        "jp": "様子を見に行ってみようか……？",
        "then": {
          "goto": "桜5-14",
        },
      },
      {
        "eng": "…No, I’ll let Fuji-Nee do it.",
        "jp": "……いや、藤ねえに任せよう。",
        "then": {
          "goto": "桜5-15",
        },
      },
    ],
  },
  "桜5-14": {
    "update": [
      "桜好感度+=2",
    ],
    "goto": "桜5-16",
  },
  "桜5-15": {
    "goto": "桜5-16",
  },
  "桜5-16": {
    "goto": "桜5-12",
  },
  "桜5-17": {
    "goto": "桜6-0",
  },
  "桜5-19": {
    "goto": "桜5-20",
  },
  "桜5-20": {
    "goto": "桜5-0",
  },
  "桜5-21": {
    "goto": "桜5-22",
  },
  "桜5-22": {
    "conditions": [
      {
        "if": "ghentai==1",
        "then": {
          "goto": "桜5-117",
        },
      },
      {
        "then": {
          "goto": "桜5-17",
        },
      },
    ],
  },
  "桜5-117": {
    "goto": "桜6-0",
  },
  "桜6-0": {
    "goto": "桜6-1",
  },
  "桜6-1": {
    "choices": [
      {
        "eng": "Don’t lie.",
        "jp": "嘘はつかない。",
        "then": {
          "goto": "桜6-3",
        },
      },
      {
        "eng": "Evade the question.",
        "jp": "なんとか誤魔化す。",
        "then": {
          "goto": "桜6-4",
        },
      },
    ],
  },
  "桜6-2": {
    "goto": "桜6-19",
  },
  "桜6-3": {
    "goto": "桜6-5",
  },
  "桜6-4": {
    "goto": "桜6-5",
  },
  "桜6-5": {
    "choices": [
      {
        "eng": "I’ll go shopping.",
        "jp": "外に買い物に行こう。",
        "then": {
          "conditions": [
            {
              "if": "イリヤとの会話\u003e=1",
              "then": {
                "goto": "桜6-9",
              },
            },
            {
              "if": "イリヤとの会話!=1",
              "then": {
                "goto": "桜6-10",
              },
            },
          ],
        },
      },
      {
        "eng": "I’ll have a snack.",
        "jp": "おやつの時間にするべし。",
        "then": {
          "goto": "桜6-7",
        },
      },
      {
        "eng": "TV comes after a meal.",
        "jp": "食後はまったりテレビである。",
        "then": {
          "goto": "桜6-8",
        },
      },
    ],
  },
  "桜6-7": {
    "update": [
      "桜好感度+=1",
    ],
    "goto": "桜6-19",
  },
  "桜6-8": {
    "goto": "桜6-19",
  },
  "桜6-9": {
    "update": [
      "イリヤとの会話+=1",
    ],
    "goto": "桜6-2",
  },
  "桜6-10": {
    "update": [
      "イリヤとの会話+=1",
    ],
    "goto": "桜6-2",
  },
  "桜6-11": {
    "goto": "桜7-15",
  },
  "桜6-16": {
    "goto": "桜6-18",
  },
  "桜6-17": {
    "goto": "桜6-18",
  },
  "桜6-18": {
    "goto": "桜6-11",
  },
  "桜6-19": {
    "choices": [
      {
        "eng": "Punch Shinji.",
        "jp": "慎二を殴る。",
        "then": {
          "goto": "桜6-20",
        },
      },
      {
        "eng": "Restrain myself.",
        "jp": "我慢する。",
        "then": {
          "goto": "桜6-21",
        },
      },
    ],
  },
  "桜6-20": {
    "goto": "桜6-22",
  },
  "桜6-21": {
    "goto": "桜6-22",
  },
  "桜6-22": {
    "choices": [
      {
        "eng": "Patrol Shinto.",
        "jp": "新都を巡回する。",
        "then": {
          "goto": "桜6-16",
        },
      },
      {
        "eng": "Patrol Miyama City.",
        "jp": "深山町を巡回する。",
        "then": {
          "goto": "桜6-17",
        },
      },
      {
        "eng": "…No, I’m worried about Sakura.",
        "jp": "……いや、桜が心配だ。",
        "then": {
          "goto": "桜6-23",
        },
      },
    ],
  },
  "桜6-23": {
    "update": [
      "桜好感度+=5",
    ],
    "goto": "桜6-11",
  },
  "桜7-0": {
    "goto": "桜7-2",
  },
  "桜7-1": {
    "goto": "桜7-17",
  },
  "桜7-2": {
    "goto": "桜7-18",
  },
  "桜7-4": {
    "goto": "桜7-19",
  },
  "桜7-5": {},
  "桜7-6": {
    "choices": [
      {
        "eng": "Invite her to my house as a guest.",
        "jp": "お客さまとしてうちに招く。",
        "then": {
          "goto": "桜7-7",
        },
      },
      {
        "eng": "To show my apology, I’ll do anything she says.",
        "jp": "謝罪を込めて言うコトを聞く。",
        "then": {
          "goto": "桜7-8",
        },
      },
      {
        "eng": "Have her forgive me.",
        "jp": "なんとか大目に見てもらう。",
        "then": {
          "goto": "桜7-9",
        },
      },
    ],
  },
  "桜7-7": {
    "update": [
      "イリヤ、衛宮邸体験した=1",
      "イリヤ好感度+=3",
    ],
    "goto": "桜7-19",
  },
  "桜7-8": {
    "update": [
      "イリヤ好感度+=3",
    ],
    "goto": "桜7-10",
  },
  "桜7-9": {
    "goto": "桜7-19",
  },
  "桜7-10": {
    "goto": "桜7-20",
  },
  "桜7-11": {
    "conditions": [
      {
        "if": "桜好感度\u003c=8",
        "then": {
          "goto": "桜7-12",
        },
      },
      {
        "then": {
          "goto": "桜7-13",
        },
      },
    ],
  },
  "桜7-12": {
    "goto": "桜7-5",
  },
  "桜7-13": {
    "goto": "桜7-21",
  },
  "桜7-15": {
    "goto": "桜7-16",
  },
  "桜7-16": {
    "goto": "桜7-1",
  },
  "桜7-17": {
    "goto": "桜7-0",
  },
  "桜7-18": {
    "conditions": [
      {
        "if": "イリヤとの会話\u003e=2",
        "then": {
          "goto": "桜7-6",
        },
      },
      {
        "then": {
          "goto": "桜7-4",
        },
      },
    ],
  },
  "桜7-19": {
    "goto": "桜7-20",
  },
  "桜7-20": {
    "goto": "桜7-11",
  },
  "桜7-21": {
    "goto": "桜8-11",
  },
  "桜8-0": {
    "goto": "桜8-15",
  },
  "桜8-1": {
    "goto": "桜8-23",
  },
  "桜8-2": {
    "choices": [
      {
        "eng": "Investigate the Ryuudou Temple.",
        "jp": "柳洞寺を調べよう。",
        "then": {
          "goto": "桜8-3",
        },
      },
      {
        "eng": "Investigate the park.",
        "jp": "公園を調べよう。",
        "then": {
          "goto": "桜8-4",
        },
      },
    ],
  },
  "桜8-3": {
    "goto": "桜8-17",
  },
  "桜8-4": {
    "goto": "桜8-17",
  },
  "桜8-5": {
    "choices": [
      {
        "eng": "Trust Saber and wait for her…!",
        "jp": "セイバーを信じて待つ……！",
        "then": {
          "goto": "桜8-6",
        },
      },
      {
        "eng": "Attack Zouken…!",
        "jp": "臓硯に斬りかかる……！",
        "then": {
          "goto": "桜8-7",
        },
      },
      {
        "eng": "Use my Command Spell…!",
        "jp": "令呪を使う……！",
        "then": {
          "goto": "桜8-8",
        },
      },
    ],
  },
  "桜8-6": {
    "goto": "桜8-9",
  },
  "桜8-7": {
    "goto": "桜8-24",
  },
  "桜8-8": {
    "goto": "桜8-9",
  },
  "桜8-9": {
    "goto": "桜8-19",
  },
  "桜8-11": {
    "goto": "桜8-12",
  },
  "桜8-12": {
    "goto": "桜8-13",
  },
  "桜8-13": {
    "goto": "桜8-14",
  },
  "桜8-14": {
    "conditions": [
      {
        "if": "イリヤ好感度\u003c=2",
        "then": {
          "goto": "桜8-1",
        },
      },
      {
        "then": {
          "goto": "桜8-0",
        },
      },
    ],
  },
  "桜8-15": {
    "goto": "桜8-16",
  },
  "桜8-16": {
    "goto": "桜8-2",
  },
  "桜8-17": {
    "goto": "桜8-18",
  },
  "桜8-18": {
    "goto": "桜8-5",
  },
  "桜8-19": {
    "goto": "桜8-20",
  },
  "桜8-20": {
    "goto": "桜8-21",
  },
  "桜8-21": {
    "goto": "桜8-22",
  },
  "桜8-22": {
    "goto": "桜9-26",
  },
  "桜8-23": {},
  "桜8-24": {},
  "桜9-0": {
    "choices": [
      {
        "eng": "He was on guard against my counterattack?",
        "jp": "反撃を警戒していた、とか？",
        "then": {
          "goto": "桜9-1",
        },
      },
      {
        "eng": "He didn’t want to kill me?",
        "jp": "俺を殺したくなかった、とか？",
        "then": {
          "goto": "桜9-2",
        },
      },
      {
        "eng": "He could afford to play around?",
        "jp": "爺さんの余裕だった、とか？",
        "then": {
          "goto": "桜9-3",
        },
      },
    ],
  },
  "桜9-1": {
    "goto": "桜9-4",
  },
  "桜9-2": {
    "update": [
      "凛好感度+=1",
    ],
    "goto": "桜9-4",
  },
  "桜9-3": {
    "update": [
      "凛好感度+=1",
    ],
    "goto": "桜9-4",
  },
  "桜9-4": {
    "choices": [
      {
        "eng": "…No, this is my problem.",
        "jp": "……いや、これは自分ひとりの問題だ。",
        "then": {
          "goto": "桜9-5",
        },
      },
      {
        "eng": "I can’t do this myself. I need Tohsaka’s help.",
        "jp": "俺一人じゃダメだ。遠坂の手を借りないと。",
        "then": {
          "goto": "桜9-6",
        },
      },
    ],
  },
  "桜9-5": {
    "goto": "桜9-38",
  },
  "桜9-6": {
    "choices": [
      {
        "eng": "Yes",
        "jp": "はい",
        "then": {
          "update": [
            "凛好感度+=1",
          ],
          "goto": "桜9-9",
        },
      },
      {
        "eng": "No",
        "jp": "いいえ",
        "then": {
          "goto": "桜9-8",
        },
      },
    ],
  },
  "桜9-8": {
    "goto": "桜9-9",
  },
  "桜9-9": {
    "choices": [
      {
        "eng": "Yes",
        "jp": "はい",
        "then": {
          "goto": "桜9-12",
        },
      },
      {
        "eng": "No",
        "jp": "いいえ",
        "then": {
          "goto": "桜9-11",
        },
      },
    ],
  },
  "桜9-11": {
    "update": [
      "凛好感度+=1",
    ],
    "goto": "桜9-12",
  },
  "桜9-12": {
    "choices": [
      {
        "eng": "No way!",
        "jp": "するか！",
        "then": {
          "goto": "桜9-13",
        },
      },
      {
        "eng": "…I guess it can’t be helped.",
        "jp": "……仕方ない。",
        "then": {
          "goto": "桜9-14",
        },
      },
    ],
  },
  "桜9-13": {
    "goto": "桜9-27",
  },
  "桜9-14": {
    "update": [
      "ギアス=1",
    ],
    "goto": "桜9-27",
  },
  "桜9-15": {
    "choices": [
      {
        "eng": "No, I can’t leave Sakura by herself.",
        "jp": "いや、これ以上桜をひとりにさせられない。",
        "then": {
          "goto": "桜9-16",
        },
      },
      {
        "eng": "…There’s the housekeeper, so I guess I can stay a bit longer…",
        "jp": "……家政婦さんもいるし、あと少しぐらいなら……",
        "then": {
          "goto": "桜9-17",
        },
      },
    ],
  },
  "桜9-16": {
    "update": [
      "桜好感度+=1",
    ],
    "goto": "桜9-18",
  },
  "桜9-17": {
    "goto": "桜9-18",
  },
  "桜9-18": {
    "goto": "桜9-33",
  },
  "桜9-19": {
    "choices": [
      {
        "eng": "Pull Tohsaka’s hand.",
        "jp": "遠坂の手を引いて───",
        "then": {
          "goto": "桜9-20",
        },
      },
      {
        "eng": "Close my eyes and attack Rider.",
        "jp": "目を瞑って、ライダーに斬りかかる───",
        "then": {
          "goto": "桜9-21",
        },
      },
      {
        "eng": "I can’t do anything.",
        "jp": "何もできない───",
        "then": {
          "goto": "桜9-22",
        },
      },
    ],
  },
  "桜9-20": {
    "update": [
      "凛好感度+=1",
      "桜好感度+=1",
    ],
    "goto": "桜9-35",
  },
  "桜9-21": {
    "goto": "桜9-39",
  },
  "桜9-22": {
    "goto": "桜9-35",
  },
  "桜9-23": {
    "choices": [
      {
        "eng": "…Persist on being a superhero.",
        "jp": "……正義の味方を、張り通す。",
        "then": {
          "goto": "桜9-25",
        },
      },
      {
        "eng": "I want to protect Sakura.",
        "jp": "桜の味方になりたいんだ。",
        "then": {
          "goto": "桜9-36",
        },
      },
    ],
  },
  "桜9-24": {
    "conditions": [
      {
        "if": "ギアス==1",
        "then": {
          "goto": "桜9-34",
        },
      },
      {
        "then": {
          "goto": "桜9-28",
        },
      },
    ],
  },
  "桜9-25": {
    "goto": "桜9-40",
  },
  "桜9-26": {
    "goto": "桜9-0",
  },
  "桜9-27": {
    "conditions": [
      {
        "if": "ギアス==1",
        "then": {
          "goto": "桜9-32",
        },
      },
      {
        "then": {
          "goto": "桜9-15",
        },
      },
    ],
  },
  "桜9-28": {
    "goto": "桜9-29",
  },
  "桜9-29": {
    "conditions": [
      {
        "if": "ghentai==1",
        "then": {
          "goto": "桜9-130",
        },
      },
      {
        "then": {
          "goto": "桜9-30",
        },
      },
    ],
  },
  "桜9-30": {
    "goto": "桜10-6",
  },
  "桜9-32": {
    "goto": "桜9-18",
  },
  "桜9-33": {
    "goto": "桜9-19",
  },
  "桜9-34": {
    "goto": "桜9-41",
  },
  "桜9-35": {
    "goto": "桜9-23",
  },
  "桜9-36": {
    "goto": "桜9-37",
  },
  "桜9-37": {
    "goto": "桜9-24",
  },
  "桜9-38": {},
  "桜9-39": {},
  "桜9-40": {},
  "桜9-41": {},
  "桜9-130": {
    "goto": "桜10-6",
  },
}

export const scripts = {
  "セ1-0": "セイバールート一日目-00",
  "セ1-1": "セイバールート一日目-01",
  "セ1-2": "セイバールート一日目-02",
  "セ1-3": "セイバールート一日目-03",
  "セ1-4": "セイバールート一日目-04",
  "セ1-5": "セイバールート一日目-05",
  "セ1-6": "セイバールート一日目-06",
  "セ1-7": "セイバールート一日目-07",
  "セ1-9": "セイバールート一日目-09",
  "セ1-11": "セイバールート一日目-11",
  "セ1-12": "セイバールート一日目-12",
  "セ1-13": "セイバールート一日目-13",
  "セ1-14": "セイバールート一日目-14",
  "セ1-15": "セイバールート一日目-15",
  "セ10-0": "セイバールート十日目-00",
  "セ10-1": "セイバールート十日目-01",
  "セ10-2": "セイバールート十日目-02",
  "セ10-3": "セイバールート十日目-03",
  "セ10-4": "セイバールート十日目-04",
  "セ10-5": "セイバールート十日目-05",
  "セ10-6": "セイバールート十日目-06",
  "セ10-7": "セイバールート十日目-07",
  "セ10-9": "セイバールート十日目-09",
  "セ10-10": "セイバールート十日目-10",
  "セ11-0": "セイバールート十一日目-00",
  "セ11-1": "セイバールート十一日目-01",
  "セ11-2": "セイバールート十一日目-02",
  "セ11-3": "セイバールート十一日目-03",
  "セ11-4": "セイバールート十一日目-04",
  "セ11-5": "セイバールート十一日目-05",
  "セ11-6": "セイバールート十一日目-06",
  "セ11-7": "セイバールート十一日目-07",
  "セ11-8": "セイバールート十一日目-08",
  "セ11-9": "セイバールート十一日目-09",
  "セ11-10": "セイバールート十一日目-10",
  "セ11-11": "セイバールート十一日目-11",
  "セ11-12": "セイバールート十一日目-12",
  "セ11-13": "セイバールート十一日目-13",
  "セ11-14": "セイバールート十一日目-14",
  "セ11-16": "セイバールート十一日目-16",
  "セ11-17": "セイバールート十一日目-17",
  "セ11-18": "セイバールート十一日目-18",
  "セ11-19": "セイバールート十一日目-19",
  "セ11-20": "セイバールート十一日目-20",
  "セ11-21": "セイバールート十一日目-21",
  "セ11-118": "セイバールート十一日目-118",
  "セ12-0": "セイバールート十二日目-00",
  "セ12-1": "セイバールート十二日目-01",
  "セ12-2": "セイバールート十二日目-02",
  "セ12-3": "セイバールート十二日目-03",
  "セ12-4": "セイバールート十二日目-04",
  "セ12-5": "セイバールート十二日目-05",
  "セ12-6": "セイバールート十二日目-06",
  "セ12-7": "セイバールート十二日目-07",
  "セ12-8": "セイバールート十二日目-08",
  "セ12-9": "セイバールート十二日目-09",
  "セ12-10": "セイバールート十二日目-10",
  "セ12-11": "セイバールート十二日目-11",
  "セ12-12": "セイバールート十二日目-12",
  "セ12-13": "セイバールート十二日目-13",
  "セ12-14": "セイバールート十二日目-14",
  "セ12-15": "セイバールート十二日目-15",
  "セ13-0": "セイバールート十三日目-00",
  "セ13-1": "セイバールート十三日目-01",
  "セ13-2": "セイバールート十三日目-02",
  "セ13-3": "セイバールート十三日目-03",
  "セ13-4": "セイバールート十三日目-04",
  "セ13-5": "セイバールート十三日目-05",
  "セ13-6": "セイバールート十三日目-06",
  "セ13-7": "セイバールート十三日目-07",
  "セ13-8": "セイバールート十三日目-08",
  "セ13-9": "セイバールート十三日目-09",
  "セ13-11": "セイバールート十三日目-11",
  "セ13-12": "セイバールート十三日目-12",
  "セ13-13": "セイバールート十三日目-13",
  "セ13-14": "セイバールート十三日目-14",
  "セ13-15": "セイバールート十三日目-15",
  "セ13-16": "セイバールート十三日目-16",
  "セ14-0": "セイバールート十四日目-00",
  "セ14-2": "セイバールート十四日目-02",
  "セ14-3": "セイバールート十四日目-03",
  "セ14-4": "セイバールート十四日目-04",
  "セ14-6": "セイバールート十四日目-06",
  "セ14-7": "セイバールート十四日目-07",
  "セ14-8": "セイバールート十四日目-08",
  "セ14-9": "セイバールート十四日目-09",
  "セ14-10": "セイバールート十四日目-10",
  "セ14-11": "セイバールート十四日目-11",
  "セ14-12": "セイバールート十四日目-12",
  "セ14-101": "セイバールート十四日目-101",
  "セ14-111": "セイバールート十四日目-111",
  "セ15-0": "セイバールート十五日目-00",
  "セ15-1": "セイバールート十五日目-01",
  "セ15-2": "セイバールート十五日目-02",
  "セ15-3": "セイバールート十五日目-03",
  "セ15-4": "セイバールート十五日目-04",
  "セ15-5": "セイバールート十五日目-05",
  "セ15-6": "セイバールート十五日目-06",
  "セ15-7": "セイバールート十五日目-07",
  "セ15-8": "セイバールート十五日目-08",
  "セ15-9": "セイバールート十五日目-09",
  "セ15-10": "セイバールート十五日目-10",
  "セ15-11": "セイバールート十五日目-11",
  "セ15-12": "セイバールート十五日目-12",
  "セ15-13": "セイバールート十五日目-13",
  "セ15-14": "セイバールート十五日目-14",
  "セ15-15": "セイバールート十五日目-15",
  "セ15-16": "セイバールート十五日目-16",
  "セ15-17": "セイバールート十五日目-17",
  "セ15-18": "セイバールート十五日目-18",
  "セ15-19": "セイバールート十五日目-19",
  "セ15-20": "セイバールート十五日目-20",
  "セ15-21": "セイバールート十五日目-21",
  "セ15-22": "セイバールート十五日目-22",
  "セ15-23": "セイバールート十五日目-23",
  "セ15-24": "セイバールート十五日目-24",
  "セ15-25": "セイバールート十五日目-25",
  "セ2-0": "セイバールート二日目-00",
  "セ2-1": "セイバールート二日目-01",
  "セ2-3": "セイバールート二日目-03",
  "セ2-4": "セイバールート二日目-04",
  "セ2-5": "セイバールート二日目-05",
  "セ2-6": "セイバールート二日目-06",
  "セ2-7": "セイバールート二日目-07",
  "セ2-8": "セイバールート二日目-08",
  "セ2-9": "セイバールート二日目-09",
  "セ2-10": "セイバールート二日目-10",
  "セ2-13": "セイバールート二日目-13",
  "セ2-14": "セイバールート二日目-14",
  "セ2-15": "セイバールート二日目-15",
  "セ2-16": "セイバールート二日目-16",
  "セ3-0": "セイバールート三日目-00",
  "セ3-1": "セイバールート三日目-01",
  "セ3-2": "セイバールート三日目-02",
  "セ3-4": "セイバールート三日目-04",
  "セ3-5": "セイバールート三日目-05",
  "セ3-6": "セイバールート三日目-06",
  "セ3-7": "セイバールート三日目-07",
  "セ3-8": "セイバールート三日目-08",
  "セ3-9": "セイバールート三日目-09",
  "セ3-10": "セイバールート三日目-10",
  "セ3-11": "セイバールート三日目-11",
  "セ3-12": "セイバールート三日目-12",
  "セ3-16": "セイバールート三日目-16",
  "セ3-17": "セイバールート三日目-17",
  "セ3-18": "セイバールート三日目-18",
  "セ3-19": "セイバールート三日目-19",
  "セ4-0": "セイバールート四日目-00",
  "セ4-1": "セイバールート四日目-01",
  "セ4-2": "セイバールート四日目-02",
  "セ4-3": "セイバールート四日目-03",
  "セ4-4": "セイバールート四日目-04",
  "セ4-5": "セイバールート四日目-05",
  "セ4-6": "セイバールート四日目-06",
  "セ4-7": "セイバールート四日目-07",
  "セ4-8": "セイバールート四日目-08",
  "セ4-9": "セイバールート四日目-09",
  "セ4-10": "セイバールート四日目-10",
  "セ4-11": "セイバールート四日目-11",
  "セ4-12": "セイバールート四日目-12",
  "セ4-15": "セイバールート四日目-15",
  "セ4-18": "セイバールート四日目-18",
  "セ5-0": "セイバールート五日目-00",
  "セ5-4": "セイバールート五日目-04",
  "セ5-5": "セイバールート五日目-05",
  "セ5-6": "セイバールート五日目-06",
  "セ5-7": "セイバールート五日目-07",
  "セ5-8": "セイバールート五日目-08",
  "セ5-9": "セイバールート五日目-09",
  "セ5-10": "セイバールート五日目-10",
  "セ5-11": "セイバールート五日目-11",
  "セ5-12": "セイバールート五日目-12",
  "セ5-14": "セイバールート五日目-14",
  "セ6-0": "セイバールート六日目-00",
  "セ6-1": "セイバールート六日目-01",
  "セ6-3": "セイバールート六日目-03",
  "セ6-4": "セイバールート六日目-04",
  "セ6-5": "セイバールート六日目-05",
  "セ6-6": "セイバールート六日目-06",
  "セ6-7": "セイバールート六日目-07",
  "セ6-8": "セイバールート六日目-08",
  "セ6-9": "セイバールート六日目-09",
  "セ6-10": "セイバールート六日目-10",
  "セ6-12": "セイバールート六日目-12",
  "セ6-13": "セイバールート六日目-13",
  "セ6-14": "セイバールート六日目-14",
  "セ6-15": "セイバールート六日目-15",
  "セ7-0": "セイバールート七日目-00",
  "セ7-1": "セイバールート七日目-01",
  "セ7-2": "セイバールート七日目-02",
  "セ7-3": "セイバールート七日目-03",
  "セ7-4": "セイバールート七日目-04",
  "セ7-5": "セイバールート七日目-05",
  "セ7-6": "セイバールート七日目-06",
  "セ7-7": "セイバールート七日目-07",
  "セ7-8": "セイバールート七日目-08",
  "セ7-12": "セイバールート七日目-12",
  "セ7-13": "セイバールート七日目-13",
  "セ7-14": "セイバールート七日目-14",
  "セ7-15": "セイバールート七日目-15",
  "セ7-16": "セイバールート七日目-16",
  "セ7-17": "セイバールート七日目-17",
  "セ7-18": "セイバールート七日目-18",
  "セ7-19": "セイバールート七日目-19",
  "セ7-20": "セイバールート七日目-20",
  "セ7-21": "セイバールート七日目-21",
  "セ7-22": "セイバールート七日目-22",
  "セ7-23": "セイバールート七日目-23",
  "セ7-24": "セイバールート七日目-24",
  "セ7-25": "セイバールート七日目-25",
  "セ7-27": "セイバールート七日目-27",
  "セ7-28": "セイバールート七日目-28",
  "セ7-29": "セイバールート七日目-29",
  "セ9-0": "セイバールート九日目-00",
  "セ9-1": "セイバールート九日目-01",
  "セ9-2": "セイバールート九日目-02",
  "セ9-3": "セイバールート九日目-03",
  "セ9-4": "セイバールート九日目-04",
  "セ9-5": "セイバールート九日目-05",
  "セ9-6": "セイバールート九日目-06",
  "セ9-7": "セイバールート九日目-07",
  "セ9-8": "セイバールート九日目-08",
  "セ9-9": "セイバールート九日目-09",
  "セ9-10": "セイバールート九日目-10",
  "セ9-11": "セイバールート九日目-11",
  "セ9-12": "セイバールート九日目-12",
  "セ9-14": "セイバールート九日目-14",
  "セ9-15": "セイバールート九日目-15",
  "セ9-16": "セイバールート九日目-16",
  "セ9-17": "セイバールート九日目-17",
  "プ-1": "プロローグ1日目",
  "プ-2": "プロローグ2日目",
  "プ-3": "プロローグ3日目",
  "凛10-0": "凛ルート十日目-00",
  "凛10-1": "凛ルート十日目-01",
  "凛10-2": "凛ルート十日目-02",
  "凛10-3": "凛ルート十日目-03",
  "凛10-4": "凛ルート十日目-04",
  "凛10-6": "凛ルート十日目-06",
  "凛10-7": "凛ルート十日目-07",
  "凛10-8": "凛ルート十日目-08",
  "凛11-0": "凛ルート十一日目-00",
  "凛11-1": "凛ルート十一日目-01",
  "凛11-2": "凛ルート十一日目-02",
  "凛11-3": "凛ルート十一日目-03",
  "凛11-4": "凛ルート十一日目-04",
  "凛11-5": "凛ルート十一日目-05",
  "凛11-6": "凛ルート十一日目-06",
  "凛11-8": "凛ルート十一日目-08",
  "凛11-9": "凛ルート十一日目-09",
  "凛11-10": "凛ルート十一日目-10",
  "凛11-11": "凛ルート十一日目-11",
  "凛11-12": "凛ルート十一日目-12",
  "凛11-13": "凛ルート十一日目-13",
  "凛11-14": "凛ルート十一日目-14",
  "凛11-15": "凛ルート十一日目-15",
  "凛11-16": "凛ルート十一日目-16",
  "凛11-17": "凛ルート十一日目-17",
  "凛12-0": "凛ルート十二日目-00",
  "凛12-1": "凛ルート十二日目-01",
  "凛12-2": "凛ルート十二日目-02",
  "凛12-3": "凛ルート十二日目-03",
  "凛12-4": "凛ルート十二日目-04",
  "凛12-5": "凛ルート十二日目-05",
  "凛12-6": "凛ルート十二日目-06",
  "凛12-7": "凛ルート十二日目-07",
  "凛12-8": "凛ルート十二日目-08",
  "凛12-10": "凛ルート十二日目-10",
  "凛12-11": "凛ルート十二日目-11",
  "凛12-12": "凛ルート十二日目-12",
  "凛12-13": "凛ルート十二日目-13",
  "凛12-14": "凛ルート十二日目-14",
  "凛12-15": "凛ルート十二日目-15",
  "凛12-16": "凛ルート十二日目-16",
  "凛12-17": "凛ルート十二日目-17",
  "凛13-0": "凛ルート十三日目-00",
  "凛13-1": "凛ルート十三日目-01",
  "凛13-2": "凛ルート十三日目-02",
  "凛13-3": "凛ルート十三日目-03",
  "凛13-4": "凛ルート十三日目-04",
  "凛13-5": "凛ルート十三日目-05",
  "凛13-6": "凛ルート十三日目-06",
  "凛13-7": "凛ルート十三日目-07",
  "凛13-8": "凛ルート十三日目-08",
  "凛13-9": "凛ルート十三日目-09",
  "凛13-11": "凛ルート十三日目-11",
  "凛13-12": "凛ルート十三日目-12",
  "凛13-13": "凛ルート十三日目-13",
  "凛13-14": "凛ルート十三日目-14",
  "凛13-15": "凛ルート十三日目-15",
  "凛13-16": "凛ルート十三日目-16",
  "凛13-17": "凛ルート十三日目-17",
  "凛13-18": "凛ルート十三日目-18",
  "凛13-19": "凛ルート十三日目-19",
  "凛13-20": "凛ルート十三日目-20",
  "凛13-21": "凛ルート十三日目-21",
  "凛13-22": "凛ルート十三日目-22",
  "凛14-0": "凛ルート十四日目-00",
  "凛14-1": "凛ルート十四日目-01",
  "凛14-2": "凛ルート十四日目-02",
  "凛14-3": "凛ルート十四日目-03",
  "凛14-4": "凛ルート十四日目-04",
  "凛14-5": "凛ルート十四日目-05",
  "凛14-6": "凛ルート十四日目-06",
  "凛14-7": "凛ルート十四日目-07",
  "凛14-8": "凛ルート十四日目-08",
  "凛14-9": "凛ルート十四日目-09",
  "凛14-10": "凛ルート十四日目-10",
  "凛14-11": "凛ルート十四日目-11",
  "凛14-12": "凛ルート十四日目-12",
  "凛14-13": "凛ルート十四日目-13",
  "凛14-14": "凛ルート十四日目-14",
  "凛14-15": "凛ルート十四日目-15",
  "凛14-16": "凛ルート十四日目-16",
  "凛14-17": "凛ルート十四日目-17",
  "凛14-18": "凛ルート十四日目-18",
  "凛14-19": "凛ルート十四日目-19",
  "凛14-20": "凛ルート十四日目-20",
  "凛14-21": "凛ルート十四日目-21",
  "凛14-22": "凛ルート十四日目-22",
  "凛14-23": "凛ルート十四日目-23",
  "凛14-24": "凛ルート十四日目-24",
  "凛14-25": "凛ルート十四日目-25",
  "凛14-26": "凛ルート十四日目-26",
  "凛14-27": "凛ルート十四日目-27",
  "凛14-28": "凛ルート十四日目-28",
  "凛14-29": "凛ルート十四日目-29",
  "凛14-31": "凛ルート十四日目-31",
  "凛14-32": "凛ルート十四日目-32",
  "凛14-33": "凛ルート十四日目-33",
  "凛14-34": "凛ルート十四日目-34",
  "凛14-35": "凛ルート十四日目-35",
  "凛14-36": "凛ルート十四日目-36",
  "凛14-37": "凛ルート十四日目-37",
  "凛14-108": "凛ルート十四日目-108",
  "凛14-130": "凛ルート十四日目-130",
  "凛3-0": "凛ルート三日目-00",
  "凛3-1": "凛ルート三日目-01",
  "凛3-2": "凛ルート三日目-02",
  "凛3-3": "凛ルート三日目-03",
  "凛3-4": "凛ルート三日目-04",
  "凛3-5": "凛ルート三日目-05",
  "凛3-6": "凛ルート三日目-06",
  "凛3-7": "凛ルート三日目-07",
  "凛3-9": "凛ルート三日目-09",
  "凛3-10": "凛ルート三日目-10",
  "凛3-11": "凛ルート三日目-11",
  "凛3-12": "凛ルート三日目-12",
  "凛4-0": "凛ルート四日目-00",
  "凛4-1": "凛ルート四日目-01",
  "凛4-2": "凛ルート四日目-02",
  "凛4-3": "凛ルート四日目-03",
  "凛4-4": "凛ルート四日目-04",
  "凛4-5": "凛ルート四日目-05",
  "凛4-6": "凛ルート四日目-06",
  "凛4-7": "凛ルート四日目-07",
  "凛4-9": "凛ルート四日目-09",
  "凛4-10": "凛ルート四日目-10",
  "凛4-11": "凛ルート四日目-11",
  "凛4-12": "凛ルート四日目-12",
  "凛5-0": "凛ルート五日目-00",
  "凛5-1": "凛ルート五日目-01",
  "凛5-2": "凛ルート五日目-02",
  "凛5-3": "凛ルート五日目-03",
  "凛5-4": "凛ルート五日目-04",
  "凛5-5": "凛ルート五日目-05",
  "凛5-6": "凛ルート五日目-06",
  "凛5-9": "凛ルート五日目-09",
  "凛5-10": "凛ルート五日目-10",
  "凛5-11": "凛ルート五日目-11",
  "凛5-12": "凛ルート五日目-12",
  "凛5-13": "凛ルート五日目-13",
  "凛5-14": "凛ルート五日目-14",
  "凛5-15": "凛ルート五日目-15",
  "凛5-16": "凛ルート五日目-16",
  "凛5-17": "凛ルート五日目-17",
  "凛5-18": "凛ルート五日目-18",
  "凛5-20": "凛ルート五日目-20",
  "凛5-21": "凛ルート五日目-21",
  "凛5-22": "凛ルート五日目-22",
  "凛5-23": "凛ルート五日目-23",
  "凛5-24": "凛ルート五日目-24",
  "凛5-25": "凛ルート五日目-25",
  "凛5-26": "凛ルート五日目-26",
  "凛5-27": "凛ルート五日目-27",
  "凛6-0": "凛ルート六日目-00",
  "凛6-1": "凛ルート六日目-01",
  "凛6-2": "凛ルート六日目-02",
  "凛6-3": "凛ルート六日目-03",
  "凛6-4": "凛ルート六日目-04",
  "凛6-5": "凛ルート六日目-05",
  "凛6-6": "凛ルート六日目-06",
  "凛6-8": "凛ルート六日目-08",
  "凛6-9": "凛ルート六日目-09",
  "凛6-10": "凛ルート六日目-10",
  "凛6-11": "凛ルート六日目-11",
  "凛6-12": "凛ルート六日目-12",
  "凛6-13": "凛ルート六日目-13",
  "凛6-14": "凛ルート六日目-14",
  "凛7-0": "凛ルート七日目-00",
  "凛7-1": "凛ルート七日目-01",
  "凛7-2": "凛ルート七日目-02",
  "凛7-3": "凛ルート七日目-03",
  "凛7-4": "凛ルート七日目-04",
  "凛7-5": "凛ルート七日目-05",
  "凛7-6": "凛ルート七日目-06",
  "凛7-7": "凛ルート七日目-07",
  "凛7-8": "凛ルート七日目-08",
  "凛7-9": "凛ルート七日目-09",
  "凛7-11": "凛ルート七日目-11",
  "凛7-12": "凛ルート七日目-12",
  "凛8-0": "凛ルート八日目-00",
  "凛8-1": "凛ルート八日目-01",
  "凛8-2": "凛ルート八日目-02",
  "凛8-3": "凛ルート八日目-03",
  "凛8-4": "凛ルート八日目-04",
  "凛8-5": "凛ルート八日目-05",
  "凛8-6": "凛ルート八日目-06",
  "凛8-8": "凛ルート八日目-08",
  "凛8-9": "凛ルート八日目-09",
  "凛8-10": "凛ルート八日目-10",
  "凛8-11": "凛ルート八日目-11",
  "凛8-12": "凛ルート八日目-12",
  "凛9-0": "凛ルート九日目-00",
  "凛9-1": "凛ルート九日目-01",
  "凛9-2": "凛ルート九日目-02",
  "凛9-3": "凛ルート九日目-03",
  "凛9-4": "凛ルート九日目-04",
  "凛9-5": "凛ルート九日目-05",
  "凛9-7": "凛ルート九日目-07",
  "凛9-8": "凛ルート九日目-08",
  "凛9-9": "凛ルート九日目-09",
  "凛9-10": "凛ルート九日目-10",
  "凛9-11": "凛ルート九日目-11",
  "凛9-12": "凛ルート九日目-12",
  "凛9-13": "凛ルート九日目-13",
  "凛9-14": "凛ルート九日目-14",
  "桜10-0": "桜ルート十日目-00",
  "桜10-1": "桜ルート十日目-01",
  "桜10-2": "桜ルート十日目-02",
  "桜10-3": "桜ルート十日目-03",
  "桜10-4": "桜ルート十日目-04",
  "桜10-5": "桜ルート十日目-05",
  "桜10-6": "桜ルート十日目-06",
  "桜10-7": "桜ルート十日目-07",
  "桜10-8": "桜ルート十日目-08",
  "桜10-9": "桜ルート十日目-09",
  "桜10-10": "桜ルート十日目-10",
  "桜10-11": "桜ルート十日目-11",
  "桜10-12": "桜ルート十日目-12",
  "桜10-13": "桜ルート十日目-13",
  "桜10-14": "桜ルート十日目-14",
  "桜10-15": "桜ルート十日目-15",
  "桜10-16": "桜ルート十日目-16",
  "桜10-17": "桜ルート十日目-17",
  "桜10-18": "桜ルート十日目-18",
  "桜10-19": "桜ルート十日目-19",
  "桜10-20": "桜ルート十日目-20",
  "桜10-21": "桜ルート十日目-21",
  "桜10-22": "桜ルート十日目-22",
  "桜10-23": "桜ルート十日目-23",
  "桜10-24": "桜ルート十日目-24",
  "桜10-25": "桜ルート十日目-25",
  "桜10-26": "桜ルート十日目-26",
  "桜10-28": "桜ルート十日目-28",
  "桜10-29": "桜ルート十日目-29",
  "桜10-30": "桜ルート十日目-30",
  "桜10-31": "桜ルート十日目-31",
  "桜10-32": "桜ルート十日目-32",
  "桜10-33": "桜ルート十日目-33",
  "桜10-34": "桜ルート十日目-34",
  "桜10-35": "桜ルート十日目-35",
  "桜11-0": "桜ルート十一日目-00",
  "桜11-1": "桜ルート十一日目-01",
  "桜11-2": "桜ルート十一日目-02",
  "桜11-3": "桜ルート十一日目-03",
  "桜11-4": "桜ルート十一日目-04",
  "桜11-6": "桜ルート十一日目-06",
  "桜11-7": "桜ルート十一日目-07",
  "桜11-8": "桜ルート十一日目-08",
  "桜11-9": "桜ルート十一日目-09",
  "桜11-10": "桜ルート十一日目-10",
  "桜11-11": "桜ルート十一日目-11",
  "桜11-12": "桜ルート十一日目-12",
  "桜11-13": "桜ルート十一日目-13",
  "桜11-14": "桜ルート十一日目-14",
  "桜11-15": "桜ルート十一日目-15",
  "桜11-16": "桜ルート十一日目-16",
  "桜11-115": "桜ルート十一日目-115",
  "桜12-0": "桜ルート十二日目-00",
  "桜12-1": "桜ルート十二日目-01",
  "桜12-2": "桜ルート十二日目-02",
  "桜12-3": "桜ルート十二日目-03",
  "桜12-5": "桜ルート十二日目-05",
  "桜12-6": "桜ルート十二日目-06",
  "桜12-7": "桜ルート十二日目-07",
  "桜12-8": "桜ルート十二日目-08",
  "桜12-9": "桜ルート十二日目-09",
  "桜12-10": "桜ルート十二日目-10",
  "桜12-11": "桜ルート十二日目-11",
  "桜12-12": "桜ルート十二日目-12",
  "桜12-13": "桜ルート十二日目-13",
  "桜12-14": "桜ルート十二日目-14",
  "桜12-113": "桜ルート十二日目-113",
  "桜13-0": "桜ルート十三日目-00",
  "桜13-1": "桜ルート十三日目-01",
  "桜13-2": "桜ルート十三日目-02",
  "桜13-3": "桜ルート十三日目-03",
  "桜13-5": "桜ルート十三日目-05",
  "桜13-6": "桜ルート十三日目-06",
  "桜13-8": "桜ルート十三日目-08",
  "桜13-9": "桜ルート十三日目-09",
  "桜13-10": "桜ルート十三日目-10",
  "桜13-11": "桜ルート十三日目-11",
  "桜13-12": "桜ルート十三日目-12",
  "桜13-13": "桜ルート十三日目-13",
  "桜13-14": "桜ルート十三日目-14",
  "桜13-15": "桜ルート十三日目-15",
  "桜13-16": "桜ルート十三日目-16",
  "桜14-0": "桜ルート十四日目-00",
  "桜14-1": "桜ルート十四日目-01",
  "桜14-2": "桜ルート十四日目-02",
  "桜14-3": "桜ルート十四日目-03",
  "桜14-4": "桜ルート十四日目-04",
  "桜14-5": "桜ルート十四日目-05",
  "桜14-6": "桜ルート十四日目-06",
  "桜14-8": "桜ルート十四日目-08",
  "桜14-9": "桜ルート十四日目-09",
  "桜14-10": "桜ルート十四日目-10",
  "桜14-11": "桜ルート十四日目-11",
  "桜14-110": "桜ルート十四日目-110",
  "桜15-0": "桜ルート十五日目-00",
  "桜15-1": "桜ルート十五日目-01",
  "桜15-2": "桜ルート十五日目-02",
  "桜15-3": "桜ルート十五日目-03",
  "桜15-4": "桜ルート十五日目-04",
  "桜15-5": "桜ルート十五日目-05",
  "桜15-6": "桜ルート十五日目-06",
  "桜15-7": "桜ルート十五日目-07",
  "桜15-8": "桜ルート十五日目-08",
  "桜15-9": "桜ルート十五日目-09",
  "桜15-10": "桜ルート十五日目-10",
  "桜15-11": "桜ルート十五日目-11",
  "桜15-12": "桜ルート十五日目-12",
  "桜15-13": "桜ルート十五日目-13",
  "桜15-14": "桜ルート十五日目-14",
  "桜15-15": "桜ルート十五日目-15",
  "桜15-16": "桜ルート十五日目-16",
  "桜15-17": "桜ルート十五日目-17",
  "桜15-18": "桜ルート十五日目-18",
  "桜15-19": "桜ルート十五日目-19",
  "桜15-20": "桜ルート十五日目-20",
  "桜15-22": "桜ルート十五日目-22",
  "桜15-23": "桜ルート十五日目-23",
  "桜15-24": "桜ルート十五日目-24",
  "桜15-25": "桜ルート十五日目-25",
  "桜15-26": "桜ルート十五日目-26",
  "桜15-27": "桜ルート十五日目-27",
  "桜15-28": "桜ルート十五日目-28",
  "桜15-29": "桜ルート十五日目-29",
  "桜16-0": "桜ルート十六日目-00",
  "桜16-1": "桜ルート十六日目-01",
  "桜16-2": "桜ルート十六日目-02",
  "桜16-3": "桜ルート十六日目-03",
  "桜16-4": "桜ルート十六日目-04",
  "桜16-5": "桜ルート十六日目-05",
  "桜16-6": "桜ルート十六日目-06",
  "桜16-7": "桜ルート十六日目-07",
  "桜16-8": "桜ルート十六日目-08",
  "桜16-9": "桜ルート十六日目-09",
  "桜16-10": "桜ルート十六日目-10",
  "桜16-11": "桜ルート十六日目-11",
  "桜16-12": "桜ルート十六日目-12",
  "桜16-13": "桜ルート十六日目-13",
  "桜16-14": "桜ルート十六日目-14",
  "桜16-15": "桜ルート十六日目-15",
  "桜16-16": "桜ルート十六日目-16",
  "桜16-17": "桜ルート十六日目-17",
  "桜16-18": "桜ルート十六日目-18",
  "桜16-19": "桜ルート十六日目-19",
  "桜16-20": "桜ルート十六日目-20",
  "桜16-21": "桜ルート十六日目-21",
  "桜16-22": "桜ルート十六日目-22",
  "桜16-23": "桜ルート十六日目-23",
  "桜16-24": "桜ルート十六日目-24",
  "桜4-0": "桜ルート四日目-00",
  "桜4-1": "桜ルート四日目-01",
  "桜4-2": "桜ルート四日目-02",
  "桜4-3": "桜ルート四日目-03",
  "桜4-4": "桜ルート四日目-04",
  "桜4-5": "桜ルート四日目-05",
  "桜4-7": "桜ルート四日目-07",
  "桜4-8": "桜ルート四日目-08",
  "桜4-9": "桜ルート四日目-09",
  "桜4-10": "桜ルート四日目-10",
  "桜4-11": "桜ルート四日目-11",
  "桜5-0": "桜ルート五日目-00",
  "桜5-1": "桜ルート五日目-01",
  "桜5-2": "桜ルート五日目-02",
  "桜5-3": "桜ルート五日目-03",
  "桜5-4": "桜ルート五日目-04",
  "桜5-5": "桜ルート五日目-05",
  "桜5-6": "桜ルート五日目-06",
  "桜5-7": "桜ルート五日目-07",
  "桜5-8": "桜ルート五日目-08",
  "桜5-9": "桜ルート五日目-09",
  "桜5-10": "桜ルート五日目-10",
  "桜5-11": "桜ルート五日目-11",
  "桜5-12": "桜ルート五日目-12",
  "桜5-13": "桜ルート五日目-13",
  "桜5-14": "桜ルート五日目-14",
  "桜5-15": "桜ルート五日目-15",
  "桜5-16": "桜ルート五日目-16",
  "桜5-17": "桜ルート五日目-17",
  "桜5-19": "桜ルート五日目-19",
  "桜5-20": "桜ルート五日目-20",
  "桜5-21": "桜ルート五日目-21",
  "桜5-22": "桜ルート五日目-22",
  "桜5-117": "桜ルート五日目-117",
  "桜6-0": "桜ルート六日目-00",
  "桜6-1": "桜ルート六日目-01",
  "桜6-2": "桜ルート六日目-02",
  "桜6-3": "桜ルート六日目-03",
  "桜6-4": "桜ルート六日目-04",
  "桜6-5": "桜ルート六日目-05",
  "桜6-7": "桜ルート六日目-07",
  "桜6-8": "桜ルート六日目-08",
  "桜6-9": "桜ルート六日目-09",
  "桜6-10": "桜ルート六日目-10",
  "桜6-11": "桜ルート六日目-11",
  "桜6-16": "桜ルート六日目-16",
  "桜6-17": "桜ルート六日目-17",
  "桜6-18": "桜ルート六日目-18",
  "桜6-19": "桜ルート六日目-19",
  "桜6-20": "桜ルート六日目-20",
  "桜6-21": "桜ルート六日目-21",
  "桜6-22": "桜ルート六日目-22",
  "桜6-23": "桜ルート六日目-23",
  "桜7-0": "桜ルート七日目-00",
  "桜7-1": "桜ルート七日目-01",
  "桜7-2": "桜ルート七日目-02",
  "桜7-4": "桜ルート七日目-04",
  "桜7-5": "桜ルート七日目-05",
  "桜7-6": "桜ルート七日目-06",
  "桜7-7": "桜ルート七日目-07",
  "桜7-8": "桜ルート七日目-08",
  "桜7-9": "桜ルート七日目-09",
  "桜7-10": "桜ルート七日目-10",
  "桜7-11": "桜ルート七日目-11",
  "桜7-12": "桜ルート七日目-12",
  "桜7-13": "桜ルート七日目-13",
  "桜7-15": "桜ルート七日目-15",
  "桜7-16": "桜ルート七日目-16",
  "桜7-17": "桜ルート七日目-17",
  "桜7-18": "桜ルート七日目-18",
  "桜7-19": "桜ルート七日目-19",
  "桜7-20": "桜ルート七日目-20",
  "桜7-21": "桜ルート七日目-21",
  "桜8-0": "桜ルート八日目-00",
  "桜8-1": "桜ルート八日目-01",
  "桜8-2": "桜ルート八日目-02",
  "桜8-3": "桜ルート八日目-03",
  "桜8-4": "桜ルート八日目-04",
  "桜8-5": "桜ルート八日目-05",
  "桜8-6": "桜ルート八日目-06",
  "桜8-7": "桜ルート八日目-07",
  "桜8-8": "桜ルート八日目-08",
  "桜8-9": "桜ルート八日目-09",
  "桜8-11": "桜ルート八日目-11",
  "桜8-12": "桜ルート八日目-12",
  "桜8-13": "桜ルート八日目-13",
  "桜8-14": "桜ルート八日目-14",
  "桜8-15": "桜ルート八日目-15",
  "桜8-16": "桜ルート八日目-16",
  "桜8-17": "桜ルート八日目-17",
  "桜8-18": "桜ルート八日目-18",
  "桜8-19": "桜ルート八日目-19",
  "桜8-20": "桜ルート八日目-20",
  "桜8-21": "桜ルート八日目-21",
  "桜8-22": "桜ルート八日目-22",
  "桜8-23": "桜ルート八日目-23",
  "桜8-24": "桜ルート八日目-24",
  "桜9-0": "桜ルート九日目-00",
  "桜9-1": "桜ルート九日目-01",
  "桜9-2": "桜ルート九日目-02",
  "桜9-3": "桜ルート九日目-03",
  "桜9-4": "桜ルート九日目-04",
  "桜9-5": "桜ルート九日目-05",
  "桜9-6": "桜ルート九日目-06",
  "桜9-8": "桜ルート九日目-08",
  "桜9-9": "桜ルート九日目-09",
  "桜9-11": "桜ルート九日目-11",
  "桜9-12": "桜ルート九日目-12",
  "桜9-13": "桜ルート九日目-13",
  "桜9-14": "桜ルート九日目-14",
  "桜9-15": "桜ルート九日目-15",
  "桜9-16": "桜ルート九日目-16",
  "桜9-17": "桜ルート九日目-17",
  "桜9-18": "桜ルート九日目-18",
  "桜9-19": "桜ルート九日目-19",
  "桜9-20": "桜ルート九日目-20",
  "桜9-21": "桜ルート九日目-21",
  "桜9-22": "桜ルート九日目-22",
  "桜9-23": "桜ルート九日目-23",
  "桜9-24": "桜ルート九日目-24",
  "桜9-25": "桜ルート九日目-25",
  "桜9-26": "桜ルート九日目-26",
  "桜9-27": "桜ルート九日目-27",
  "桜9-28": "桜ルート九日目-28",
  "桜9-29": "桜ルート九日目-29",
  "桜9-30": "桜ルート九日目-30",
  "桜9-32": "桜ルート九日目-32",
  "桜9-33": "桜ルート九日目-33",
  "桜9-34": "桜ルート九日目-34",
  "桜9-35": "桜ルート九日目-35",
  "桜9-36": "桜ルート九日目-36",
  "桜9-37": "桜ルート九日目-37",
  "桜9-38": "桜ルート九日目-38",
  "桜9-39": "桜ルート九日目-39",
  "桜9-40": "桜ルート九日目-40",
  "桜9-41": "桜ルート九日目-41",
  "桜9-130": "桜ルート九日目-130",
}

export const sections = {
  v: [{
    v: [{
      section: "プ", v: [
        {id: "プ-1", eng: "2 days ago - Prologue", jp: ""},
        {id: "プ-2", eng: "1 day ago - Prologue", jp: ""},
        {id: "プ-3", eng: "The day - Prologue", jp: ""},
      ],
    }, {
      section: "セ1", v: [
        {
          id: "セ1-0",
          eng: "1st Day: Recollection of ten years ago-Morning/Rebirth",
          jp: "一日目・十年前の回想〜朝/Rebirth",
        },
        {
          h: [
            {id: "セ1-1", eng: "1st Day: Breakfast preparation/Matou Sakura (I)", jp: "一日目・朝の支度/間桐桜（Ⅰ）"},
            {id: "セ1-2", eng: "1st Day: Morning training/Dojo scenery", jp: "一日目・朝の鍛練/道場風景"},
          ],
        },
        {id: "セ1-6", eng: "1st Day: Breakfast/Morning in the Emiya household", jp: "一日目・朝食/衛宮邸の朝"},
        {id: "セ1-3", eng: "1st Day: School-After school/Everyday (I)", jp: "一日目・学校〜放課後/日常（Ⅰ）"},
        {
          h: [
            {id: "セ1-4", eng: "1st Day: After school/Flower on a high peak", jp: "一日目・放課後/高嶺の花"},
            {id: "セ1-5", eng: "1st Day: After school/Brownie chocolate cake", jp: "一日目・放課後/ブラウニーチョコケーキ"},
          ],
        },
        {id: "セ1-7", eng: "1st Day: Returning home at night/A white girl", jp: "一日目・夜の帰宅/白い少女"},
        {id: "セ1-9", eng: "1st Day: After dinner/Well done", jp: "一日目・夕食後/おつかれさまでした。"},
        {
          h: [
            {id: "セ1-11", eng: "1st Day: Night/The return of the orange man", jp: "一日目・夜/みかん星人の逆襲"},
            {id: "セ1-12", eng: "1st Day: Night/Well done even more", jp: "一日目・夜/更におつかれさまでした。"},
            {
              id: "セ1-13",
              eng: "1st Day: Night/Taking Sakura home, introductory chapter",
              jp: "一日目・夜/桜を送る、初級編",
            },
            {id: "セ1-14", eng: "1st Day: Night/Taking Sakura home, advanced chapter", jp: "一日目・夜/桜を送る、上級編"},
          ],
        },
        {id: "セ1-15", eng: "1st Day: Bedtime/Training (Magic Circuit)", jp: "一日目・就寝/鍛練（魔術回路）"},
      ],
    }, {
      section: "セ2", v: [
        {
          h: [
            {id: "セ2-13", eng: "2nd Day: Awakening/Trivial changes", jp: "二日目・目覚め/些細な変動"},
            {id: "セ2-0", eng: "2nd Day: Awakening/Morning in the Emiya household", jp: "二日目・目覚め/衛宮邸の朝"},
          ],
        },
        {
          h: [
            {id: "セ2-5", eng: "2nd Day: Morning/Dojo scenery", jp: "二日目・朝/道場風景"},
            {id: "セ2-6", eng: "2nd Day: Morning/Dojo scenery", jp: "二日目・朝/道場風景"},
            {id: "セ2-3", eng: "2nd Day: Breakfast preparation with Sakura/Signs", jp: "二日目・桜と朝食の支度/兆し"},
          ],
        },
        {id: "セ2-15", eng: "2nd Day: Breakfast/Morning in the Emiya household", jp: "二日目・朝食/衛宮邸の朝"},
        {id: "セ2-7", eng: "2nd Day: School/Everyday (II)", jp: "二日目・学校/日常（Ⅱ）"},
        {
          h: [
            {id: "セ2-9", eng: "2nd Day: After school/Choice", jp: "二日目・放課後/選択肢"},
            {id: "セ2-16", eng: "2nd Day: After school/Pipeline", jp: "二日目・放課後/パイプライン"},
          ],
        },
        {
          h: [
            {
              id: "セ2-10",
              eng: "2nd Day: After school, Sakura’s classroom/Matou Sakura (II)",
              jp: "二日目・放課後・桜の教室/間桐桜（Ⅱ）",
            },
            {
              id: "セ2-8",
              eng: "2nd Day: After School-Part time job/Tohsaka Rin (I)",
              jp: "二日目・放課後〜アルバイト/遠坂凛（Ⅰ）",
            },
          ],
        },
        {
          h: [
            {
              id: "セ2-4",
              eng: "2nd Day: After school-Part time job/Tohsaka Rin (I)",
              jp: "二日目・放課後〜アルバイト/遠坂凛（Ⅰ）",
            },
            {id: "セ2-1", eng: "2nd Day: Dinner/Love’s magical ranger force", jp: "二日目・夕食/恋のマジカルレンジャーフォース"},
          ],
        },
        {id: "セ2-14", eng: "2nd Day: Night-Matou household/Old man", jp: "二日目・夜〜間桐邸/翁"},
      ],
    },
    ],
  }, {
    h: [{
      section: "セ3", v: [
        {id: "セ3-8", eng: "3rd Day: Awakening-Morning/What is burned in", jp: "三日目・目覚め〜朝/焼きついたもの"},
        {
          h: [
            {id: "セ3-9", eng: "3rd Day: Morning-Journey to school/Unnatural mark", jp: "三日目・朝〜登校/不自然な痣"},
            {id: "セ3-10", eng: "3rd Day: Morning-Journey to school/Worsening bruise", jp: "三日目・朝〜登校/悪化する痣"},
          ],
        },
        {id: "セ3-1", eng: "3rd Day: After School-Night/Night of fate", jp: "三日目・放課後〜夜/運命の夜"},
        {id: "セ3-16", eng: "3rd Day: Night-Returning home/One more time", jp: "三日目・夜〜帰宅/もういちど"},
        {id: "セ3-0", eng: "Summoning of Saber. VS Lancer/Promised sign", jp: "セイバー召喚。ＶＳランサー/プロミスト・サイン"},
        {id: "セ3-17", eng: "3rd Day: Lecture on Masters/Tohsaka Rin (II)", jp: "三日目・マスター講座/遠坂凛（Ⅱ）"},
        {id: "セ3-2", eng: "3rd Day: Kotomine Church/Alter ego", jp: "三日目・言峰教会/オルター・エゴ"},
        {
          h: [
            {id: "セ3-18", eng: "3rd Day: Kotomine Church/Decision", jp: "三日目・言峰教会/決意。"},
            {id: "セ3-4", eng: "3rd Day: Night/Forest of no return", jp: "三日目・夜/帰らずの森"},
          ],
        },
        {
          h: [
            {id: "セ3-5", eng: "The Strongest Enemy", jp: "最強の敵"},
            {id: "セ3-11", eng: "Tiger Dojo 1", jp: "タイガー道場1"},
          ],
        },
        {
          h: [
            {id: "セ3-6", eng: "3rd Day: Late night/Canary’s cage", jp: "三日目・深夜/金糸雀の篭"},
            {id: "セ3-7", eng: "3rd Day: Last/Distortion (I)", jp: "三日目・ラスト/ディストレーション（Ⅰ）"},
          ],
        },
        {
          h: [
            {id: "セ3-12", eng: "3rd Day: Intermission/Worms from hell", jp: "三日目・幕間/奈落の虫"},
            {id: "セ3-19", eng: "Tiger Dojo 2", jp: "タイガー道場2"},
          ],
        },
      ],
    }, {
      section: "凛3", v: [
        {id: "凛3-9", eng: "3rd Day: Night/First Command Spell", jp: "三日目・夜/令呪、一回目"},
        {id: "凛3-10", eng: "3rd Day: Night-Rin-Church/Master Registration", jp: "三日目・夜〜凛〜教会/マスター登録"},
        {
          id: "凛3-11",
          eng: "3rd Day: Night, Returning home-Illya/Another night-VS Berserker",
          jp: "三日目・夜・帰宅〜イリヤ/もう一つの夜〜ＶＳバーサーカー",
        },
        {id: "凛3-0", eng: "VS Berserker/Choice", jp: "ＶＳバーサーカー/選択肢"},
        {
          h: [
            {id: "凛3-1", eng: "VS Berserker/Go where", jp: "ＶＳバーサーカー/何処に向かう"},
            {id: "凛3-3", eng: "VS Berserker/Equal match-Archer’s shot", jp: "ＶＳバーサーカー/互角の戦い〜アーチャーの狙撃"},
            {id: "凛3-2", eng: "VS Berserker/Third death", jp: "ＶＳバーサーカー/三度目の死"},
          ],
        },
        {
          h: [
            {id: "凛3-4", eng: "VS Berserker/Third death", jp: "ＶＳバーサーカー/三度目の死"},
            {id: "凛3-5", eng: "VS Berserker/Equal match-Archer’s shot", jp: "ＶＳバーサーカー/互角の戦い〜アーチャーの狙撃"},
            {id: "凛3-7", eng: "VS Berserker/Distortion (II)", jp: "ＶＳバーサーカー/ディストレーション（Ⅱ）"},
          ],
        },
        {
          h: [
            {id: "凛3-6", eng: "VS Berserker/Calling voice", jp: "ＶＳバーサーカー/呼び戻す声"},
            {id: "凛3-12", eng: "Tiger Dojo 15", jp: "タイガー道場15"},
          ],
        },
      ],
    },
    ],
  }, {
    h: [{
      v: [{
        section: "セ4", v: [
          {
            id: "セ4-0",
            eng: "4th Day: Awakening-My room/Principle of action-Tohsaka Rin (III)",
            jp: "四日目・目覚め〜自室/行動原理〜遠坂凛（Ⅲ）",
          },
          {
            h: [
              {
                id: "セ4-1",
                eng: "4th Day: Rin’s question/Understanding the current situation",
                jp: "四日目・凛の質問/現状把握",
              },
              {id: "セ4-2", eng: "4th Day: Rin’s question/The serious stuff", jp: "四日目・凛の質問/真面目な話"},
              {id: "セ4-3", eng: "4th Day: Rin’s question/Invitation refusal", jp: "四日目・凛の質問/勧誘お断り"},
            ],
          },
          {id: "セ4-4", eng: "4th Day: Morning/Rin’s proposal", jp: "四日目・朝/凛の提案"},
          {
            h: [
              {id: "セ4-18", eng: "4th Day: Morning/Contract established", jp: "四日目・朝/契約成立"},
              {id: "セ4-5", eng: "4th Day: Before noon/Solo&Only", jp: "四日目・午前中/ソロ＆オンリー"},
            ],
          },
          {id: "セ4-6", eng: "4th Day: Before noon/Saber (I)", jp: "四日目・午前/セイバー（Ⅰ）"},
          {
            h: [
              {id: "セ4-7", eng: "4th Day/No concern for safety", jp: "四日目/安否無用"},
              {id: "セ4-9", eng: "4th Day/Funny clothes", jp: "四日目/ファニードレス"},
              {id: "セ4-8", eng: "4th Day: Afternoon/Saber’s circumstances", jp: "四日目・午後/セイバーの事情"},
            ],
          },
          {id: "セ4-10", eng: "4th Day: Afternoon/Saber’s circumstances", jp: "四日目・午後/セイバーの事情"},
          {id: "セ4-11", eng: "4th Day: Dinner/Buddy Saber, buddy Rin", jp: "四日目・夕食/仲良しセイバー、仲良し凛"},
          {id: "セ4-12", eng: "4th Day: Night/Is my Master aptitude low?", jp: "四日目・夜/マスター適性、低めでしょうか？"},
          {id: "セ4-15", eng: "4th Day Bedtime: Shed/Star in the fog", jp: "四日目就寝・土蔵/霧中の星"},
        ],
      }, {
        section: "セ5", v: [
          {id: "セ5-0", eng: "5th Day: Morning/Rose and hydrangea", jp: "五日目・朝/薔薇と紫陽花"},
          {
            id: "セ5-4",
            eng: "5th Day: Breakfast-Way to school/Waku-waku Fuji-Nee land-Matou brother and sister",
            jp: "五日目・朝食〜登校/わくわく藤ねえランド〜間桐の兄妹",
          },
          {id: "セ5-5", eng: "5th Day: Lunchtime/Choice", jp: "五日目・昼休み/選択肢"},
          {
            h: [
              {id: "セ5-6", eng: "5th Day: Lunchtime/Tohsaka Rin (IV)", jp: "五日目・昼休み/遠坂凛（Ⅳ）"},
              {
                id: "セ5-7",
                eng: "5th Day: Lunchtime/Matou Sakura (III)-The anger of the great devil",
                jp: "五日目・昼休み/間桐桜（Ⅲ）〜大魔神怒る",
              },
            ],
          },
          {id: "セ5-8", eng: "5th Day: Return home-Evening/Question for Saber", jp: "五日目・下校〜夕方/セイバーへの質問"},
          {
            h: [
              {id: "セ5-9", eng: "5th Day: Question/Survivor", jp: "五日目・質問/サバイバー"},
              {id: "セ5-10", eng: "5th Day: Question/Unknown", jp: "五日目・質問/アンノウン"},
              {id: "セ5-11", eng: "5th Day: Question/Vela Gulf", jp: "五日目・質問/ヴェラガルフ"},
            ],
          },
          {id: "セ5-12", eng: "5th Day: Dinner/You too", jp: "五日目・夕食/君も一緒に"},
          {
            id: "セ5-14",
            eng: "5th Day: Dinner-Bedtime/Clash of the lion and the tiger",
            jp: "五日目・夕食〜就寝/激突、ライオン対トラ",
          },
        ],
      }, {
        section: "セ6", v: [
          {
            id: "セ6-12",
            eng: "6th Day: Breakfast-Way to school/Morning at the Emiya household: Festival",
            jp: "六日目・朝食〜登校/衛宮家の朝・お祭り編",
          },
          {id: "セ6-0", eng: "6th Day: School-Matou household/The fourth Master", jp: "六日目・学校〜間桐邸/第四のマスター"},
          {id: "セ6-1", eng: "6th Day: Shinji’s invitation, breakdown/Choice", jp: "六日目・慎二の誘い、決裂/選択肢"},
          {
            h: [
              {
                id: "セ6-3",
                eng: "6th Day: Return from the Matou household/Lady of fresh blood",
                jp: "六日目・間桐邸帰り/鮮血淑女",
              },
              {
                id: "セ6-4",
                eng: "6th Day: Return from the Matou household/Averting one’s gaze",
                jp: "六日目・間桐邸帰り/視線を合わさず",
              },
            ],
          },
          {id: "セ6-13", eng: "6th Day: Return home-Dinner/Everyone getting along", jp: "六日目・帰宅〜夕食/みんな仲良く"},
          {
            id: "セ6-5",
            eng: "6th Day: Night/Strategy Meeting. Should we challenge Ryuudou temple?",
            jp: "六日目・夜/作戦会議。柳洞寺に挑むべきか？",
          },
          {
            h: [
              {id: "セ6-7", eng: "6th Day: Night/Conflict between the two", jp: "六日目・夜/二人の齟齬"},
              {
                id: "セ6-6",
                eng: "6th Day: Late night-Ryuudou temple/Missing Ariadne",
                jp: "六日目・深夜〜柳洞寺/ミッシング・アリアドネ",
              },
            ],
          },
          {
            h: [
              {id: "セ6-8", eng: "Intermission/Elegant moonlight-VS Assassin", jp: "幕間/月下流麗〜ＶＳアサシン"},
              {id: "セ6-15", eng: "Tiger Dojo 3", jp: "タイガー道場3"},
            ],
          },
          {id: "セ6-9", eng: "6th Day: Late night/Absence of Saber", jp: "六日目・深夜/セイバー不在"},
          {id: "セ6-14", eng: "Intermission/“Demonic Sword”-VS Assassin 2", jp: "幕間/「魔剣」〜ＶＳアサシン２"},
          {id: "セ6-10", eng: "6th Day: Return home-Contract/Boy Meets Girl (I)", jp: "六日目・帰還〜契約/ボーイ・ミーツ・ガール（Ⅰ）"},
        ],
      }, {
        section: "セ7", v: [
          {
            id: "セ7-0",
            eng: "7th Day: Awakening-Morning/Superhero and the usual breakfast",
            jp: "七日目・目覚め〜朝/正義の味方といつもの朝食",
          },
          {
            id: "セ7-2",
            eng: "7th Day: Before noon: Training swordsmanship/Life guard",
            jp: "七日目・午前・剣の修行/ライフ・ガード",
          },
          {
            h: [
              {
                id: "セ7-4",
                eng: "7th Day: Conversation with Saber/What to pour into the Grail",
                jp: "七日目・セイバーとの会話/杯に注ぐもの",
              },
              {
                id: "セ7-5",
                eng: "7th Day: Conversation with Saber/Hero apocalypse story",
                jp: "七日目・セイバーとの会話/英雄黙示譚",
              },
              {
                id: "セ7-6",
                eng: "7th Day: Conversation with Saber/Saber-san angry",
                jp: "七日目・セイバーとの会話/セイバーさんご立腹",
              },
            ],
          },
          {id: "セ7-7", eng: "7th Day: Noon/The daughter of winter-Illya (I)", jp: "七日目・昼/冬の娘〜イリヤ（Ⅰ）"},
          {
            id: "セ7-28",
            eng: "7th Day: Return home-Before dinner/Shirou peeping incident: Prelude",
            jp: "七日目・帰宅〜夕食前/士郎覗き事件・序",
          },
          {
            id: "セ7-1",
            eng: "7th Day: After dinner/Magic Lecture (Magic Crest)",
            jp: "七日目・夕食後/魔術講座（魔術刻印）",
          },
          {id: "セ7-3", eng: "7th Day: Late night-Bedtime/Differing person", jp: "七日目・深夜〜就寝/異なる者"},
          {
            id: "セ7-8",
            eng: "8th Day: Morning-Training swordsmanship/Life guard & safe",
            jp: "八日目・朝〜剣の修行/ライフガード＆セーフ",
          },
          {
            h: [
              {
                id: "セ7-12",
                eng: "8th Day: Conversation with Saber/Hero apocalypse story",
                jp: "八日目・セイバーとの会話/英雄黙示譚",
              },
              {
                id: "セ7-13",
                eng: "8th Day: Conversation with Saber/Saber-san angry",
                jp: "八日目・セイバーとの会話/セイバーさんご立腹",
              },
              {
                id: "セ7-14",
                eng: "8th Day: Conversation with Saber/What to pour into the Grail",
                jp: "八日目・セイバーとの会話/杯に注ぐもの",
              },
              {
                id: "セ7-15",
                eng: "8th Day: Conversation with Saber/Saber-san angry",
                jp: "八日目・セイバーとの会話/セイバーさんご立腹",
              },
              {
                id: "セ7-16",
                eng: "8th Day: Conversation with Saber/What to pour into the Grail",
                jp: "八日目・セイバーとの会話/杯に注ぐもの",
              },
              {
                id: "セ7-17",
                eng: "8th Day: Conversation with Saber/Hero apocalypse story",
                jp: "八日目・セイバーとの会話/英雄黙示譚",
              },
            ],
          },
          {id: "セ7-18", eng: "8th Day: Noon/Shopping district", jp: "八日目・昼/商店街"},
          {
            h: [
              {id: "セ7-19", eng: "8th Day: Lunch/Last stand Saber", jp: "八日目・昼食/背水セイバー"},
              {id: "セ7-20", eng: "8th Day: Lunch/Daughter of winter-Illya (II)", jp: "八日目・昼/冬の娘〜イリヤ（Ⅱ）"},
            ],
          },
          {id: "セ7-29", eng: "8th Day: Afternoon/Issei’s get well visit-Types of smiles", jp: "八日目・午後/笑顔の種類"},
          {id: "セ7-21", eng: "8th Day: Before Dinner/Choice", jp: "八日目・夕食前/選択肢"},
          {
            h: [
              {id: "セ7-22", eng: "8th Day: Afternoon/Funny lion", jp: "八日目・夕方/ファニーライオン"},
              {id: "セ7-23", eng: "8th Day: Afternoon/Orange pekoe mystery", jp: "八日目・夕方/オレンジペコーの怪"},
              {id: "セ7-24", eng: "8th Day: Afternoon/Golden bath", jp: "八日目・夕方/金色の湯浴み"},
            ],
          },
          {id: "セ7-25", eng: "8th Day: Night/Bare-Knuckle Rin", jp: "八日目・夜/ベアナックラーリン"},
          {id: "セ7-27", eng: "8th Day: Night/Magic Lecture (Switch)", jp: "八日目・夜/魔術講座（スイッチ）"},
        ],
      }, {
        section: "セ9", v: [
          {id: "セ9-15", eng: "9th Day: Awakening-Breakfast/Infringed table", jp: "九日目・起床〜朝食/侵食される食卓"},
          {
            id: "セ9-0",
            eng: "9th Day: Before noon-Afternoon/Training swordsmanship-Rin’s lecture",
            jp: "九日目・午前〜午後/剣の稽古〜凛の授業",
          },
          {
            h: [
              {id: "セ9-1", eng: "9th Day: Sequel/“Works”", jp: "九日目・余談/「ワークス」"},
              {id: "セ9-2", eng: "9th Day: Afternoon/Let’s Hachikou", jp: "九日目・午後/レッツハチ公"},
            ],
          },
          {id: "セ9-3", eng: "9th Day: Afternoon/Blood Temple-VS Rider (I)", jp: "九日目・午後/鮮血神殿〜ＶＳライダー（Ⅰ）"},
          {
            h: [
              {id: "セ9-4", eng: "VS Rider (I)/Attack", jp: "ＶＳライダー（Ⅰ）/攻撃"},
              {id: "セ9-5", eng: "VS Rider (I)/Defense", jp: "ＶＳライダー（Ⅰ）/防御"},
            ],
          },
          {id: "セ9-6", eng: "VS Rider (I)/Sparks", jp: "ＶＳライダー（Ⅰ）/スパークス"},
          {
            h: [
              {id: "セ9-8", eng: "VS Rider (I)/Fall down, your mind", jp: "ＶＳライダー（Ⅰ）/フォールダウン、ユアマインド"},
              {id: "セ9-7", eng: "VS Rider (I)/Melty Blood", jp: "ＶＳライダー（Ⅰ）/メルティブラッド"},
            ],
          },
          {
            h: [
              {id: "セ9-9", eng: "VS Rider (I)/Summoning Saber", jp: "ＶＳライダー（Ⅰ）/セイバー召喚"},
              {id: "セ9-10", eng: "VS Rider (I)/Summoning and rescue", jp: "ＶＳライダー（Ⅰ）/召喚と救出"},
              {id: "セ9-11", eng: "VS Rider (I)/Rafflesia umbrella", jp: "ＶＳライダー（Ⅰ）/ラフレシア・アンブレラ"},
              {id: "セ9-16", eng: "Tiger Dojo 4", jp: "タイガー道場4"},
            ],
          },
          {
            h: [
              {id: "セ9-12", eng: "VS Rider (I)/Crazy train", jp: "ＶＳライダー（Ⅰ）/クレイジー・トレイン"},
              {id: "セ9-17", eng: "Tiger Dojo 5", jp: "タイガー道場5"},
            ],
          },
          {id: "セ9-14", eng: "9th Day: Night/Boy meets girl (II)", jp: "九日目・夜/ボーイ・ミーツ・ガール（Ⅱ）"},
        ],
      }, {
        section: "セ10", v: [
          {id: "セ10-0", eng: "10th Day: Awakening-Morning/Strategy meeting", jp: "十日目・起床〜朝/作戦会議"},
          {
            id: "セ10-9",
            eng: "10th Day: Afternoon-Memory of ten years ago/Portrait",
            jp: "十日目・午後〜十年前の回想/ポートレイト",
          },
          {id: "セ10-2", eng: "VS Rider (II)/Assault", jp: "ＶＳライダー（Ⅱ）/強襲"},
          {
            h: [
              {id: "セ10-1", eng: "VS Rider (II)/Death Circus", jp: "ＶＳライダー（Ⅱ）/デス・サーカス"},
              {id: "セ10-3", eng: "10th Day-Morning/Nutcracker doll", jp: "十日目〜朝/くるみ割り人形"},
            ],
          },
          {
            h: [
              {id: "セ10-4", eng: "VS Rider (II)/Sword of Promised Victory", jp: "ＶＳライダー（Ⅱ）/約束された勝利の剣"},
              {id: "セ10-10", eng: "Tiger Dojo 6", jp: "タイガー道場6"},
            ],
          },
          {
            h: [
              {id: "セ10-5", eng: "10th Day: Night/Remains of Tragedy", jp: "十日目・夜/惨劇の跡"},
              {id: "セ10-6", eng: "10th Day: Night/Boy meets girl (III)", jp: "十日目・夜/ボーイ・ミーツ・ガール（Ⅲ）"},
            ],
          },
          {id: "セ10-7", eng: "10th Day: Bedtime/Reparation for victory", jp: "十日目・就寝/勝利の代償"},
        ],
      }, {
        section: "セ11", v: [
          {
            id: "セ11-0",
            eng: "11th Day: Awakening-Outside/The king’s memories-Follow through",
            jp: "十一日目・起床〜外へ/王の記憶〜残心",
          },
          {
            id: "セ11-16",
            eng: "11th Day: Morning in the park/Charming white eyes-Illya (III)",
            jp: "十一日目・朝の公園/白い呪眼〜イリヤ（Ⅲ）",
          },
          {
            h: [
              {id: "セ11-2", eng: "11th Day: Einzbern Castle/Refusal and escape", jp: "十一日目・アインツベルン城/拒絶と脱出"},
              {id: "セ11-1", eng: "11th Day: Einzbern Castle/Heaven’s dress", jp: "十一日目・アインツベルン城/天のドレス"},
            ],
          },
          {
            h: [
              {id: "セ11-3", eng: "11th Day: Einzbern Castle/Small resistance", jp: "十一日目・アインツベルン城/小さな抵抗"},
              {id: "セ11-4", eng: "11th Day: Einzbern Castle/Means of escape", jp: "十一日目・アインツベルン城/活路を見出す"},
              {
                id: "セ11-5",
                eng: "11th Day: Einzbern Castle/Stuffed animal room murder case",
                jp: "十一日目・アインツベルン城/ぬいぐるみ部屋殺人事件",
              },
              {id: "セ11-20", eng: "Tiger Dojo 7", jp: "タイガー道場7"},
            ],
          },
          {id: "セ11-17", eng: "11th Day: Einzbern Castle lobby/A distant back", jp: "十一日目・アインツベルン城ロビー/遠い背中"},
          {id: "セ11-19", eng: "11th Day: Escape from Einzbern Castle/Elopement", jp: "十一日目・アインツベルン城脱出/逃避行"},
          {
            h: [
              {id: "セ11-18", eng: "11th Day: Ruins in the forest/Dragon’s core", jp: "十一日目・森の廃墟/竜の炉心"},
              {
                id: "セ11-118",
                eng: "11th Day: Ruins in the forest/Boy meets girl & girl",
                jp: "十一日目・森の廃墟/ボーイ・ミーツ・ガール＆ガール",
              },
            ],
          },
          {
            id: "セ11-6",
            eng: "Intermission: Archer and Berserker/11th Day: Dawn in the ruins",
            jp: "幕間・弓兵と狂戦士/十一日目・廃墟の夜明け",
          },
          {
            h: [
              {id: "セ11-7", eng: "Morning in the ruins/Boy meets girl (IV)", jp: "廃墟の朝/ボーイ・ミーツ・ガール（Ⅳ）"},
              {id: "セ11-8", eng: "Morning in the ruins/Gold rush?", jp: "廃墟の朝/ごーるど・らっしゅ？"},
            ],
          },
          {id: "セ11-9", eng: "VS Berserker/Replay of the legend", jp: "ＶＳバーサーカー/神話再生"},
          {
            h: [
              {id: "セ11-10", eng: "VS Berserker/Small resistance", jp: "ＶＳバーサーカー/小さな抵抗"},
              {id: "セ11-11", eng: "VS Berserker/Developing means", jp: "ＶＳバーサーカー/活路を見出す"},
            ],
          },
          {id: "セ11-12", eng: "VS Berserker/Twelve Labors", jp: "ＶＳバーサーカー/十二の試練"},
          {
            h: [
              {id: "セ11-13", eng: "VS Berserker/Night without dawn", jp: "ＶＳバーサーカー/明けない夜"},
              {
                id: "セ11-14",
                eng: "VS Berserker/And thus I pray, Unlimited Blade Works",
                jp: "ＶＳバーサーカー/And thus I pray,unlimited blade works.",
              },
            ],
          },
          {id: "セ11-21", eng: "Tiger Dojo 8", jp: "タイガー道場8"},
        ],
      }, {
        section: "セ12", v: [
          {
            id: "セ12-13",
            eng: "12th Day: Awakening-Morning/The king’s memories-Saber acting strange",
            jp: "十二日目・起床〜朝/王の記憶〜おかしなセイバー",
          },
          {
            id: "セ12-0",
            eng: "12th Day: Breakfast preparation/Saber, Rin, Illya: A great morning battle",
            jp: "十二日目・朝食/ハンバーグ争奪戦",
          },
          {
            h: [
              {id: "セ12-1", eng: "12th Day: Morning/Saber, sulking", jp: "十二日目・朝/セイバー、拗ねる"},
              {id: "セ12-2", eng: "12th Day: Morning/Illya, sulking", jp: "十二日目・朝/イリヤ、拗ねる"},
            ],
          },
          {
            id: "セ12-3",
            eng: "12th Day: Morning-Noon/Training swordsmanship-Saber still acting strangely",
            jp: "十二日目・午前〜昼/剣の修行〜やっぱりおかしなセイバー",
          },
          {
            h: [
              {id: "セ12-4", eng: "Lunchtime/Obedient nod", jp: "お昼の時間/素直に頷く"},
              {id: "セ12-5", eng: "Lunchtime/Saber, blushing", jp: "お昼の時間/セイバー、赤面"},
              {id: "セ12-6", eng: "Lunchtime/Brave leader Hungryheart", jp: "お昼の時間/闘将ハングリーハート"},
            ],
          },
          {id: "セ12-14", eng: "12th Day: Lunch/Lunchtime", jp: "十二日目・昼食/ランチタイム"},
          {id: "セ12-7", eng: "12th Day: Afternoon/Magic Lecture (Permit)", jp: "十二日目・午後/魔術講座（仮免許）"},
          {
            h: [
              {id: "セ12-8", eng: "How and why questions/About the projection magic", jp: "なぜなにクエスチョン/投影魔術について"},
              {id: "セ12-9", eng: "How and why questions/So, it’s strong", jp: "なぜなにクエスチョン/頑丈なんだ"},
              {id: "セ12-10", eng: "How and why questions/Is silence best?", jp: "なぜなにクエスチョン/沈黙は美徳とか"},
            ],
          },
          {id: "セ12-11", eng: "12th Day: Rin’s guest room/Saber (II)", jp: "十二日目・凛の客間/セイバー（Ⅱ）"},
          {
            id: "セ12-12",
            eng: "12th Day: Dinner-Dressing room/Peeping incident: Caught red-handed",
            jp: "十二日目・夕食〜脱衣場/覗き事件・現行犯逮捕",
          },
          {id: "セ12-15", eng: "12th Day: Night-Bedtime/Saber (III)", jp: "十二日目・夜〜就寝/セイバー（Ⅲ）"},
        ],
      }, {
        section: "セ13", v: [
          {id: "セ13-3", eng: "13th Day: Awakening/The king’s memories", jp: "十三日目・起床/王の記憶"},
          {id: "セ13-12", eng: "13th Day: Breakfast/Sweets", jp: "十三日目・朝食/スイート"},
          {
            id: "セ13-6",
            eng: "13th Day: Training swordsmanship-Lunchtime/Saber (IV)",
            jp: "十三日目・剣の稽古〜昼食/セイバー（Ⅳ）",
          },
          {
            id: "セ13-13",
            eng: "13th Day: Afternoon/Tohsaka Sensei’s misunderstanding-Saber’s contradiction",
            jp: "十三日目・午後/遠坂先生の勘違い〜セイバーの矛盾",
          },
          {
            id: "セ13-0",
            eng: "13th Day: Night, use of the Holy Grail/Saber (V)-VS Caster",
            jp: "十三日目・夜、聖杯の使い道/セイバー（Ⅴ）〜ＶＳキャスター",
          },
          {
            h: [
              {id: "セ13-2", eng: "VS Caster/Melee", jp: "ＶＳキャスター/乱戦"},
              {id: "セ13-1", eng: "VS Caster/Walpurgis night", jp: "ＶＳキャスター/ワルプルギスの夜"},
            ],
          },
          {
            h: [
              {id: "セ13-4", eng: "VS Caster/Premonition", jp: "ＶＳキャスター/予感"},
              {id: "セ13-5", eng: "VS Caster/Walpurgis night", jp: "ＶＳキャスター/ワルプルギスの夜"},
            ],
          },
          {
            h: [
              {id: "セ13-9", eng: "VS Caster/The eighth Servant", jp: "ＶＳキャスター/第八のサーヴァント"},
              {id: "セ13-8", eng: "VS Caster/Witch’s mark", jp: "ＶＳキャスター/魔女の烙印"},
              {id: "セ13-15", eng: "Tiger Dojo 9", jp: "タイガー道場9"},
            ],
          },
          {
            h: [
              {id: "セ13-7", eng: "13th Day: Night: Meeting/Ten years ago (I)", jp: "十三日目・夜・会議/十年前（Ⅰ）"},
              {id: "セ13-16", eng: "Tiger Dojo 10", jp: "タイガー道場10"},
            ],
          },
          {
            id: "セ13-11",
            eng: "13th Day: Late night-To the church/Ten years ago (II)",
            jp: "十三日目・深夜〜教会へ/十年前（Ⅱ）",
          },
          {id: "セ13-14", eng: "13th Day: Late night/You’re my only star", jp: "十三日目・深夜／Youre My Only Star"},
        ],
      }, {
        section: "セ14", v: [
          {id: "セ14-6", eng: "14th Day: Morning-Date/Hurry go round", jp: "十四日目・朝〜デート/ハリー・ゴー・ランド"},
          {id: "セ14-8", eng: "14th Day: Date/Boy meets girl (V)", jp: "十四日目・デート/ボーイ・ミーツ・ガール（Ⅴ）"},
          {id: "セ14-7", eng: "14th Day: Date/Present", jp: "十四日目・デート/プレゼント"},
          {id: "セ14-9", eng: "14th Day: Return home/Parting at the bridge", jp: "十四日目・帰宅/橋上の別れ"},
          {id: "セ14-10", eng: "14th Day: Night-To town/Last boy meets girl", jp: "十四日目・夜〜街へ/ラスト・ボーイ・ミーツ・ガール"},
          {id: "セ14-0", eng: "Encounter/Oldest king", jp: "遭遇/最古の王"},
          {id: "セ14-2", eng: "VS Gilgamesh/What I want to protect", jp: "ＶＳギルガメッシュ/守りたいもの"},
          {
            h: [
              {id: "セ14-4", eng: "VS Gilgamesh/Wish", jp: "ＶＳギルガメッシュ/願い"},
              {id: "セ14-3", eng: "VS Gilgamesh/One end", jp: "ＶＳギルガメッシュ/一つの結末"},
            ],
          },
          {
            h: [
              {id: "セ14-111", eng: "14th Day: Night: My room/What I’ve gained", jp: "十四日目・夜・自室/手に入れたもの"},
              {id: "セ14-11", eng: "14th Day: Night: My room/What I’ve gained", jp: "十四日目・夜・自室/手に入れたもの"},
              {id: "セ14-12", eng: "Tiger Dojo 11", jp: "タイガー道場11"},
            ],
          },
          {id: "セ14-101", eng: "14th Day: Night: My room/Temporary dream", jp: "十四日目・夜・自室/いっときのユメ"},
        ],
      }, {
        section: "セ15", v: [
          {id: "セ15-0", eng: "15th Day: Awakening-To the church/Spiral ladder", jp: "十五日目・起床〜教会へ/スパイラル・ラダー"},
          {
            h: [
              {
                id: "セ15-2",
                eng: "15th Day: Church underground/Price of survival, settlement with fate",
                jp: "十五日目・教会地下/生存代償、因縁清算",
              },
              {id: "セ15-1", eng: "15th Day: Before noon/Time limit", jp: "十五日目・午前/タイム・リミット"},
            ],
          },
          {
            h: [
              {id: "セ15-18", eng: "Intermission/Saber, to the church", jp: "幕間/セイバー、教会へ"},
              {id: "セ15-23", eng: "Tiger Dojo 12", jp: "タイガー道場12"},
            ],
          },
          {id: "セ15-19", eng: "15th Day: Church underground/Go along the cheek", jp: "十五日目・教会地下/ほほをつたう"},
          {id: "セ15-20", eng: "Intermission/Conflict", jp: "幕間/葛藤"},
          {
            h: [
              {id: "セ15-21", eng: "15th Day: Church/That which cannot be surrendered", jp: "十五日目・教会/ゆずれぬとが"},
              {
                id: "セ15-3",
                eng: "15th Day: Church underground/That which cannot be changed",
                jp: "十五日目・教会地下/変えられぬもの",
              },
            ],
          },
          {
            h: [
              {
                id: "セ15-22",
                eng: "15th Day: Escape-Foreigner’s cemetery/Shining star",
                jp: "十五日目・脱出〜外人墓地/輝ける星",
              },
              {id: "セ15-24", eng: "Tiger Dojo 13", jp: "タイガー道場13"},
            ],
          },
          {id: "セ15-14", eng: "15th Day: Return home-Rin/Choice", jp: "十五日目・帰宅〜凛/選択肢"},
          {
            h: [
              {id: "セ15-15", eng: "Question/Nod", jp: "質問/頷く"},
              {id: "セ15-16", eng: "Question/Question", jp: "質問/問い"},
            ],
          },
          {id: "セ15-4", eng: "15th Day: Night/Before the decisive battle", jp: "十五日目・夜/決戦前"},
          {
            h: [
              {id: "セ15-7", eng: "15th Day: In the shed/Strategy meeting", jp: "十五日目・土蔵内/作戦会議"},
              {id: "セ15-5", eng: "15th Day: Night/Final training", jp: "十五日目・夜/最後の稽古"},
              {id: "セ15-6", eng: "15th Day: Night/Decision", jp: "十五日目・夜/決意"},
            ],
          },
          {
            h: [
              {id: "セ15-10", eng: "15th Day: Night/Holy Sword restoration", jp: "十五日目・夜/聖剣返還"},
              {id: "セ15-8", eng: "15th Day: Night: Shed/Trump unknown", jp: "十五日目・夜・土蔵/切り札不明"},
              {id: "セ15-9", eng: "15th Day: Night: Shed/Trump unknown", jp: "十五日・夜・土蔵/切り札不明"},
            ],
          },
          {
            h: [
              {id: "セ15-11", eng: "Fate／stay night (I)", jp: "フェイト／ステイナイト（Ⅰ）"},
              {id: "セ15-12", eng: "15th Day: Decisive battle/Holy Grail completed", jp: "十五日目・決戦/聖杯成就"},
            ],
          },
          {
            h: [
              {id: "セ15-13", eng: "Fate／stay night (II)", jp: "フェイト／ステイナイト（Ⅱ）"},
              {id: "セ15-25", eng: "Tiger Dojo 14", jp: "タイガー道場14"},
            ],
          },
          {id: "セ15-17", eng: "Gold separation", jp: "黄金の別離。"},
        ],
      },
      ],
    }, {
      v: [{
        section: "凛4", v: [
          {
            id: "凛4-0",
            eng: "4th Day: Awakening-My room/Separation with Rin-Saber",
            jp: "四日目・目覚め〜自室/凛との決別〜セイバー",
          },
          {
            h: [
              {id: "凛4-1", eng: "Conversation/Flawless blindspot", jp: "会話中/無傷の死角"},
              {id: "凛4-2", eng: "Conversation/Self-healing", jp: "会話中/自然治癒"},
            ],
          },
          {
            id: "凛4-10",
            eng: "4th Day: Dojo-Phone/Saber’s compromise-Mistake that is yet to be seen",
            jp: "四日目・道場〜電話/セイバーの和解〜まだ見ぬ過ち",
          },
          {id: "凛4-3", eng: "4th Day: Afternoon: School/Telephone murder Fuji", jp: "四日目・午後・学校/テレフォンマーダー藤"},
          {
            h: [
              {id: "凛4-4", eng: "4th Day: Archery range/Shooting", jp: "四日目・弓道場/立射"},
              {id: "凛4-5", eng: "4th Day: Student council room/Breathing", jp: "四日目・生徒会室/是の呼吸"},
              {
                id: "凛4-6",
                eng: "4th Day: Showing around school/Do not play with the sheath",
                jp: "四日目・学校案内/鞘で遊んではいけません",
              },
            ],
          },
          {
            id: "凛4-7",
            eng: "4th Day: Returning home-Dinner/Introduce Saber to Fuji-Nee-Girls United?",
            jp: "四日目・帰宅〜夕食/藤ねえたちにセイバーを紹介〜女の子同盟？",
          },
          {
            h: [
              {id: "凛4-9", eng: "4th Day: Night-Bedtime/Training, meditation", jp: "四日目・夜〜就寝/鍛練、瞑想"},
              {id: "凛4-12", eng: "4th Day: Bedtime/Training in magic", jp: "四日目・就寝/魔術鍛練"},
            ],
          },
          {id: "凛4-11", eng: "Intermission/Tohsaka Rin (II)", jp: "幕間/遠坂凛（Ⅱ）"},
        ],
      }, {
        section: "凛5", v: [
          {id: "凛5-0", eng: "5th Day: Morning/Choice", jp: "五日目・朝/選択肢。"},
          {
            h: [
              {id: "凛5-1", eng: "5th Day: Morning/See how Saber’s doing", jp: "五日目・朝/セイバーの様子を見る"},
              {id: "凛5-2", eng: "5th Day: Morning/Preparation of breakfast with Sakura", jp: "五日目・朝/桜と朝食の支度"},
              {id: "凛5-3", eng: "5th Day: Morning/Fuji-Nee Jigoku Guruma", jp: "五日目・朝/藤ねえ地獄車"},
            ],
          },
          {id: "凛5-20", eng: "5th Day: Breakfast-Way to school/Everyday (II)", jp: "五日目・朝食〜登校/日常（Ⅱ）"},
          {
            h: [
              {
                id: "凛5-21",
                eng: "5th Day: Morning, school/Tohsaka Rin, Mitsuzuri Ayako",
                jp: "五日目・朝、学校/遠坂凛、美綴綾子",
              },
              {id: "凛5-27", eng: "5th Day: School/Compensation for the pride", jp: "五日目・学校/誇りの代償"},
            ],
          },
          {id: "凛5-4", eng: "5th Day: After school/Tohsaka Rin (III)", jp: "五日目・放課後/遠坂凛（Ⅲ）"},
          {
            h: [
              {id: "凛5-6", eng: "VS Tohsaka Rin/Panic sonic roller coaster", jp: "ＶＳ遠坂凛/パニックソニックコースター"},
              {id: "凛5-5", eng: "5th Day: After school/Texture", jp: "五日目・放課後/テクスチャー"},
            ],
          },
          {
            h: [
              {
                id: "凛5-9",
                eng: "5th Day: Staredown-To the woods/Hanging death-VS Rider",
                jp: "五日目・睨み合い〜雑木林へ/絞首刑〜ＶＳライダー",
              },
              {id: "凛5-25", eng: "Tiger Dojo 16", jp: "タイガー道場16"},
            ],
          },
          {
            h: [
              {id: "凛5-11", eng: "VS Rider/Fighting back", jp: "ＶＳライダー/応戦"},
              {id: "凛5-12", eng: "VS Rider/Hard fighting", jp: "ＶＳライダー/奮戦"},
              {id: "凛5-10", eng: "VS Rider/Spider’s captive", jp: "ＶＳライダー/蜘蛛の虜"},
            ],
          },
          {
            h: [
              {
                id: "凛5-13",
                eng: "5th Day: Woods-Tohsaka residence/Rin’s treatment",
                jp: "五日目・雑木林〜遠坂邸/凛の治療",
              },
              {id: "凛5-26", eng: "Tiger Dojo 17", jp: "タイガー道場17"},
            ],
          },
          {
            h: [
              {id: "凛5-14", eng: "5th Day: Rin’s room/Natural-healing body", jp: "五日目・凛の部屋/自然治癒の体"},
              {id: "凛5-15", eng: "5th Day: Rin’s room/Healing still present", jp: "五日目・凛の部屋/治癒健在"},
            ],
          },
          {id: "凛5-22", eng: "5th Day: Rin’s room/Cooperation established", jp: "五日目・凛の部屋/協力関係、成立"},
          {id: "凛5-23", eng: "5th Day: Return home/Definition of a hero", jp: "五日目・帰宅/英雄の定義"},
          {id: "凛5-24", eng: "5th Day: Dinner/Tonight’s dinner", jp: "五日目・夕食/本日の夕食"},
          {
            id: "凛5-16",
            eng: "5th Day: Night/Inform Saber about cooperation with Rin",
            jp: "五日目・夜/セイバーに、凛と協力関係になったと報告。",
          },
          {
            h: [
              {id: "凛5-17", eng: "5th Day: Bedtime/Warning", jp: "五日目・就寝/忠告"},
              {id: "凛5-18", eng: "5th Day: Bedtime/Agreement", jp: "五日目・就寝/同意"},
            ],
          },
        ],
      }, {
        section: "凛6", v: [
          {id: "凛6-13", eng: "Intermission/A story", jp: "幕間/ある話。"},
          {id: "凛6-8", eng: "6th Day: Morning-School/Shinji and Mitsuzuri", jp: "六日目・朝〜学校/慎二と美綴"},
          {id: "凛6-9", eng: "6th Day: After school/Boundary field search", jp: "六日目・放課後/結界探し"},
          {id: "凛6-10", eng: "6th Day: After school/Master identified", jp: "六日目・放課後/マスター判明"},
          {
            id: "凛6-0",
            eng: "6th Day: Return home, before dinner/Fuji-Nee’s three minute ducking",
            jp: "六日目・帰宅、夕食前/藤ねえの三分間ダッキング",
          },
          {
            h: [
              {
                id: "凛6-1",
                eng: "6th Day: Before dinner/Assault, stop the okonomiyaki bowl",
                jp: "六日目・夕食前/強襲、お好み焼き丼阻止",
              },
              {
                id: "凛6-2",
                eng: "6th Day: Matou household/People at the Matou household",
                jp: "六日目・〜間桐邸/間桐家の人々",
              },
              {id: "凛6-3", eng: "6th Day: Dojo/Report about today", jp: "六日目・〜道場/今日の報告"},
            ],
          },
          {
            h: [
              {
                id: "凛6-4",
                eng: "6th Day: After dinner, training/Tiger Dojo, extra edition",
                jp: "六日目・夕食後、剣の稽古/タイガー道場、番外編",
              },
              {
                id: "凛6-5",
                eng: "6th Day: After dinner, training/Peaceful moment",
                jp: "六日目・夕食後、剣の稽古/平和な一時",
              },
            ],
          },
          {id: "凛6-6", eng: "6th Day: Midnight/Calling", jp: "六日目・深夜/コーリング"},
          {id: "凛6-14", eng: "Intermission/Saber VS Assassin", jp: "幕間/セイバーＶＳアサシン"},
          {id: "凛6-11", eng: "6th Day: Ryuudou Temple/Archer VS Caster", jp: "六日目・柳洞寺境内/アーチャーＶＳキャスター"},
          {id: "凛6-12", eng: "6th Day: Ryuudou Temple/Fall down, your mind", jp: "六日目・柳洞寺境内/フォールダウン、ユアマインド"},
        ],
      }, {
        section: "凛7", v: [
          {
            id: "凛7-11",
            eng: "7th Day: Morning-Training swordsmanship/Saber unhappy",
            jp: "七日目・朝〜剣の稽古/セイバー、不機嫌",
          },
          {
            id: "凛7-0",
            eng: "7th Day: School, lunchtime/Creeping shadow of the demon",
            jp: "七日目・学校・昼休み/忍び寄るアクマの影",
          },
          {
            h: [
              {id: "凛7-1", eng: "7th Day: Lunchtime/Smart move", jp: "七日目・昼休み/賢明な判断"},
              {id: "凛7-2", eng: "7th Day: Lunchtime/Magical bullet shooter", jp: "七日目・昼休み/魔弾の射手"},
              {id: "凛7-3", eng: "7th Day: Lunchtime/Magical bullet shooter", jp: "七日目・昼休み/魔弾の射手"},
            ],
          },
          {id: "凛7-12", eng: "7th Day: Rooftop/Tohsaka Rin (IV)", jp: "七日目・屋上/遠坂凛（Ⅳ）"},
          {id: "凛7-4", eng: "7th Day: Boundary field activation/Choice", jp: "七日目・結界発動/選択肢"},
          {
            h: [
              {id: "凛7-5", eng: "7th Day: Bloodfort/Rin’s warning", jp: "七日目・鮮血神殿/凛の忠告"},
              {id: "凛7-6", eng: "7th Day: Bloodfort/Command Spell, second time", jp: "七日目・鮮血神殿/令呪、二回目"},
            ],
          },
          {id: "凛7-8", eng: "7th Day: Bloodfort/Rider’s death", jp: "七日目・鮮血神殿/ライダーの死"},
          {id: "凛7-9", eng: "7th Day: Woods/Quarrel", jp: "七日目・〜雑木林/諍い"},
          {id: "凛7-7", eng: "7th Day: Return home-Bedtime/Thinking in the night", jp: "七日目・帰宅〜就寝/夜に想う"},
        ],
      }, {
        section: "凛8", v: [
          {id: "凛8-9", eng: "Intermission/A story", jp: "幕間/ある話。"},
          {id: "凛8-8", eng: "8th Day: Morning-Way to school/Rin-sama angry", jp: "八日目・朝〜登校/凛さまご立腹"},
          {
            id: "凛8-0",
            eng: "8th Day: Lunchtime, student council room/Suspicion towards Issei is lifted, but…?",
            jp: "八日目・昼休み・生徒会室/一成への疑惑は晴れたが……？",
          },
          {
            h: [
              {
                id: "凛8-10",
                eng: "8th Day: Student council room/Chasing too far prohibited",
                jp: "八日目・生徒会室/深追い厳禁",
              },
              {id: "凛8-1", eng: "8th Day: Student council room/Hypnos", jp: "八日目・生徒会室/ヒュプノス"},
            ],
          },
          {
            h: [
              {id: "凛8-11", eng: "Intermission/Another blessing for this loser", jp: "幕間/この敗者に今一度の祝福を"},
              {id: "凛8-12", eng: "Tiger Dojo 18", jp: "タイガー道場18"},
            ],
          },
          {id: "凛8-2", eng: "8th Day: After school/Choice", jp: "八日目・放課後/選択肢。"},
          {
            h: [
              {
                id: "凛8-3",
                eng: "8th Day: After school-Matou household/The strange two",
                jp: "八日目・放課後〜間桐邸/あやしい二人",
              },
              {
                id: "凛8-4",
                eng: "8th Day: After school-Return home/Contact via phone",
                jp: "八日目・放課後〜帰宅/電話で連絡",
              },
              {
                id: "凛8-5",
                eng: "8th Day: After school-Shopping district/Strange maid",
                jp: "八日目・放課後〜商店街/おかしなメイド",
              },
            ],
          },
          {id: "凛8-6", eng: "8th Day: Dinner-Bedtime/Reason", jp: "八日目・夕食〜就寝/その理由"},
        ],
      }, {
        section: "凛9", v: [
          {id: "凛9-7", eng: "Intermission/A story of a knight", jp: "幕間/ある騎士の物語。"},
          {
            id: "凛9-8",
            eng: "9th Day: Morning-After school/Guests at the Ryuudou Temple",
            jp: "九日目・朝〜放課後/柳洞寺の客人",
          },
          {id: "凛9-0", eng: "9th Day: Night/Ambush, decisive action", jp: "九日目・夜/奇襲、決行"},
          {
            h: [
              {id: "凛9-1", eng: "9th Day: Night, ambush/Stop", jp: "九日目・夜・奇襲/止める"},
              {id: "凛9-2", eng: "9th Day: Night, ambush/Watch", jp: "九日目・夜・奇襲/見届ける"},
            ],
          },
          {id: "凛9-12", eng: "9th Day: Ambush/Master of the magus", jp: "九日目・奇襲/魔術師の主"},
          {id: "凛9-9", eng: "Intermission/Poisonous snake, jack of all trades", jp: "幕間/毒蛇百芸"},
          {id: "凛9-3", eng: "9th Day: Ambush/Defeat", jp: "九日目・奇襲/敗北"},
          {
            h: [
              {id: "凛9-5", eng: "9th Day: Ambush/Fight back, projection magic", jp: "九日目・奇襲/応戦、投影魔術"},
              {id: "凛9-4", eng: "9th Day: Ambush/Killer", jp: "九日目・奇襲/殺人鬼"},
            ],
          },
          {
            h: [
              {
                id: "凛9-13",
                eng: "9th Day: Night, intersection/Plan failed, Rin’s wonder",
                jp: "九日目・夜・交差点/作戦失敗、凛の疑惑",
              },
              {id: "凛9-14", eng: "Tiger Dojo 19", jp: "タイガー道場19"},
            ],
          },
          {id: "凛9-10", eng: "9th Day: Bedtime/Rebound", jp: "九日目・就寝/リバウンド"},
          {id: "凛9-11", eng: "Intermission/Result of Utnapishtim", jp: "幕間/ナピシュチムの末"},
        ],
      }, {
        section: "凛10", v: [
          {
            id: "凛10-6",
            eng: "10th Day: Awakening-School-Return home/Half the body paralyzed",
            jp: "十日目・起床〜学校〜帰宅/麻痺した半身",
          },
          {id: "凛10-7", eng: "10th Day: Afternoon/Rin strikes back!", jp: "十日目・午後/リン・ストライクバック！"},
          {id: "凛10-0", eng: "10th Day: Before dinner/Fuji-Nee VS Rin", jp: "十日目・夕食前/藤ねえＶＳ凛"},
          {
            h: [
              {id: "凛10-1", eng: "10th Day: Night/Conversation on projection magic", jp: "十日目・夜/投影魔術の話"},
              {id: "凛10-2", eng: "10th Day: Night, dojo/Wild Wild England", jp: "十日目・夜・道場/ワイルドワイルドイングランド"},
              {
                id: "凛10-3",
                eng: "10th Day: Night, living room/Which one do you like?",
                jp: "十日目・夜・居間/どっちが好きなの？",
              },
            ],
          },
          {
            id: "凛10-4",
            eng: "10th Day: Night, porch/Tohsaka Rin (V)-Shirou’s defect",
            jp: "十日目・夜・縁側/遠坂凛（Ⅴ）〜士郎の瑕",
          },
          {id: "凛10-8", eng: "10th Day: Bedtime-Shed/Night training-Warning", jp: "十日目・就寝〜土蔵/夜の鍛練〜警告"},
        ],
      }, {
        section: "凛11", v: [
          {id: "凛11-0", eng: "11th Day: Early morning/Bread disappearing incident", jp: "十一日目・早朝/食パン消失事件"},
          {
            h: [
              {
                id: "凛11-1",
                eng: "11th Day: Early morning, outbuilding/You’re the culprit",
                jp: "十一日目・早朝・離れ/犯人はオマエ",
              },
              {
                id: "凛11-2",
                eng: "11th Day: Early morning/Legend of the fastest one in Miyama City",
                jp: "十一日目・早朝〜/深山町最速伝説",
              },
            ],
          },
          {
            h: [
              {
                id: "凛11-9",
                eng: "11th Day: Shopping district/Life signal lighted",
                jp: "十一日目・〜商店街へ/ライフシグナル大回灯",
              },
              {id: "凛11-3", eng: "11th Day: Rin’s guest room/Good morning?", jp: "十一日目・凛の客間/グッドモーニング？"},
            ],
          },
          {id: "凛11-10", eng: "11th Day: Breakfast/Culprit arrest", jp: "十一日目・朝食/犯人逮捕"},
          {id: "凛11-11", eng: "11th Day: Morning/Let’s go on a date!", jp: "十一日目・朝/デートに行こう！"},
          {id: "凛11-4", eng: "11th Day: Shinto/Special?", jp: "十一日目・新都/スペシャル？"},
          {id: "凛11-8", eng: "11th Day: Afternoon, return home/Caster’s attack", jp: "十一日目・午後・帰宅/キャスター襲来"},
          {
            h: [
              {id: "凛11-6", eng: "Refusal/Distortion (III)-Rule Breaker", jp: "拒否/ディストレーション（Ⅲ）〜ルールブレイカー"},
              {id: "凛11-5", eng: "11th Day: Capsule/Hazy", jp: "十一日目・カプセル/朧"},
            ],
          },
          {
            h: [
              {
                id: "凛11-12",
                eng: "11th Day: Escape-To the Tohsaka household/Withdrawal",
                jp: "十一日目・逃走〜遠坂邸へ/戦線離脱",
              },
              {id: "凛11-17", eng: "Tiger Dojo 20", jp: "タイガー道場20"},
            ],
          },
          {id: "凛11-15", eng: "Intermission/Tohsaka Rin (VI)", jp: "幕間/遠坂凛（Ⅵ）"},
          {id: "凛11-16", eng: "11th Day: Night, building rooftop/Distance", jp: "十一日目・夜・ビル屋上/ディスタンス"},
          {id: "凛11-13", eng: "Intermission/Witch’s plan", jp: "幕間/魔女の思惑"},
          {id: "凛11-14", eng: "11th Day: Return home-My room/Reason to fight", jp: "十一日目・帰宅〜自室/戦う理由"},
        ],
      }, {
        section: "凛12", v: [
          {
            id: "凛12-14",
            eng: "Intermission/Holy woman violated|Intermission/Captured knight|gmature",
            jp: "幕間/囚われの騎士",
          },
          {
            h: [
              {id: "凛12-0", eng: "12th Day: To battle/Choice", jp: "十二日目・戦いへ/選択肢"},
              {id: "凛12-15", eng: "12th Day: To battle/Source of information", jp: "十二日目・戦いへ/情報源"},
            ],
          },
          {
            h: [
              {id: "凛12-1", eng: "12th Day: Shinto/Search and lure", jp: "十二日目・新都へ/囮探索"},
              {id: "凛12-3", eng: "12th Day: Church/Bad luck", jp: "十二日目・教会/バッドラック"},
            ],
          },
          {
            h: [
              {id: "凛12-12", eng: "Intermission/Unlimited───", jp: "幕間/無限の───"},
              {id: "凛12-2", eng: "12th Day: Church-Palm/Artificial Noble Phantasm", jp: "十二日目・教会〜掌/人工宝具"},
              {id: "凛12-10", eng: "12th Day: Church-Palm/Artificial Noble Phantasm", jp: "十二日目・教会〜掌/人工宝具"},
              {id: "凛12-11", eng: "12th Day: Church-Palm/Artificial Noble Phantasm", jp: "十二日目・教会〜掌/人工宝具"},
            ],
          },
          {
            h: [
              {
                id: "凛12-4",
                eng: "12th Day: Night-Church basement/Confrontation between Rin and Caster",
                jp: "十二日目・夜〜教会地下/対峙する凛とキャスター",
              },
              {id: "凛12-16", eng: "Tiger Dojo 21", jp: "タイガー道場21"},
            ],
          },
          {
            h: [
              {id: "凛12-6", eng: "12th Day: Confrontation/Estrangement", jp: "十二日目・対峙/離反"},
              {id: "凛12-5", eng: "12th Day: Church basement/Sword and magic", jp: "十二日目・教会地下/剣と魔術"},
            ],
          },
          {
            h: [
              {id: "凛12-7", eng: "12th Day: Confrontation/Resistance of the body", jp: "十二日目・対峙/肉体反抗"},
              {id: "凛12-17", eng: "Tiger Dojo 22", jp: "タイガー道場22"},
            ],
          },
          {
            id: "凛12-8",
            eng: "12th Day: Confrontation/Desperate projection-return alive",
            jp: "十二日目・対峙/決死の投影〜生還",
          },
          {
            id: "凛12-13",
            eng: "12th Day: Foreigners’ cemetery/Tohsaka Rin (VII)",
            jp: "十二日目・夜の外人墓地/遠坂凛（Ⅶ）",
          },
        ],
      }, {
        section: "凛13", v: [
          {id: "凛13-11", eng: "12th Day: Return home-Dinner/Warm dinnertime", jp: "十二日目・帰宅〜夕食/温かな夕食"},
          {id: "凛13-0", eng: "12th Day: Strategy meeting/Is there a way?", jp: "十二日目・作戦会議/打開策、ある？"},
          {
            h: [
              {id: "凛13-1", eng: "Rin’s smile/The scary type", jp: "凛の笑顔/怖いタイプ"},
              {id: "凛13-2", eng: "Rin’s distress/The serious type", jp: "凛の憂い/真面目なタイプ"},
              {id: "凛13-3", eng: "Rin’s smile/The good type", jp: "凛の笑顔/なんかいいタイプ"},
            ],
          },
          {id: "凛13-12", eng: "12th Day: Nap/Plan determined, sleep", jp: "十二日目・〜仮眠/方針決定、睡眠"},
          {id: "凛13-13", eng: "Intermission/Princess Medea", jp: "幕間/王女メディア"},
          {
            id: "凛13-14",
            eng: "13th Day: Awakening-To the forest/Winter forest, the great devil gets really angry",
            jp: "十三日目・目覚め〜森へ/冬の森、大魔神かなり怒る",
          },
          {id: "凛13-21", eng: "13th Day/Entering Einzbern Castle", jp: "十三日目/アインツベルン城侵入"},
          {
            id: "凛13-4",
            eng: "13th Day: Einzbern Castle/Gilgamesh VS Berserker",
            jp: "十三日目・アインツベルン城/ギルガメッシュＶＳバーサーカー",
          },
          {
            h: [
              {id: "凛13-15", eng: "Decision/Distortion (IV)", jp: "決断/ディストレーション（Ⅳ）"},
              {id: "凛13-6", eng: "Decision/Illya’s death", jp: "決断/イリヤの死。"},
            ],
          },
          {id: "凛13-16", eng: "Intermission/Winter forest", jp: "幕間/冬の森"},
          {id: "凛13-17", eng: "Einzbern Castle/Puppet master", jp: "アインツベルン城/傀儡の主"},
          {id: "凛13-18", eng: "Einzbern Castle/Your distortion", jp: "アインツベルン城/君の歪み"},
          {id: "凛13-5", eng: "Einzbern Castle: Setting sun/Lancer’s proposal", jp: "アインツベルン城・落陽/ランサーの提案"},
          {
            h: [
              {id: "凛13-9", eng: "Joint force proposal/Refuse", jp: "共闘提案/断る"},
              {id: "凛13-7", eng: "Joint force proposal/Consent", jp: "共闘提案/快諾"},
              {id: "凛13-8", eng: "Joint force proposal/Rin-sama embarrassed and angry", jp: "共闘提案/凛さま照れ怒る"},
            ],
          },
          {
            h: [
              {id: "凛13-19", eng: "13th Day: Night-To the church/One conclusion", jp: "十三日目・夜〜教会へ/或る結末。"},
              {id: "凛13-20", eng: "13th Day: Night-To the church/Past the night", jp: "十三日目・夜〜教会へ/夜を越えて"},
            ],
          },
          {id: "凛13-22", eng: "Tiger Dojo 23", jp: "タイガー道場23"},
        ],
      }, {
        section: "凛14", v: [
          {id: "凛14-17", eng: "14th Day: Dawn-Church/Battle start", jp: "十四日目・夜明け〜教会/戦闘開始"},
          {id: "凛14-18", eng: "14th Day: Church underground temple/Showdown", jp: "十四日目・教会地下聖堂/対決"},
          {id: "凛14-19", eng: "Intermission/Lance of sure hit, shield of no loss", jp: "幕間/必中の槍、無敗の盾"},
          {id: "凛14-20", eng: "Showdown/Rin’s clever attack", jp: "対決/凛の奇策"},
          {id: "凛14-0", eng: "Battle, end of battle/Choice", jp: "対決、決着/選択肢"},
          {
            h: [
              {id: "凛14-1", eng: "Choice/Ideal", jp: "選択/理想。"},
              {id: "凛14-2", eng: "Choice/Idea", jp: "選択/理念。"},
            ],
          },
          {
            id: "凛14-3",
            eng: "14th Day: Church underground temple/Reality Marble",
            jp: "十四日目・教会地下聖堂/リアリティ・マーブル",
          },
          {id: "凛14-21", eng: "14th Day: Outside church/Return with Saber", jp: "十四日目・〜教会外へ/帰還"},
          {id: "凛14-22", eng: "Intermission/Captured princess", jp: "幕間/囚われの姫"},
          {id: "凛14-23", eng: "14th Day: Midnight/To the place of conviction", jp: "十四日目・深夜〜/断罪の場へ"},
          {id: "凛14-24", eng: "Intermission/Original and Fake", jp: "幕間/オリジナル＆フェイク"},
          {id: "凛14-25", eng: "15th Day: Dawn-Einzbern Castle/“VS”", jp: "十五日目・夜明け〜アインツベルン城/『VS』"},
          {id: "凛14-26", eng: "Intermission/End of a hero", jp: "幕間/英雄の結末"},
          {id: "凛14-27", eng: "End of battle/Answer", jp: "決着/アンサー"},
          {id: "凛14-28", eng: "Einzbern Castle/Enemy that must be defeated", jp: "アインツベルン城/倒すべき敵"},
          {id: "凛14-29", eng: "Intermission/Contradictory Holy Grail", jp: "幕間/矛盾聖杯"},
          {
            id: "凛14-4",
            eng: "15th Day: Return home, night/Before the final battle",
            jp: "十五日目・〜帰還・夜/最終決戦前",
          },
          {
            h: [
              {id: "凛14-5", eng: "Last action/Go ask Rin", jp: "最後の行動/凛に相談"},
              {id: "凛14-6", eng: "Last action/Tea with Saber", jp: "最後の行動/セイバーとお茶を"},
              {id: "凛14-7", eng: "Last action/Think one more time", jp: "最後の行動/もう一度考える"},
            ],
          },
          {
            h: [
              {id: "凛14-108", eng: "15th Day: Night/Rin’s proposal (lethal dose)", jp: "十五日目・夜/凛の提案（致死量）"},
              {id: "凛14-8", eng: "15th Day: Night/Memories in the ocean", jp: "十五日目・夜/海の記憶"},
            ],
          },
          {id: "凛14-130", eng: "The two’s choice/Mind and body", jp: ""},
          {id: "凛14-31", eng: "16th Day: Before dawn/To the Ryuudou Temple", jp: "十六日目・夜明け前/柳洞寺へ"},
          {id: "凛14-32", eng: "Intermission/Unnamed great style", jp: "幕間/巌流、無名"},
          {id: "凛14-33", eng: "Confrontation/Gift “Embryo”", jp: "対峙/ギフト“エンブリオ”"},
          {id: "凛14-34", eng: "Battle/Circuit Overload", jp: "決戦/サーキット・オーバーロード"},
          {id: "凛14-35", eng: "Battle/The beauties of nature", jp: "決戦/花鳥風月"},
          {id: "凛14-36", eng: "Match decided/Unlimited Blade Works", jp: "決着/アンリミテッドブレイドワークス"},
          {id: "凛14-9", eng: "Intermission/Holy Grail breakdown", jp: "幕間/聖杯崩壊"},
          {
            h: [
              {id: "凛14-10", eng: "Intermission/New wish", jp: "幕間/新たな望み"},
              {id: "凛14-11", eng: "Intermission/End of the dream", jp: "幕間/夢の終わり"},
            ],
          },
          {id: "凛14-12", eng: "End of battle/Last fight", jp: "決着/ラスト・フライト"},
          {
            h: [
              {id: "凛14-14", eng: "Daybreak/Stay away", jp: "夜明け/ステイ・アウェイ"},
              {id: "凛14-13", eng: "16th Day: Round crown corridor/Heavens fall", jp: "十六日目・円冠回廊/ヘブンズフォール"},
            ],
          },
          {
            h: [
              {id: "凛14-15", eng: "To epilogue 1", jp: "エピローグ１へ。"},
              {id: "凛14-16", eng: "To epilogue 2", jp: "エピローグ２へ。"},
              {id: "凛14-37", eng: "Tiger Dojo 24", jp: "タイガー道場24"},
            ],
          },
        ],
      },
      ],
    }, {
      v: [{
        section: "桜4", v: [
          {id: "桜4-11", eng: "4th Day: Morning/Rin’s proposal", jp: "四日目朝/凛からの提案"},
          {id: "桜4-0", eng: "4th Day: Morning/Rin leaves", jp: "四日目・朝/凛、去る"},
          {id: "桜4-10", eng: "4th Day: Morning: Dojo/Saber explains the rules", jp: "四日目・午前・道場/セイバーによるルール説明"},
          {
            id: "桜4-1",
            eng: "4th Day: Dojo-Church/Holy Grail War, the beginning",
            jp: "四日目・道場〜教会/聖杯戦争、その発端",
          },
          {
            id: "桜4-7",
            eng: "4th Day: Outside church/Will to fight, fighting sword",
            jp: "四日目・教会外/戦う意思、戦う剣",
          },
          {id: "桜4-8", eng: "4th Day: Afternoon-Dinner/Intruder", jp: "四日目・夕方〜夕食/イントルーダー"},
          {id: "桜4-2", eng: "4th Day: Night: Patrol/Choice", jp: "四日目・夜・巡回/選択肢"},
          {
            h: [
              {id: "桜4-3", eng: "Action/To Miyama City", jp: "行動/深山町へ"},
              {id: "桜4-4", eng: "Action/To Shinto", jp: "行動/新都へ"},
            ],
          },
          {id: "桜4-5", eng: "4th Day: Midnight: Park/Makiri’s end-VS Rider", jp: "四日目・深夜・公園/マキリの末〜ＶＳライダー"},
          {
            id: "桜4-9",
            eng: "4th Day: Midnight: Church/The answer lies at the very end",
            jp: "四日目・深夜・教会/その答えは結末にのみ",
          },
        ],
      }, {
        section: "桜5", v: [
          {id: "桜5-19", eng: "5th Day: Morning, awakening/A usual morning?", jp: "五日目・朝、起床/いつもの朝？"},
          {id: "桜5-20", eng: "5th Day: Breakfast/Shinji’s viciousness", jp: "五日目・朝食/慎二の蛮行"},
          {id: "桜5-0", eng: "5th Day: Way to school-School/Ready?", jp: "五日目・登校〜学校/レディ？"},
          {
            h: [
              {id: "桜5-1", eng: "Go!/About Sakura", jp: "ゴー！/桜について"},
              {id: "桜5-2", eng: "Go!/About Shinji", jp: "ゴー/慎二について"},
              {id: "桜5-3", eng: "No!/Fancy curse. The great devil gets very angry.", jp: "ノー！/ファンシーカース。大魔神とても怒る。"},
            ],
          },
          {
            id: "桜5-4",
            eng: "5th Day: Lunchtime: Rooftop/Consultation with Rin-Peace treaty?",
            jp: "五日目・昼休み・屋上/凛と相談〜休戦条約？",
          },
          {
            id: "桜5-5",
            eng: "5th Day: After school: Shopping district/The daughter of winter-Illya (I) ",
            jp: "五日目・放課後・商店街/冬の娘〜イリヤ（Ⅰ）",
          },
          {
            h: [
              {id: "桜5-6", eng: "Reply/Reaction, not quite good", jp: "返答/いまいちな反応"},
              {id: "桜5-7", eng: "Reply/Good", jp: "返答/良かったね。"},
            ],
          },
          {id: "桜5-8", eng: "5th Day: Noon: Park/Innocent murder", jp: "五日目・夕方前・公園/イノセント・マーダー"},
          {
            id: "桜5-9",
            eng: "5th Day: Return home: Before dinner/Who will tell Sakura?",
            jp: "五日目・帰宅・夕食前/桜に誰がきりだす？",
          },
          {
            h: [
              {id: "桜5-10", eng: "Request/Fuji-Nee", jp: "依頼/藤ねえ"},
              {id: "桜5-11", eng: "Carry into effect/Myself", jp: "実行/自分"},
            ],
          },
          {id: "桜5-13", eng: "5th Day: After dinner/Go check on Sakura?", jp: "五日目・夕食後/桜の様子を見に行く？"},
          {
            h: [
              {id: "桜5-14", eng: "5th Day: Bathroom/Cold medicine, A capsule", jp: "五日目・脱衣場/コールドメディスン、Ａカプセル"},
              {id: "桜5-15", eng: "5th Day: Living room/Cold medicine, C capsule", jp: "五日目・居間/コールドメディスン、Ｃカプセル"},
            ],
          },
          {id: "桜5-16", eng: "5th Day: Midnight-Patrol/To the Ryuudou Temple", jp: "五日目・深夜〜巡回/柳洞寺へ"},
          {id: "桜5-12", eng: "Intermission/Malak al Maut", jp: "幕間/マラク・アル・マウト"},
          {id: "桜5-21", eng: "5th Day: Midnight: Ryuudou Temple/VS Caster", jp: "五日目・深夜・柳洞寺境内/ＶＳキャスター"},
          {id: "桜5-22", eng: "Intermission/Disaster", jp: "幕間/ディザスター"},
          {
            h: [
              {id: "桜5-17", eng: "5th Day: Bedtime/Shapeless island", jp: "五日目・就寝/形のない島"},
              {id: "桜5-117", eng: "5th Day: Bedtime/Shapeless island", jp: "五日目・就寝/形のない島"},
            ],
          },
        ],
      }, {
        section: "桜6", v: [
          {id: "桜6-0", eng: "6th Day: Awakening-Morning/Nurse Sakura", jp: "六日目・起床〜朝/桜の看病"},
          {id: "桜6-1", eng: "6th Day: Nurse Sakura/A simple question", jp: "六日目・桜の看病/素朴な疑問"},
          {
            h: [
              {id: "桜6-3", eng: "Answer/Cold smile", jp: "回答/冷たい笑顔"},
              {id: "桜6-4", eng: "Answer/Sakura disappointed", jp: "回答/残念がる桜"},
            ],
          },
          {id: "桜6-5", eng: "6th Day: After lunch/Choice", jp: "六日目・昼食後/選択肢"},
          {
            h: [
              {id: "桜6-9", eng: "6th Day: Park/Winter castle-Illya (II)", jp: "六日目・公園/冬の城〜イリヤ（Ⅱ）"},
              {id: "桜6-10", eng: "6th Day: Park/The daughter of winter-Illya (I)", jp: "六日目・公園/冬の娘〜イリヤ（Ⅰ）"},
              {
                id: "桜6-7",
                eng: "6th Day: After lunch: Living room/Saber is merciless!",
                jp: "六日目・昼食後・居間/このセイバー容赦せん！",
              },
              {
                id: "桜6-8",
                eng: "6th Day: After lunch: Living room/A peaceful time",
                jp: "六日目・昼食後・居間/のどかな食後",
              },
            ],
          },
          {id: "桜6-2", eng: "6th Day: Return home-Entrance/A big pinch", jp: "六日目・帰宅〜玄関/だいぴんち"},
          {id: "桜6-19", eng: "6th Day: Afternoon/Matou Shinji", jp: "六日目・夕方/間桐慎二"},
          {
            h: [
              {id: "桜6-20", eng: "Action/Enraged", jp: "行動/激昂"},
              {id: "桜6-21", eng: "Action/Prudence", jp: "行動/自重"},
            ],
          },
          {id: "桜6-22", eng: "6th Day: -Night/Sakura sick-Tonight’s plan", jp: "六日目・〜夜/倒れた桜〜夜の予定"},
          {
            h: [
              {id: "桜6-16", eng: "6th Day: Night: Patrol/Shinto", jp: "六日目・夜・巡回/新都"},
              {id: "桜6-17", eng: "6th Day: Night: Patrol/Miyama City", jp: "六日目・夜・巡回/深山町"},
              {id: "桜6-23", eng: "6th Day: Night-Bedtime/Matou Sakura (III)", jp: "六日目・夜〜就寝/間桐桜（Ⅲ）"},
            ],
          },
          {id: "桜6-18", eng: "6th Day: Bedtime/Day’s end", jp: "六日目・就寝/一日の終わり"},
          {id: "桜6-11", eng: "Intermission/Hero’s death", jp: "幕間/勇者の死"},
        ],
      }, {
        section: "桜7", v: [
          {
            id: "桜7-15",
            eng: "7th Day: Awakening-Breakfast/Wandering cloud, sumo edition",
            jp: "七日目・起床〜朝食/はぐれ雲相撲編",
          },
          {id: "桜7-16", eng: "7th Day: After breakfast/Sakura and lunch", jp: "七日目・朝食後/桜とお弁当"},
          {id: "桜7-1", eng: "7th Day: Way to school-Lunchtime/Interval", jp: "七日目・登校〜昼休み/インターバル"},
          {id: "桜7-17", eng: "7th Day: Lunchtime: Rooftop/Tohsaka Rin (II)", jp: "七日目・昼休み・屋上/遠坂凛（Ⅱ）"},
          {id: "桜7-0", eng: "7th Day: Before 5th period: Stairway/The two", jp: "七日目・五時限目前・階段/ふたり"},
          {
            id: "桜7-2",
            eng: "7th Day: After school-Chinese Restaurant/Shocking Mapo tofu",
            jp: "七日目・放課後〜中華飯店/衝撃のマーボー",
          },
          {id: "桜7-18", eng: "Intermission/Re-contract", jp: "幕間/再契約"},
          {
            h: [
              {id: "桜7-6", eng: "7th Day: Way home: Intersection/Encounter", jp: "七日目・帰り道・交差点/遭遇"},
              {id: "桜7-4", eng: "7th Day: Afternoon/Way home", jp: "七日目・午後/帰り道"},
            ],
          },
          {
            h: [
              {id: "桜7-7", eng: "Choice/Homesick-Illya (III)", jp: "選択/ホームシック〜イリヤ（Ⅲ）"},
              {id: "桜7-8", eng: "Choice/Cinema-Illya (III)", jp: "選択/シネマ〜イリヤ（Ⅲ）"},
              {id: "桜7-9", eng: "Choice/Mistake", jp: "選択/ミステイク"},
            ],
          },
          {
            h: [
              {id: "桜7-10", eng: "7th Day: Return home: Living room/Temptation", jp: "七日目・帰宅・居間/テンプテーション"},
              {
                id: "桜7-19",
                eng: "7th Day: Return home: Living room/Temptation (Afternoon)",
                jp: "七日目・帰宅・居間/テンプテーション（夕方）",
              },
            ],
          },
          {id: "桜7-20", eng: "7th Day: Training-Living room/Treat Sakura", jp: "七日目・剣の稽古〜居間/桜の手当て"},
          {id: "桜7-11", eng: "7th Day: Midnight: Park/War balance randomizer", jp: "七日目・深夜・公園/ウォーバランス・ランダマイザー"},
          {
            h: [
              {id: "桜7-12", eng: "7th Day/Ocean depths", jp: "七日目/深海"},
              {
                id: "桜7-13",
                eng: "7th Day: Return alive-Return home/Gap between the two",
                jp: "七日目・生還〜帰宅/二人の溝",
              },
            ],
          },
          {
            h: [
              {id: "桜7-5", eng: "Tiger Dojo 25", jp: "タイガー道場25"},
              {id: "桜7-21", eng: "Intermission/Madness", jp: "幕間/跳梁"},
            ],
          },
        ],
      }, {
        section: "桜8", v: [
          {id: "桜8-11", eng: "8th Day: Awakening-Morning/Sakura complains", jp: "八日目・起床〜朝/桜の告戒"},
          {id: "桜8-12", eng: "8th Day: Morning/Challenging the shadow", jp: "八日目・朝/影に挑む"},
          {id: "桜8-13", eng: "8th Day: School/Foreseeing the future", jp: "八日目・学校/未来予知"},
          {id: "桜8-14", eng: "8th Day: Rooftop/Rin’s advice", jp: "八日目・屋上/凛のアドバイス"},
          {
            h: [
              {id: "桜8-0", eng: "8th Day: After school/Sunset town", jp: "八日目・下校/夕焼けの町"},
              {
                id: "桜8-1",
                eng: "8th Day: Return home-Emiya household/Battle of the Holy Grail",
                jp: "八日目・帰宅〜衛宮邸/聖杯の戦い",
              },
            ],
          },
          {
            h: [
              {id: "桜8-15", eng: "Intermission/Truth", jp: "幕間/真実"},
              {id: "桜8-23", eng: "Tiger Dojo 26", jp: "タイガー道場26"},
            ],
          },
          {id: "桜8-16", eng: "8th Day: Dinner/Peaceful day", jp: "八日目・夕食/穏やかな日"},
          {id: "桜8-2", eng: "8th Day: Patrol at night/Choice", jp: "八日目・夜の巡回/選択肢"},
          {
            h: [
              {id: "桜8-3", eng: "Decision/Ryuudou Temple", jp: "決定/柳洞寺"},
              {id: "桜8-4", eng: "Decision/Scolded", jp: "決定/お叱り"},
            ],
          },
          {id: "桜8-17", eng: "8th Day: Midnight: Ryuudou Temple/Assassin’s attack", jp: "八日目・深夜・柳洞寺/アサシン襲来"},
          {id: "桜8-18", eng: "Intermission/Last swordsman", jp: "幕間/最後の剣士"},
          {
            id: "桜8-5",
            eng: "8th Day: Midnight: Ryuudou Temple/The battle at Ryuudou Temple",
            jp: "八日目・深夜・柳洞寺お堂/柳洞寺の戦い。",
          },
          {
            h: [
              {id: "桜8-6", eng: "Decision/Tragic trust", jp: "決定/悲痛な信頼"},
              {id: "桜8-8", eng: "Decision/Use the Command Spell", jp: "決定/令呪、使用"},
              {id: "桜8-7", eng: "Decision/Die together", jp: "決定/共に死す"},
            ],
          },
          {
            h: [
              {id: "桜8-9", eng: "The battle at Ryuudou Temple/True Assassin VS Rider", jp: "柳洞寺の戦い/真アサシンＶＳライダー"},
              {id: "桜8-24", eng: "Tiger Dojo 27", jp: "タイガー道場27"},
            ],
          },
          {id: "桜8-19", eng: "8th Day: Midnight: Ryuudou Temple/Parting and oath", jp: "八日目・深夜・柳洞寺/別れと誓い"},
          {id: "桜8-20", eng: "8th Day: Return home-Bedtime/What is lost", jp: "八日目・帰宅〜就寝/なくしたもの"},
          {id: "桜8-21", eng: "Intermission/Pupa", jp: "幕間/サナギ"},
          {id: "桜8-22", eng: "Intermission/Report", jp: "幕間/レポート"},
        ],
      }, {
        section: "桜9", v: [
          {id: "桜9-26", eng: "9th Day: Awakening-Morning/Sakura collapses", jp: "九日目・起床〜朝/桜倒れる"},
          {id: "桜9-0", eng: "9th Day: School-Rooftop/Report Rin", jp: "九日目・学校〜屋上/凛への報告"},
          {
            h: [
              {id: "桜9-1", eng: "Answer/Unsatisfactory", jp: "回答/不満"},
              {id: "桜9-2", eng: "Answer/Correct", jp: "回答/正解"},
              {id: "桜9-3", eng: "Answer/Correct", jp: "回答/正解"},
            ],
          },
          {id: "桜9-4", eng: "Rin’s question/What to do now", jp: "凛の質問/これからの行動"},
          {
            h: [
              {id: "桜9-6", eng: "Rin’s question/Choice", jp: "凛の問答/選択肢"},
              {
                id: "桜9-5",
                eng: "9th Day: Afternoon-Confrontation/Miserable lone force",
                jp: "九日目・午後〜対決/孤軍無残",
              },
            ],
          },
          {
            h: [
              {id: "桜9-8", eng: "Reply/Who do you think you are?", jp: "返事/何様よアンタ"},
              {id: "桜9-38", eng: "Tiger Dojo 28", jp: "タイガー道場28"},
            ],
          },
          {
            id: "桜9-9",
            eng: "Rin’s question/Can you trust her? Can you stay on her side?",
            jp: "凛の問答/信頼できる？裏切らない？",
          },
          {id: "桜9-11", eng: "Reply/Who do you think you are?", jp: "返事/何様よアンタ"},
          {id: "桜9-12", eng: "Rin’s question/Will you give me your absolute obedience?", jp: "凛の問答/絶対服従する？"},
          {
            h: [
              {id: "桜9-13", eng: "Reply/Let me win", jp: "返事/わたしを勝たせてね"},
              {id: "桜9-14", eng: "Reply/Geas", jp: "返事/ギアス"},
            ],
          },
          {id: "桜9-27", eng: "9th Day: After school-Tohsaka household/Photo", jp: "九日目・下校〜遠坂邸/写真"},
          {
            h: [
              {id: "桜9-15", eng: "9th Day: Rin’s room-Afternoon/Choice", jp: "九日目・凛の部屋〜夕方/選択肢。"},
              {
                id: "桜9-32",
                eng: "9th Day: Rin’s room-Afternoon-Return home/Rin gets angry",
                jp: "九日目・凛の部屋〜夕方〜帰宅/凛、怒る",
              },
            ],
          },
          {
            h: [
              {id: "桜9-16", eng: "Decision/Rin gets angry", jp: "決断/凛、怒る"},
              {id: "桜9-17", eng: "Decision/Rin still gets angry", jp: "決断/凛、やっぱり怒る"},
            ],
          },
          {id: "桜9-18", eng: "9th Day: Return home-To school/Over", jp: "九日目・帰宅〜学校へ/オーバー"},
          {
            id: "桜9-33",
            eng: "9th Day: School/Older brother and younger sister-VS Rider",
            jp: "九日目・学校/兄と妹〜ＶＳライダー",
          },
          {id: "桜9-19", eng: "VS Rider/Truth about Sakura", jp: "ＶＳライダー/桜の真実"},
          {
            h: [
              {id: "桜9-20", eng: "Mystic eyes released/Save Rin", jp: "魔眼解放/凛を助ける。"},
              {id: "桜9-22", eng: "Mystic eyes released/Direct hit", jp: "魔眼解放/直撃"},
              {id: "桜9-21", eng: "9th Day: VS Rider/Stone coffin", jp: "九日目・ＶＳライダー/ストーン・コフィン"},
            ],
          },
          {
            h: [
              {id: "桜9-35", eng: "9th Day: -Church/Sisters (I)", jp: "九日目・〜教会/姉妹（Ⅰ）"},
              {id: "桜9-39", eng: "Tiger Dojo 29", jp: "タイガー道場29"},
            ],
          },
          {
            id: "桜9-23",
            eng: "9th Day: Outside church-Park, night/What I should protect",
            jp: "九日目・教会外〜公園・夜/まもるべきもの",
          },
          {
            h: [
              {id: "桜9-36", eng: "9th Day: Park-To the church/Run into the rain", jp: "九日目・公園〜教会へ/雨に走る"},
              {id: "桜9-25", eng: "9th Day/Superhero", jp: "九日目/正義の味方"},
            ],
          },
          {
            h: [
              {id: "桜9-37", eng: "Intermission/Bailing hand", jp: "幕間/掬いの手"},
              {id: "桜9-40", eng: "Tiger Dojo 30", jp: "タイガー道場30"},
            ],
          },
          {
            id: "桜9-24",
            eng: "9th Day: Church: Confrontation with Rin/Set position",
            jp: "九日目・教会・凛と対峙/セット・ポジション",
          },
          {
            h: [
              {id: "桜9-28", eng: "9th Day/Rain", jp: "九日目/レイン"},
              {id: "桜9-34", eng: "9th Day: Night: Church/Geas", jp: "九日目・夜・教会/ギアス"},
            ],
          },
          {
            h: [
              {id: "桜9-29", eng: "9th Day: Return home-Entrance/Sisters (II)", jp: "九日目・帰宅〜玄関/姉妹（Ⅱ）"},
              {id: "桜9-41", eng: "Tiger Dojo 31", jp: "タイガー道場31"},
            ],
          },
          {
            h: [
              {id: "桜9-30", eng: "九日目・深夜・自室/体の重なり", jp: "九日目・深夜・自室/スティール"},
              {
                id: "桜9-130",
                eng: "9th Day: Midnight: My room/Connection of Bodies",
                jp: "9th Day: Midnight: My room/Connection of Bodies",
              },
            ],
          },
        ],
      }, {
        section: "桜10", v: [
          {id: "桜10-6", eng: "10th Day: Awakening-Morning/Naive morning", jp: "十日目・起床〜朝/初々しい朝"},
          {
            id: "桜10-0",
            eng: "10th Day: Breakfast/About Rider, who is at the table",
            jp: "十日目・朝食/食卓にいるライダーについて",
          },
          {
            h: [
              {id: "桜10-1", eng: "Impression/Red card from Sakura and Rider", jp: "感想/桜、ライダーにレッドカード"},
              {id: "桜10-2", eng: "Impression/Rider mad", jp: "感想/ライダー、むす"},
              {id: "桜10-3", eng: "Rider, breakfast?/No", jp: "ライダー、ごはんは/たべません"},
            ],
          },
          {id: "桜10-4", eng: "10th Day: After breakfast/Future plans", jp: "十日目・朝食後/今後の方針"},
          {
            id: "桜10-7",
            eng: "10th Day: Emiya household-Go out/To the Einzbern forest",
            jp: "十日目・衛宮邸〜外出/アインツベルンの森へ",
          },
          {id: "桜10-5", eng: "Intermission/Secret", jp: "幕間/隠し事"},
          {id: "桜10-8", eng: "10th Day: Einzbern forest/Meet up with Rin", jp: "十日目・アインツベルンの森/凛との合流"},
          {
            h: [
              {id: "桜10-9", eng: "Einzbern forest/To the center of explosion", jp: "アインツベルンの森/爆心地へ"},
              {
                id: "桜10-10",
                eng: "10th Day: Einzbern forest…?/Layered curse of the Womb Realm Mandala",
                jp: "十日目・アインツベルンの森……？/呪層界胎蔵曼荼羅",
              },
            ],
          },
          {
            h: [
              {id: "桜10-12", eng: "Intermission/Shadow swallowing the castle", jp: "幕間/城食影"},
              {id: "桜10-34", eng: "Tiger Dojo 32", jp: "タイガー道場32"},
            ],
          },
          {id: "桜10-11", eng: "Einzbern forest/Power game", jp: "アインツベルンの森/パワー・ゲーム"},
          {id: "桜10-19", eng: "Einzbern forest/Rescue Illya-Black swordsman", jp: "アインツベルンの森/イリヤ救出〜黒い剣士"},
          {id: "桜10-13", eng: "Einzbern forest/Distraction", jp: "アインツベルンの森/ディストラクション"},
          {
            h: [
              {id: "桜10-14", eng: "Einzbern forest/Blood out", jp: "アインツベルンの森/ブラッド・アウト"},
              {id: "桜10-15", eng: "Einzbern forest/World purge, meltdown", jp: "アインツベルンの森/ワールドパージ・メルトダウン"},
            ],
          },
          {
            h: [
              {id: "桜10-28", eng: "Intermission/Deep desire", jp: "幕間/昏い望み"},
              {id: "桜10-35", eng: "Tiger Dojo 33", jp: "タイガー道場33"},
            ],
          },
          {id: "桜10-29", eng: "10th Day: Church/Artificial Phantasm", jp: "十日目・教会/アーティフィシャル・ファンタズム"},
          {id: "桜10-16", eng: "10th Day: Out of church/Which one?", jp: "十日目・教会外へ/どっちがいいの？"},
          {
            h: [
              {id: "桜10-17", eng: "Answer/Rin blushes", jp: "感想/凛赤面"},
              {id: "桜10-18", eng: "Answer/Illya delighted", jp: "感想/喜ぶイリヤ"},
            ],
          },
          {id: "桜10-30", eng: "10th Day: Intersection-Return home/Blade virus ", jp: "十日目・交差点〜帰宅/ブレイドウイルス"},
          {id: "桜10-31", eng: "Intermission/Sacrilege", jp: "幕間/サクラリッジ"},
          {id: "桜10-20", eng: "10th Day: Return home-Entrance/Sweet & spicy", jp: "十日目・帰宅〜玄関/スイート＆スパイシー"},
          {
            h: [
              {id: "桜10-21", eng: "Conversation/Second visit", jp: "会話中/二度目の来訪"},
              {id: "桜10-22", eng: "Conversation/First visit", jp: "会話中/初めての来訪"},
            ],
          },
          {id: "桜10-32", eng: "10th Day: Dinner/Sisters (III)", jp: "十日目・夕食/姉妹（Ⅲ）"},
          {id: "桜10-23", eng: "10th Day: Bedtime/Choice", jp: "十日目・就寝/選択肢。"},
          {
            h: [
              {id: "桜10-24", eng: "Choice/Release it", jp: "選択/解く"},
              {id: "桜10-25", eng: "Choice/Do not release it.", jp: "選択/解かない"},
            ],
          },
          {id: "桜10-26", eng: "10th Day: Bedtime/Rider’s inquiry", jp: "十日目・就寝/ライダーの問い"},
          {id: "桜10-33", eng: "Intermission/Nightmare (I)", jp: "幕間/悪夢（Ⅰ）"},
        ],
      }, {
        section: "桜11", v: [
          {id: "桜11-6", eng: "11th Day: Awakening: My room/Illya’s warning", jp: "十一日目・起床・自室/イリヤの忠告"},
          {id: "桜11-7", eng: "11th Day: Breakfast/Bad news", jp: "十一日目・朝食/バッドニュース"},
          {id: "桜11-8", eng: "11th Day: After breakfast/Future plans", jp: "十一日目・朝食後/今後の方針"},
          {
            id: "桜11-9",
            eng: "11th Day: Morning: Dojo/Lecture on magic (Drastic measure)",
            jp: "十一日目・午前・道場/魔術講座（荒療治）",
          },
          {id: "桜11-10", eng: "11th Day: Lunch preparation/Sisters (IV)", jp: "十一日目・昼食の準備/姉妹（Ⅳ）"},
          {id: "桜11-0", eng: "11th Day: Afternoon/Choice", jp: "十一日目・午後/選択肢"},
          {
            h: [
              {id: "桜11-1", eng: "Action/Rin and Illya", jp: "行動/凛とイリヤ"},
              {id: "桜11-2", eng: "Action/Cute girl", jp: "行動/かわいい女の子"},
              {id: "桜11-3", eng: "Action/Earnest", jp: "行動/一途"},
            ],
          },
          {id: "桜11-4", eng: "11th Day: Checking on Sakura/Distant twilight (I)", jp: "十一日目・桜の看病/遠い夕暮れ（Ⅰ）"},
          {id: "桜11-11", eng: "Intermission/Distortion", jp: "幕間/歪み"},
          {id: "桜11-12", eng: "11th Day: Dinner/Signs of disaster", jp: "十一日目・夕食/異変、前兆"},
          {id: "桜11-13", eng: "11th Day: Night: Patrol/Tohsaka Rin (III)", jp: "十一日目・夜・巡回/遠坂凛（Ⅲ）"},
          {
            id: "桜11-14",
            eng: "11th Day: Return home: My room/Release of the seal-Overture of breakdown",
            jp: "十一日目・帰宅・自室/封印解除〜崩壊序曲",
          },
          {
            h: [
              {id: "桜11-15", eng: "11th Day: Night: My room/Crack", jp: "十一日目・夜・自室/クラック"},
              {id: "桜11-115", eng: "11th Day: Night: My room/Connection of Minds", jp: "十一日目・夜・自室/心の重なり"},
            ],
          },
          {id: "桜11-16", eng: "Intermission/Nightmare (II)", jp: "幕間/悪夢（Ⅱ）"},
        ],
      }, {
        section: "桜12", v: [
          {id: "桜12-5", eng: "12th Day: Awakening-Morning/Blank memory", jp: "十二日目・起床〜朝/空白"},
          {id: "桜12-6", eng: "12th Day: Breakfast/Illya’s breakfast", jp: "十二日目・朝食/イリヤの朝ごはん"},
          {id: "桜12-0", eng: "12th Day: Morning: Dojo/Determination", jp: "十二日目・午前・道場/その決意"},
          {
            h: [
              {id: "桜12-1", eng: "Resolution/Noble fool", jp: "覚悟/尊い愚者"},
              {id: "桜12-2", eng: "Resolution/Blame for persistence", jp: "覚悟/不断の咎"},
            ],
          },
          {id: "桜12-3", eng: "12th Day: Morning: Dojo/Training start", jp: "十二日目・午前・道場/修行開始"},
          {id: "桜12-7", eng: "Intermission/Sisters (V)", jp: "幕間/姉妹（Ⅴ）"},
          {id: "桜12-8", eng: "12th Day: Noon: Dojo/Blank memory", jp: "十二日目・正午・道場/空白"},
          {id: "桜12-9", eng: "12th Day: Shopping district/Lorelei", jp: "十二日目・商店街/ローレライ"},
          {id: "桜12-10", eng: "12th Day: Dinner-Night/Memory lost", jp: "十二日目・夕食〜夜/メモリー・ロスト"},
          {id: "桜12-11", eng: "12th Day: Night: Patrol/Shadow swallowing the town", jp: "十二日目・夜・巡回/街食影"},
          {id: "桜12-12", eng: "Intermission/Chess", jp: "2"},
          {
            h: [
              {id: "桜12-13", eng: "12th Day: Return home-Bedtime/Void", jp: "十二日目・帰宅〜就寝/ヴォイド"},
              {id: "桜12-113", eng: "12th Day: Return home-Bedtime/Mind’s Thirst", jp: "十二日目・帰宅～就寝/心の渇き"},
            ],
          },
          {id: "桜12-14", eng: "Intermission/Nightmare, awakening", jp: "幕間/悪夢→目覚め"},
        ],
      }, {
        section: "桜13", v: [
          {
            id: "桜13-8",
            eng: "13th Day: Awakening-Morning/Sakura’s absence-Finding",
            jp: "十三日目・起床〜朝/桜の不在〜発見",
          },
          {id: "桜13-9", eng: "13th Day: Morning/Check on Sakura", jp: "十三日目・午前/桜の看病"},
          {
            id: "桜13-10",
            eng: "13th Day: Morning: Living room/Distant twilight (II)",
            jp: "十三日目・午前・居間/遠い夕暮れ（Ⅱ）",
          },
          {id: "桜13-11", eng: "Intermission/Misery", jp: "幕間/ミザリー"},
          {id: "桜13-0", eng: "13th Day: Morning: My room/Assassin intrusion", jp: "十三日目・午前・自室/アサシン侵入"},
          {
            h: [
              {
                id: "桜13-1",
                eng: "13th Day: -Matou household/Confrontation with Zouken-the shadow’s true identity",
                jp: "十三日目・〜間桐邸/臓硯と対峙〜影の正体",
              },
              {id: "桜13-2", eng: "13th Day: Noon-Dinner/Horror show", jp: "十三日目・昼〜夕食/ホラーショウ"},
            ],
          },
          {
            h: [
              {id: "桜13-12", eng: "13th Day: Return home: Entrance/Gift", jp: "十三日目・帰宅・玄関/ギフト"},
              {id: "桜13-15", eng: "Tiger Dojo 34", jp: "タイガー道場34"},
            ],
          },
          {
            id: "桜13-13",
            eng: "13th Day: Afternoon: Sakura’s guest room/Once it’s spring",
            jp: "十三日目・午後・桜の客間/春になったら",
          },
          {id: "桜13-3", eng: "13th Day: Night/Decision time", jp: "十三日目・夜/決断の刻"},
          {
            h: [
              {id: "桜13-5", eng: "13th Day/Happy end", jp: "十三日目/ハッピーエンド"},
              {id: "桜13-6", eng: "13th Day: Night/Beautiful aria", jp: "十三日目・夜/美しいアリア"},
            ],
          },
          {
            h: [
              {id: "桜13-14", eng: "Intermission/Matou Sakura (IV)", jp: "幕間/間桐桜（Ⅳ）"},
              {id: "桜13-16", eng: "Tiger Dojo 35", jp: "タイガー道場35"},
            ],
          },
        ],
      }, {
        section: "桜14", v: [
          {id: "桜14-0", eng: "14th Day: Awakening-To the church/A ray of hope", jp: "十四日目・起床〜教会へ/一縷の希望"},
          {id: "桜14-2", eng: "Intermission/Foolish", jp: "幕間/フーリッシュ"},
          {id: "桜14-8", eng: "Intermission/Trash", jp: "幕間/トラッシュ"},
          {id: "桜14-9", eng: "14th Day: Church/What is hidden in the Holy Grail", jp: "十四日目・教会/聖杯に潜むモノ"},
          {
            id: "桜14-1",
            eng: "14th Day: Return home-Search-To the Matou household/Matou household murder case",
            jp: "十四日目・帰宅〜探索〜間桐邸へ/間桐邸殺人事件",
          },
          {
            h: [
              {id: "桜14-10", eng: "Intermission/Last piece", jp: "幕間/ラストピース"},
              {id: "桜14-110", eng: "Intermission/Last piece", jp: ""},
            ],
          },
          {id: "桜14-3", eng: "14th Day: Matou household: Sakura’s room/Choice", jp: "十四日目・間桐邸・桜の部屋/選択肢"},
          {
            h: [
              {id: "桜14-4", eng: "Action/Best", jp: "行動/最善"},
              {id: "桜14-5", eng: "Action/Worst", jp: "行動/最悪"},
            ],
          },
          {id: "桜14-6", eng: "Intermission/Sacrilege-Sisters (VI)", jp: "幕間/サクラリッジ〜姉妹（Ⅵ）"},
          {id: "桜14-11", eng: "14th Day/Finale", jp: "十四日目/フィナーレ"},
        ],
      }, {
        section: "桜15", v: [
          {id: "桜15-0", eng: "15th Day/Finale, replay", jp: "十五日目/フィナーレ・リプレイ"},
          {
            h: [
              {
                id: "桜15-1",
                eng: "15th Day: Church-Outside church/Resume battle. Kotomine’s help.",
                jp: "十五日目・教会〜教会外/戦闘続行。言峰の協力を、",
              },
              {id: "桜15-2", eng: "15th Day/Dead fin", jp: "十五日目/デッド・フィン"},
            ],
          },
          {
            h: [
              {id: "桜15-22", eng: "15th Day: To the forest/Duo", jp: "十五日目・森へ/デュオ"},
              {id: "桜15-3", eng: "15th Day: Einzbern castle/Death penalty", jp: "十五日目・アインツベルン城/デス・ペナルティ"},
              {id: "桜15-27", eng: "Tiger Dojo 36", jp: "タイガー道場36"},
            ],
          },
          {
            h: [
              {id: "桜15-23", eng: "Intermission/Succeed from deep", jp: "幕間/サクスィード・フロム・ディープ"},
              {id: "桜15-28", eng: "Tiger Dojo 37", jp: "タイガー道場37"},
            ],
          },
          {id: "桜15-4", eng: "Einzbern castle/Illya found", jp: "アインツベルン城/イリヤ発見"},
          {
            h: [
              {id: "桜15-5", eng: "Action/Emotion", jp: "行動/感情"},
              {id: "桜15-6", eng: "Action/Emotion", jp: "行動/感情"},
              {id: "桜15-7", eng: "Action/Emotion", jp: "行動/感情"},
            ],
          },
          {id: "桜15-8", eng: "Escape start-To the forest/Epilogue", jp: "逃走開始〜森へ/エピローグ"},
          {id: "桜15-9", eng: "Battle in the forest: First half/over load", jp: "森の攻防・前半/over load"},
          {
            id: "桜15-10",
            eng: "Battle in the forest: Second half/Nine Bullet Revolver",
            jp: "森の攻防・後半/Nine Bullet Revolver",
          },
          {id: "桜15-11", eng: "15th Day: Einzbern forest/Death of a saint", jp: "十五日目・アインツベルンの森/聖者の死"},
          {
            id: "桜15-12",
            eng: "15th Day: Return home-Emiya living room/Truth-Antihero Angra Mainyu",
            jp: "十五日目・帰還〜衛宮邸居間/真相〜反英雄アンリマユ",
          },
          {id: "桜15-24", eng: "15th Day: Sakura’s shadow/Separation", jp: "十五日目・桜の影/決別"},
          {
            id: "桜15-25",
            eng: "15th Day: Night: Shed/Record of the Great Holy Grail",
            jp: "十五日目・夜・土蔵/大聖杯の記録",
          },
          {
            id: "桜15-13",
            eng: "15th Day: Preparation for battle/Confrontation with Rider",
            jp: "十五日目・決戦準備/ライダーとの対峙",
          },
          {
            h: [
              {id: "桜15-16", eng: "Choice/Rider’s question", jp: "選択肢/ライダーの問い"},
              {id: "桜15-14", eng: "15th Day: Night/Rider leaves", jp: "十五日目・夜/ライダー去る"},
              {id: "桜15-15", eng: "15th Day: Night/Rider leaves", jp: "十五日目・夜/ライダー去る"},
            ],
          },
          {
            h: [
              {id: "桜15-17", eng: "15th Day: Night/Rider leaves", jp: "十五日目・夜/ライダー去る"},
              {id: "桜15-18", eng: "15th Day: Night/Rider leaves", jp: "十五日目・夜/ライダー去る"},
              {id: "桜15-19", eng: "15th Day: Preparation for battle/Tactics", jp: "十五日目・決戦準備/タクティクス"},
            ],
          },
          {
            h: [
              {id: "桜15-20", eng: "16th Day: VS Saber/Sparks liner high", jp: "十六日目・ＶＳセイバー/スパークスライナーハイ"},
              {id: "桜15-26", eng: "15th Day: Night/Goodbye, thank you", jp: "十五日目・夜/サヨナラ、アリガトウ"},
            ],
          },
          {id: "桜15-29", eng: "Tiger Dojo 38", jp: "タイガー道場38"},
        ],
      }, {
        section: "桜16", v: [
          {id: "桜16-0", eng: "Intermission/Zouken’s end", jp: "幕間/臓硯の最期"},
          {id: "桜16-14", eng: "Last day/To the underground cave", jp: "最終日/地下洞穴へ"},
          {id: "桜16-15", eng: "Last day: Inside the cave/The strongest Servant", jp: "最終日・中空洞/最強のサーヴァント"},
          {id: "桜16-16", eng: "Intermission/Country of the dark queen", jp: "幕間/黒き王女の国"},
          {id: "桜16-1", eng: "VS Saber/Burst", jp: "ＶＳセイバー/バースト"},
          {
            h: [
              {id: "桜16-3", eng: "VS Saber/Burst out", jp: "ＶＳセイバー/バースト、アウト"},
              {id: "桜16-4", eng: "VS Saber/Crazy train II", jp: "ＶＳセイバー/クレイジー・トレインⅡ"},
              {id: "桜16-2", eng: "Last day: Inside the cavern/Compassion", jp: "最終日・中空洞/慈悲"},
            ],
          },
          {
            h: [
              {id: "桜16-5", eng: "Oath/", jp: "誓い/"},
              {id: "桜16-23", eng: "Tiger Dojo 39", jp: "タイガー道場39"},
            ],
          },
          {
            h: [
              {id: "桜16-6", eng: "I’ll forget about you", jp: "───君を忘れる"},
              {id: "桜16-7", eng: "Last day: Cavern/Femme fatale", jp: "最終日・大空洞/ファム・ファタール"},
            ],
          },
          {
            h: [
              {id: "桜16-17", eng: "Intermission/Gem Sword Zelretch", jp: "幕間/宝石剣ゼルレッチ"},
              {id: "桜16-24", eng: "Tiger Dojo 40", jp: "タイガー道場40"},
            ],
          },
          {id: "桜16-18", eng: "Intermission/Sisters (VII)", jp: "幕間/姉妹（Ⅶ）"},
          {id: "桜16-19", eng: "Conclusion/To the cavern", jp: "終局/大空洞へ"},
          {id: "桜16-20", eng: "Conclusion/Liberation", jp: "終局/解放"},
          {id: "桜16-8", eng: "Conclusion/To Angra Mainyu", jp: "終局/アンリマユへ"},
          {
            h: [
              {id: "桜16-11", eng: "Conclusion/All evils of the world", jp: "終局/この世全ての悪"},
              {id: "桜16-9", eng: "Conclusion/Conclusion", jp: "終局/終局"},
            ],
          },
          {id: "桜16-21", eng: "Intermission/At the end of the dearest wish", jp: "幕間/悲願の果て"},
          {id: "桜16-22", eng: "Conclusion/All the good in this life", jp: "終局/この生、全ての善"},
          {id: "桜16-10", eng: "Last projection", jp: "最後の投影"},
          {
            h: [
              {id: "桜16-12", eng: "Conclusion/Conclusion", jp: "終局/終局"},
              {id: "桜16-13", eng: "Conclusion/At the end of a miracle", jp: "終局/奇跡の果て"},
            ],
          },
        ],
      },
      ],
    },
    ],
  },
  ],
}
